/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ActionResponseDetail {
  /** @format int32 */
  code?: number | null;
  detail?: string | null;
  source?: ObjectSource;
  title?: string | null;
}

export enum ActorType {
  System = 'system',
  User = 'user',
  Machine = 'machine',
}

export interface AddressInformation {
  street_address2?: string | null;
  /**
   * Legal City of the Operator.
   * Ex: "Miami"
   */
  city?: string | null;
  /**
   * Legal Country of the Operator.
   * Ex: "USA"
   */
  country?: string | null;
  /**
   * Legal City of the Operator.
   * Ex: "FL"
   */
  state?: string | null;
  street_address?: string | null;
  /**
   * Legal Zipcode of the Operator.
   * Ex: "33023"
   */
  zipcode?: string | null;
}

/** ATM view for affiliate users. */
export interface AffiliateAtmListView {
  /** @format int32 */
  barcode_scanner_status?: number | null;
  /** @format int32 */
  bill_acceptor_status?: number | null;
  /** @format int32 */
  bill_dispenser_status?: number | null;
  /**
   * Total quantity of all bills for all denominations.
   * @format int32
   */
  bill_total?: number | null;
  /** @format int32 */
  bulk_note_recycler_status?: number | null;
  /** @format int32 */
  card_reader_status?: number | null;
  /** This is a list of enabled coins for atm. */
  enabled_coin_ids?: string[] | null;
  /** This is a list of enabled precious metals for atm. */
  enabled_precious_metal_ids?: string[] | null;
  epp_kcv?: string | null;
  /** @format int32 */
  epp_key_index?: number | null;
  epp_key_mode?: EppKeyModeEnum;
  epp_key_status?: EppKeyStatusEnum;
  /**
   * Resources made taggable after they already exist get a new global id
   * to ensure uniqueness within the 'taggable' table. Resources will continue
   * to support their existing id property.
   * @format uuid
   */
  global_id?: string;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  imaging_device_status?: number | null;
  /**
   * The datetime object for the last machine restart,
   * or null if no restart can be found.
   * Use this value if you want to filter based on it, but use
   * the humanized version AthenaService.Web.ClientModels.v2.AffiliateDashboard.Atms.AffiliateAtmListView.LastRestartHumanized
   * for display in the UI.
   * @format date-time
   */
  last_restart?: string | null;
  last_restart_humanized?: string | null;
  /**
   * The datetime object for the last machine heartbeat,
   * or null if no heartbeat can be found.
   * Use this value if you want to filter based on it, but use
   * the humanized version AthenaService.Web.ClientModels.v2.AffiliateDashboard.Atms.AffiliateAtmListView.LastRobotHeartbeatCreatedAtHumanized
   * for display in the UI.
   * @format date-time
   */
  last_robot_heartbeat_created_at?: string | null;
  /**
   * The humanized text value for the last heartbeat created AthenaService.Web.ClientModels.v2.AffiliateDashboard.Atms.AffiliateAtmListView.LastRobotHeartbeatCreatedAt
   * This is a computed field so it cannot be filtered on. Filter on the datetime version of this value instead.
   */
  last_robot_heartbeat_created_at_humanized?: string | null;
  /** @format date-time */
  last_sale_created_at?: string | null;
  /**
   * The humanized text value for the last sale AthenaService.Web.ClientModels.v2.AffiliateDashboard.Atms.AffiliateAtmListView.LastSaleCreatedAt
   * This is a computed field so it cannot be filtered on. Filter on the datetime version of this value instead.
   */
  last_sale_created_at_humanized?: string | null;
  /** Live denomination breakdown backing AthenaService.Web.ClientModels.v2.AffiliateDashboard.Atms.AffiliateAtmListView.LiveCash. */
  live_bill_denominations?: Record<string, number>;
  /**
   * Live total quantity of all bills for all denominations, backing AthenaService.Web.ClientModels.v2.AffiliateDashboard.Atms.AffiliateAtmListView.LiveCash.
   * @format int32
   */
  live_bill_total?: number | null;
  /**
   * Live cash currently in the box, derived from the box-clear boundary.
   * Distinct from the heartbeat-reported AthenaService.Web.ClientModels.v2.AffiliateDashboard.Atms.AffiliateAtmListView.BillTotal.
   * @format double
   */
  live_cash?: number | null;
  location?: NonceLocationShortView;
  /** @format int32 */
  location_id?: number | null;
  machine_status?: MachineStatus;
  /** Friendly human name operators can pick for an ATM. */
  name?: string | null;
  /** @format int32 */
  phidget_board_status?: number | null;
  /** @format int32 */
  printer_status?: number | null;
  /**
   * A unique identifier physically present on the hardware of the machine.
   * Uniqueness is only guaranteed per manufacturer (genmega, kiosk, etc.)
   * Installers input this into the system during QA of a new machine. It is possible for
   * them to enter an incorrect value (twice) which can be annoying and requires manually fixing.
   */
  serial?: string | null;
  /**
   * A unique location string concatenated from address fields. (See this code for source (I think).
   * https://github.com/bitstopco/locations_service/blob/5083f20f360e268c568e86dfb4513bb21f113b95/locations_service.Web/Models/Location.cs#L43)
   */
  slug?: string | null;
  /** List of tag ids associated to this resource. */
  tag_ids?: string[] | null;
}

/**
 * Common enumerable atm response that is intended to be used with any type of
 * atm projection.
 */
export interface AffiliateAtmListViewAtmActionResponse {
  correlation_id?: string | null;
  /** ATM view for affiliate users. */
  data?: AffiliateAtmListView;
  /** Schema for the included property of atm action responses. */
  included?: AtmIncluded;
}

/**
 * Common enumerable atm response that is intended to be used with any type of
 * atm projection.
 */
export interface AffiliateAtmListViewEnumerableAtmActionResponse {
  correlation_id?: string | null;
  data?: AffiliateAtmListView[] | null;
  /** Schema for the included property of atm action responses. */
  included?: AtmIncluded;
  meta?: AffiliateAtmListViewPaginatableResponseMetadata;
}

export interface AffiliateAtmListViewExportFilter {
  operands?: AffiliateAtmListViewExportFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface AffiliateAtmListViewExportFilterableRequest {
  filter?: AffiliateAtmListViewExportFilter;
  search_text?: string | null;
}

export interface AffiliateAtmListViewFilter {
  operands?: AffiliateAtmListViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface AffiliateAtmListViewPaginatableRequest {
  filter?: AffiliateAtmListViewFilter;
  pagination?: AffiliateAtmListViewPagination;
  search_text?: string | null;
}

export interface AffiliateAtmListViewPaginatableResponseMetadata {
  filter?: AffiliateAtmListViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface AffiliateAtmListViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

/** Use this class to represent a summary stats of the asset. */
export interface AssetStatsView {
  asset?: DispenseAssetView;
  /** AssetId: Represents Asset by Sale. */
  asset_id?: string | null;
  /**
   * Total Crypto: Aggregate amount for all the matching transactions.
   * @format double
   */
  total_crypto?: number;
  /**
   * Total Fees: Aggregate FIAT amount in Fees for all the matching transactions.
   * @format double
   */
  total_fees?: number;
  /**
   * Total Sales: Aggregate FIAT amount for all the matching transactions.
   * @format double
   */
  total_sales?: number;
  /**
   * Total Fees: Aggregate enviando amount for all the matching transactions.
   * @format double
   */
  total_sent?: number;
  /**
   * Total Transactions: Count of all matching transactions.
   * @format int32
   */
  total_transactions?: number;
}

export interface AtmFilter {
  operands?: AtmFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

/** Schema for the included property of atm action responses. */
export interface AtmIncluded {
  coins?: CoinView[] | null;
  precious_metals?: PreciousMetalView[] | null;
  /** Tags associated to this atm. */
  tags?: TagView[] | null;
}

export interface AtmLocationDataView {
  address2?: string | null;
  /** @format int32 */
  atm_id?: number;
  city?: string | null;
  country?: string | null;
  full_address?: string | null;
  hours?: string[] | null;
  /** @format int32 */
  id?: number;
  /** @format double */
  latitude?: number;
  local_time_zone?: string | null;
  /** @format double */
  longitude?: number;
  map_url?: string | null;
  name?: string | null;
  /** @format int32 */
  operator_id?: number;
  pick_up_id?: string | null;
  place_id?: string | null;
  slug?: string | null;
  state?: string | null;
  street_address?: string | null;
  /** @format date-time */
  updated_at?: string;
  zipcode?: string | null;
}

export interface AtmLocationView {
  /** @format int32 */
  atm_id?: number;
  /** @format date-time */
  date_time_installed?: string;
  /** @format date-time */
  date_time_uninstalled?: string | null;
}

export interface AtmPaginatableRequest {
  filter?: AtmFilter;
  pagination?: AtmPagination;
  search_text?: string | null;
}

export interface AtmPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface AtmProductStateResponse {
  products?: ProductState[] | null;
}

export interface AtmStats {
  /** @format int32 */
  atm_id?: number | null;
  atm_name?: string | null;
  /** @format double */
  total_btc?: number;
  /** @format int32 */
  total_count?: number;
  /** @format float */
  total_env?: number;
  /** @format double */
  total_fees?: number;
  /** @format float */
  total_sales?: number;
}

export interface AtmStatsICollectionIActionDataResponse {
  correlation_id?: string | null;
  data?: AtmStats[] | null;
}

export interface AtmStatusSummary {
  /**
   * Total Machines with status not Bitstop.Btm.Hardware.MachineStatus.Ok
   * @format int32
   */
  total_down?: number;
  /**
   * The total number of machines belonging to that operator.
   * @format int32
   */
  total_machines?: number;
  /**
   * Total Machines with status Bitstop.Btm.Hardware.MachineStatus.Ok
   * @format int32
   */
  total_online?: number;
}

export interface AtmTransferRequest {
  /**
   * Id of the Atm that is being transferred.
   * @format int32
   */
  atm_id?: number;
  /**
   * Id of the operator the Atm is being transferred to.
   * @format int32
   * @min 1
   * @max 2147483647
   */
  destination_operator_id: number;
  /** Whether the Atm is being transferred with locations. */
  is_location_transferring?: boolean;
  /**
   * Id of the operator the Atm is being transferred from.
   * @format int32
   */
  origin_operator_id?: number;
}

export interface AtmTransferView {
  /** @format int32 */
  atm_id?: number;
  atm_location_id?: string | null;
  /** @format int32 */
  destination_operator_id?: number;
  is_location_transferring?: boolean;
  operator_location_id?: string | null;
  /** @format int32 */
  origin_operator_id?: number;
}

export interface AuditTrailEntryView {
  /** @format date-time */
  change_occurred_at?: string;
  change_queue_item_id?: string | null;
  change_type?: string | null;
  /** @format date-time */
  created_at?: string;
  explanation?: string | null;
  id?: string | null;
  /** @format int32 */
  location_id?: number;
  location_name?: string | null;
  pin_me_to_response_code?: string | null;
  request_type?: string | null;
}

export interface AuditTrailEntryViewFilter {
  operands?: AuditTrailEntryViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface AuditTrailEntryViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: AuditTrailEntryView[] | null;
  meta?: AuditTrailEntryViewPaginatableResponseMetadata;
}

export interface AuditTrailEntryViewPaginatableRequest {
  filter?: AuditTrailEntryViewFilter;
  pagination?: AuditTrailEntryViewPagination;
  search_text?: string | null;
}

export interface AuditTrailEntryViewPaginatableResponseMetadata {
  filter?: AuditTrailEntryViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface AuditTrailEntryViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface Auth0LogEventRequest {
  data?: any;
  /** @minLength 1 */
  log_id: string;
}

export interface BillNoteListView {
  asset_id?: string | null;
  asset_type_id?: string | null;
  /** @format date-time */
  created_at?: string;
  display_name?: string | null;
  id?: string | null;
  is_active?: boolean;
  /** @format date-time */
  last_updated_at?: string;
  metadata?: any;
  /** @format int32 */
  unit?: number;
  variant?: string | null;
}

export interface BillNoteListViewFilter {
  operands?: BillNoteListViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface BillNoteListViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: BillNoteListView[] | null;
  meta?: BillNoteListViewPaginatableResponseMetadata;
}

export interface BillNoteListViewPaginatableRequest {
  filter?: BillNoteListViewFilter;
  pagination?: BillNoteListViewPagination;
  search_text?: string | null;
}

export interface BillNoteListViewPaginatableResponseMetadata {
  filter?: BillNoteListViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface BillNoteListViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

/** Bills from an ATM */
export interface Bills {
  /**
   * Fifty bill amount
   * @format int32
   */
  fifty?: number;
  /**
   * Five bill amount
   * @format int32
   */
  five?: number;
  /**
   * Hundred bill amount
   * @format int32
   */
  hundred?: number;
  /**
   * One bill amount
   * @format int32
   */
  one?: number;
  /**
   * Ten bill amount
   * @format int32
   */
  ten?: number;
  /**
   * Twenty bill amount
   * @format int32
   */
  twenty?: number;
  /**
   * Two bill amount
   * @format int32
   */
  two?: number;
}

export enum BoxClearAction {
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted',
  Confirmed = 'confirmed',
}

export interface BoxClearAtmView {
  /** @format int32 */
  location_id?: number | null;
  name?: string | null;
  pickup_id?: string | null;
}

export interface BoxClearAuditLogView {
  action?: BoxClearAction;
  actor_id?: string | null;
  actor_type?: ActorType;
  /** @format int32 */
  atm_id?: number;
  /** @format int32 */
  box_clear_id?: number;
  changes?: any;
  /** @format date-time */
  created_at?: string;
  id?: string | null;
  new_state?: any;
  previous_state?: any;
  reason?: string | null;
}

export interface BoxClearAuditLogViewFilter {
  operands?: BoxClearAuditLogViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface BoxClearAuditLogViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: BoxClearAuditLogView[] | null;
  meta?: BoxClearAuditLogViewPaginatableResponseMetadata;
}

export interface BoxClearAuditLogViewPaginatableRequest {
  filter?: BoxClearAuditLogViewFilter;
  pagination?: BoxClearAuditLogViewPagination;
  search_text?: string | null;
}

export interface BoxClearAuditLogViewPaginatableResponseMetadata {
  filter?: BoxClearAuditLogViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface BoxClearAuditLogViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface BoxClearDetailView {
  address2?: string | null;
  atm?: BoxClearAtmView;
  /** @format int32 */
  atm_id?: number;
  cash_clear_id?: string | null;
  city?: string | null;
  country?: string | null;
  /** @format date-time */
  created_at?: string;
  currency?: string | null;
  /** @format int32 */
  fifty?: number | null;
  /** @format int32 */
  five?: number | null;
  full_address?: string | null;
  has_bills_breakdown?: boolean;
  /** @format int32 */
  hundred?: number | null;
  /** @format int32 */
  id?: number;
  /** @format date-time */
  local_created_at?: string;
  local_time_zone?: string | null;
  /** @format int32 */
  location_id?: number | null;
  notes?: BoxClearNoteView[] | null;
  /** @format int32 */
  one?: number | null;
  provenance?: BoxClearProvenance;
  state?: string | null;
  status?: BoxClearStatus;
  street_address?: string | null;
  /** @format int32 */
  ten?: number | null;
  /** @format int32 */
  total_amount_of_bills?: number | null;
  /** @format int32 */
  total_worth_of_bills?: number;
  /** @format int32 */
  transaction_count?: number;
  /** @format double */
  transaction_total_amount?: number;
  transactions?: BoxClearTransactionView[] | null;
  /** @format int32 */
  twenty?: number | null;
  /** @format int32 */
  two?: number | null;
  zipcode?: string | null;
}

export interface BoxClearDetailViewIActionDataResponse {
  correlation_id?: string | null;
  data?: BoxClearDetailView;
}

export interface BoxClearNoteView {
  author?: string | null;
  body?: string | null;
  /** @format int32 */
  box_clear_id?: number;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  id?: string | null;
}

export enum BoxClearProvenance {
  MachineReported = 'machine_reported',
  HeartbeatInferred = 'heartbeat_inferred',
  Manual = 'manual',
}

export interface BoxClearReconciliationView {
  atm?: BoxClearAtmView;
  /** @format int32 */
  atm_id?: number;
  cash_clear_id?: string | null;
  /** @format date-time */
  created_at?: string;
  currency?: string | null;
  has_bills_breakdown?: boolean;
  /** @format int32 */
  id?: number;
  /** @format date-time */
  local_created_at?: string;
  local_time_zone?: string | null;
  /** @format int32 */
  location_id?: number | null;
  provenance?: BoxClearProvenance;
  status?: BoxClearStatus;
  /** @format int32 */
  total_amount_of_bills?: number | null;
  /** @format int32 */
  total_worth_of_bills?: number;
  /** @format int32 */
  transaction_count?: number;
}

export interface BoxClearReconciliationViewFilter {
  operands?: BoxClearReconciliationViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface BoxClearReconciliationViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: BoxClearReconciliationView[] | null;
  meta?: BoxClearReconciliationViewPaginatableResponseMetadata;
}

export interface BoxClearReconciliationViewPaginatableRequest {
  filter?: BoxClearReconciliationViewFilter;
  pagination?: BoxClearReconciliationViewPagination;
  search_text?: string | null;
}

export interface BoxClearReconciliationViewPaginatableResponseMetadata {
  filter?: BoxClearReconciliationViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface BoxClearReconciliationViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export enum BoxClearStatus {
  Provisional = 'provisional',
  Confirmed = 'confirmed',
  Invalidated = 'invalidated',
  // DEV-2404: taken from `npm run types` against the testnet swagger, which already publishes these
  // values; the rest of that regeneration was left out to keep unrelated drift out of this PR.
  Deposited = 'deposited',
  DepositedOver = 'deposited_over',
  DepositedUnder = 'deposited_under',
  Voided = 'voided',
}

export interface BoxClearTransactionView {
  /** Coin type of the sale (e.g. BTC, ETH) for rendering the transaction type column. */
  coin_type?: string | null;
  /** @format date-time */
  created_at?: string;
  /** @format int32 */
  customer_id?: number;
  /** @format int32 */
  fifty?: number;
  /** @format int32 */
  five?: number;
  /** @format int32 */
  hundred?: number;
  /** @format int32 */
  id?: number;
  /** @format double */
  inserted?: number;
  /** @format int32 */
  one?: number;
  /** @format int32 */
  ten?: number;
  /** @format int32 */
  twenty?: number;
  /** @format int32 */
  two?: number;
  /**
   * String identifier the transaction single-view endpoint
   * (`GET v2/transaction/{uuid}`) resolves by. The dashboard should link
   * the row to this value, not the numeric AthenaService.Web.ClientModels.v2.NonceDashboard.Atms.BoxClearTransactionView.Id.
   */
  uuid?: string | null;
}

export interface BoxClearView {
  address2?: string | null;
  atm?: BoxClearAtmView;
  /** @format int32 */
  atm_id?: number;
  cash_clear_id?: string | null;
  city?: string | null;
  country?: string | null;
  /** @format date-time */
  created_at?: string;
  currency?: string | null;
  /** @format int32 */
  fifty?: number | null;
  /** @format int32 */
  five?: number | null;
  full_address?: string | null;
  has_bills_breakdown?: boolean;
  /** @format int32 */
  hundred?: number | null;
  /** @format int32 */
  id?: number;
  /** @format date-time */
  local_created_at?: string;
  local_time_zone?: string | null;
  location?: NonceLocationShortView;
  /** @format int32 */
  location_id?: number | null;
  /** @format int32 */
  one?: number | null;
  provenance?: BoxClearProvenance;
  state?: string | null;
  status?: BoxClearStatus;
  street_address?: string | null;
  /** @format int32 */
  ten?: number | null;
  /** @format int32 */
  total_amount_of_bills?: number | null;
  /** @format int32 */
  total_worth_of_bills?: number;
  /** @format int32 */
  twenty?: number | null;
  /** @format int32 */
  two?: number | null;
  zipcode?: string | null;
}

export interface BoxClearViewExportFilter {
  operands?: BoxClearViewExportFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface BoxClearViewExportFilterableRequest {
  filter?: BoxClearViewExportFilter;
  search_text?: string | null;
}

export interface BoxClearViewFilter {
  operands?: BoxClearViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface BoxClearViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: BoxClearView[] | null;
  meta?: BoxClearViewPaginatableResponseMetadata;
}

export interface BoxClearViewPaginatableRequest {
  filter?: BoxClearViewFilter;
  pagination: BoxClearViewPagination;
  search_text?: string | null;
}

export interface BoxClearViewPaginatableResponseMetadata {
  filter?: BoxClearViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface BoxClearViewPagination {
  /**
   * @format int32
   * @min 1
   */
  current_page?: number;
  /**
   * @format int32
   * @min 1
   * @max 1000
   */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface CaseListView {
  assigned_user_id?: string | null;
  /** @format int32 */
  atm_id?: number;
  auto_created?: boolean;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  description?: string | null;
  /** @format int32 */
  display_id?: number;
  id?: string | null;
  issue_types?: string[] | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  /**
   * Distinct list of DisplayIds for the service tickets linked to this case.
   * Lets Ops users filter/search cases by a specific linked service ticket.
   * Empty when the case has no linked service tickets.
   */
  linked_service_ticket_ids?: number[] | null;
  location?: CaseLocationView;
  /** @format int32 */
  location_id?: number | null;
  location_tag_ids?: string[] | null;
  location_tags?: TagView[] | null;
  merchant_id?: string | null;
  priority?: CasePriority;
  resolution_summary?: string | null;
  /** @format date-time */
  resolved_at?: string | null;
  status?: CaseStatus;
  /**
   * Flattened list of distinct task type names from all tasks on the service
   * tickets linked to this case (e.g., "HDD Swap", "Lock Change", "CMOS Battery").
   * Lets Ops users see the work associated with a case without opening its tickets.
   * Empty when the case has no service tickets with tasks that have a task type.
   */
  task_type_names?: string[] | null;
  type?: CaseType;
}

export interface CaseListViewFilter {
  operands?: CaseListViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface CaseListViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: CaseListView[] | null;
  meta?: CaseListViewPaginatableResponseMetadata;
}

export interface CaseListViewPaginatableRequest {
  filter?: CaseListViewFilter;
  pagination?: CaseListViewPagination;
  search_text?: string | null;
}

export interface CaseListViewPaginatableResponseMetadata {
  filter?: CaseListViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface CaseListViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface CaseLocationView {
  address2?: string | null;
  city?: string | null;
  full_address?: string | null;
  /** @format int32 */
  location_id?: number;
  location_name?: string | null;
  state?: string | null;
  street_address?: string | null;
  zip_code?: string | null;
}

export interface CaseNoteAttachmentView {
  /** @format date-time */
  created_at?: string;
  file_name?: string | null;
  id?: string | null;
}

export enum CaseNoteType {
  Internal = 'internal',
  FieldReport = 'field_report',
  OpsNote = 'ops_note',
}

export interface CaseNoteView {
  attachments?: CaseNoteAttachmentView[] | null;
  author?: string | null;
  body?: string | null;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  id?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  type?: CaseNoteType;
}

export enum CasePriority {
  Low = 'low',
  Medium = 'medium',
  High = 'high',
  Critical = 'critical',
}

export interface CaseStatsView {
  /** @format int32 */
  new_cases_last24_hours?: number;
  /** @format double */
  closed_cases_percentage_change?: number;
  /** @format double */
  new_cases_percentage_change?: number;
  /** @format double */
  open_cases_percentage_change?: number;
  /** @format int32 */
  total_closed_cases?: number;
  /** @format int32 */
  total_open_cases?: number;
}

export interface CaseStatsViewActionResponse {
  correlation_id?: string | null;
  data?: CaseStatsView;
  /** @deprecated */
  dictionaries?: any;
  errors?: ActionResponseDetail[] | null;
  included?: any;
  meta?: any;
  warnings?: ActionResponseDetail[] | null;
}

export enum CaseStatus {
  InProgress = 'in_progress',
  Resolved = 'resolved',
  Closed = 'closed',
}

export enum CaseType {
  Machine = 'machine',
  Software = 'software',
  Customer = 'customer',
  Payment = 'payment',
  Merchant = 'merchant',
  Other = 'other',
}

export interface CaseView {
  assigned_user_id?: string | null;
  /** @format int32 */
  atm_id?: number;
  auto_created?: boolean;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  description?: string | null;
  /** @format int32 */
  display_id?: number;
  full_address?: string | null;
  id?: string | null;
  issue_types?: string[] | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  /** @format double */
  latitude?: number | null;
  /** @format int32 */
  location_id?: number | null;
  /** @format double */
  longitude?: number | null;
  merchant_classification?: MerchantClassificationEnum;
  merchant_email?: string | null;
  merchant_first_name?: string | null;
  merchant_id?: string | null;
  merchant_last_name?: string | null;
  merchant_phone_number?: string | null;
  notes?: CaseNoteView[] | null;
  priority?: CasePriority;
  resolution_summary?: string | null;
  /** @format date-time */
  resolved_at?: string | null;
  status?: CaseStatus;
  /**
   * Flattened list of distinct task type names from all tasks on the service
   * tickets linked to this case (e.g., "HDD Swap", "Lock Change", "CMOS Battery").
   * Empty when the case has no service tickets with tasks that have a task type.
   */
  task_type_names?: string[] | null;
  type?: CaseType;
}

export interface CaseViewActionResponse {
  correlation_id?: string | null;
  data?: CaseView;
  /** @deprecated */
  dictionaries?: any;
  errors?: ActionResponseDetail[] | null;
  included?: any;
  meta?: any;
  warnings?: ActionResponseDetail[] | null;
}

export interface CaseViewExportFilter {
  operands?: CaseViewExportFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface CaseViewExportFilterableRequest {
  filter?: CaseViewExportFilter;
  search_text?: string | null;
}

export interface CashPullView {
  /**
   * Fifty notes pulled
   * @format int32
   */
  fifty?: number;
  /**
   * Five notes pulled
   * @format int32
   */
  five?: number;
  /**
   * Hundred notes pulled
   * @format int32
   */
  hundred?: number;
  /**
   * Id of the cash pull
   * @format int32
   */
  id?: number;
  /**
   * One notes pulled
   * @format int32
   */
  one?: number;
  /** Serial number of the terminal */
  serial_number?: string | null;
  /**
   * Creation date and time in UTC
   * @format date-time
   */
  server_time?: string;
  /**
   * Ten notes pulled
   * @format int32
   */
  ten?: number;
  /**
   * Id of the terminal
   * @format int32
   */
  terminal_id?: number;
  /**
   * Creation date and time in the terminal's timezone
   * @format date-time
   */
  terminal_time?: string;
  /**
   * Amount of cash by bills present at the time of cash pull
   * @format int32
   */
  total_amount_of_bills?: number;
  /**
   * The sum total value of all bills combined
   * @format int32
   */
  total_worth_of_bills?: number;
  /**
   * Twenty notes pulled
   * @format int32
   */
  twenty?: number;
  /**
   * Two notes pulled
   * @format int32
   */
  two?: number;
}

export interface CashPullViewFilter {
  operands?: CashPullViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface CashPullViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: CashPullView[] | null;
  meta?: CashPullViewPaginatableResponseMetadata;
}

export interface CashPullViewPaginatableRequest {
  filter?: CashPullViewFilter;
  pagination?: CashPullViewPagination;
  search_text?: string | null;
}

export interface CashPullViewPaginatableResponseMetadata {
  filter?: CashPullViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface CashPullViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

/** Cash report view */
export interface CashReportView {
  /** Atm name */
  atm_name?: string | null;
  /** Atm slug */
  atm_slug?: string | null;
  /** Bills from an ATM */
  bills?: Bills;
  /** Location (full address) */
  location?: string | null;
  /** Operator name */
  operator: string | null;
  /** Location's pick-up Id */
  pick_up_id?: string | null;
  /**
   * Total amount of bills
   * @format int32
   */
  total_bills?: number;
  /**
   * Total USD
   * @format double
   */
  total_usd?: number;
}

/**
 * Common enumerable atm response that is intended to be used with any type of
 * atm projection.
 */
export interface CashReportViewAtmActionResponse {
  correlation_id?: string | null;
  /** Cash report view */
  data?: CashReportView;
  /** Schema for the included property of atm action responses. */
  included?: AtmIncluded;
}

export interface CashServiceListView {
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  description?: string | null;
  id?: string | null;
  is_active?: boolean;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  name?: string | null;
}

export interface CashServiceListViewFilter {
  operands?: CashServiceListViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface CashServiceListViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: CashServiceListView[] | null;
  meta?: CashServiceListViewPaginatableResponseMetadata;
}

export interface CashServiceListViewPaginatableRequest {
  filter?: CashServiceListViewFilter;
  pagination?: CashServiceListViewPagination;
  search_text?: string | null;
}

export interface CashServiceListViewPaginatableResponseMetadata {
  filter?: CashServiceListViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface CashServiceListViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface CashVaultBranchListView {
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  description?: string | null;
  id?: string | null;
  is_active?: boolean;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  name?: string | null;
}

export interface CashVaultBranchListViewFilter {
  operands?: CashVaultBranchListViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface CashVaultBranchListViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: CashVaultBranchListView[] | null;
  meta?: CashVaultBranchListViewPaginatableResponseMetadata;
}

export interface CashVaultBranchListViewPaginatableRequest {
  filter?: CashVaultBranchListViewFilter;
  pagination?: CashVaultBranchListViewPagination;
  search_text?: string | null;
}

export interface CashVaultBranchListViewPaginatableResponseMetadata {
  filter?: CashVaultBranchListViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface CashVaultBranchListViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface CassetteDispenseLogView {
  bill_note_id?: string | null;
  cassette_id?: string | null;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  dispense_info?: any;
  /** @format date-time */
  event_timestamp?: string;
  event_type?: DispenseEventType;
  hardware_response_code?: string | null;
  id?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  /** @format int32 */
  quantity_dispensed?: number | null;
  /** @format int32 */
  quantity_rejected?: number | null;
  transaction_id?: string | null;
}

export interface CassetteDispenseLogViewFilter {
  operands?: CassetteDispenseLogViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface CassetteDispenseLogViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: CassetteDispenseLogView[] | null;
  meta?: CassetteDispenseLogViewPaginatableResponseMetadata;
}

export interface CassetteDispenseLogViewPaginatableRequest {
  filter?: CassetteDispenseLogViewFilter;
  pagination?: CassetteDispenseLogViewPagination;
  search_text?: string | null;
}

export interface CassetteDispenseLogViewPaginatableResponseMetadata {
  filter?: CassetteDispenseLogViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface CassetteDispenseLogViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export enum CassetteStatus {
  Unknown = 'unknown',
  Full = 'full',
  Low = 'low',
  Missing = 'missing',
  NotAvailable = 'not_available',
  NotSupported = 'not_supported',
}

export interface CassetteView {
  bill_note_id?: string | null;
  /** @format int32 */
  capacity?: number | null;
  /** @format int32 */
  cassette_index?: number;
  /** @format int32 */
  count?: number | null;
  /** @format date-time */
  created_at?: string;
  id?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  /** @format int32 */
  low_quantity_threshold?: number | null;
  status?: CassetteStatus;
}

export interface ChainView {
  blockchain_explorer_url?: string | null;
  id?: string | null;
  logo_url?: string | null;
  name?: string | null;
}

/** Use this class to represent a summary stats of the coin. */
export interface CoinStatsView {
  coin?: CoinView;
  /** CoinId: Represents CoinId by Sale. */
  coin_id?: string | null;
  /**
   * Total Crypto: Aggregate crypto amount for all the matching transactions.
   * @format double
   */
  total_crypto?: number;
  /**
   * Total Fees: Aggregate FIAT amount in Fees for all the matching transactions.
   * @format double
   */
  total_fees?: number;
  /**
   * Total Sales: Aggregate FIAT amount for all the matching transactions.
   * @format double
   */
  total_sales?: number;
  /**
   * Total Fees: Aggregate enviando amount for all the matching transactions.
   * @format double
   */
  total_sent?: number;
  /**
   * Total Transactions: Count of all matching transactions.
   * @format int32
   */
  total_transactions?: number;
}

export interface CoinView {
  chain?: ChainView;
  /** @format int32 */
  decimals?: number;
  id?: string | null;
  is_enabled?: boolean | null;
  is_token?: boolean | null;
  is_wallet_configured?: boolean | null;
  logo_url?: string | null;
  name?: string | null;
  price_provider?: string | null;
  ticker?: string | null;
  unicode_symbol?: string | null;
  wallet?: WalletView;
}

export interface CoinViewArrayIActionDataResponse {
  correlation_id?: string | null;
  data?: CoinView[] | null;
}

export interface CouponDetailView {
  /** @format int32 */
  assigned_customers_count?: number;
  auto_assign_on_check?: boolean;
  code?: string | null;
  /** @format int32 */
  coupon_id?: number;
  coupon_type?: CouponTypeEnum;
  /** @format date-time */
  created_at?: string;
  description?: string | null;
  discount_type?: string | null;
  /** @format double */
  discount_value?: number;
  /** @format date-time */
  expiry_date?: string | null;
  image_url?: string | null;
  /** @format date-time */
  start_date?: string | null;
  /** @format int32 */
  times_used?: number;
  title?: string | null;
  /** @format int32 */
  usage_limit?: number | null;
}

export interface CouponListView {
  /** @format int32 */
  assigned_customers_count?: number;
  auto_assign_on_check?: boolean;
  code?: string | null;
  /** @format int32 */
  coupon_id?: number;
  coupon_type?: CouponTypeEnum;
  /** @format date-time */
  created_at?: string;
  discount_type?: string | null;
  /** @format double */
  discount_value?: number;
  /** @format date-time */
  expiry_date?: string | null;
  /** @format date-time */
  start_date?: string | null;
  /** @format int32 */
  times_used?: number;
  title?: string | null;
  /** @format int32 */
  usage_limit?: number | null;
}

export interface CouponListViewFilter {
  operands?: CouponListViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface CouponListViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: CouponListView[] | null;
  meta?: CouponListViewPaginatableResponseMetadata;
}

export interface CouponListViewPaginatableRequest {
  filter?: CouponListViewFilter;
  pagination?: CouponListViewPagination;
  search_text?: string | null;
}

export interface CouponListViewPaginatableResponseMetadata {
  filter?: CouponListViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface CouponListViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export enum CouponTypeEnum {
  GlobalCoupon = 'global_coupon',
  IndividualCoupon = 'individual_coupon',
}

export interface CreateKycNoteRequest {
  /** @format int32 */
  author_id?: number | null;
  /** @maxLength 100 */
  author_name?: string | null;
  /** @minLength 1 */
  author_type: string;
  content?: string | null;
  /** @maxLength 100 */
  customer_first_name?: string | null;
  /**
   * @format int32
   * @min 0
   * @exclusiveMin true
   */
  customer_id?: number;
  /** @maxLength 100 */
  customer_last_name?: string | null;
  /**
   * @minLength 1
   * @maxLength 50
   */
  note_type: string;
  /**
   * @minLength 1
   * @maxLength 500
   */
  reason: string;
}

export interface CreateKycNoteTemplateRequest {
  allow_content?: boolean;
  content?: string | null;
  master?: boolean | null;
  /**
   * @minLength 1
   * @maxLength 50
   */
  note_type: string;
}

export interface CreateUserRequest {
  /**
   * @minLength 1
   * @maxLength 3
   */
  country_code: string;
  /**
   * @format email
   * @minLength 6
   * @maxLength 64
   */
  email: string;
  /**
   * @minLength 1
   * @maxLength 100
   */
  first_name: string;
  /**
   * @minLength 1
   * @maxLength 100
   */
  last_name: string;
  /**
   * @minLength 1
   * @maxLength 20
   */
  phone: string;
  /**
   * @format int32
   * @min 0
   * @exclusiveMin true
   */
  role_id?: number;
}

export interface CreateUserResponse {
  auth0_user_id?: string | null;
  /** @format int32 */
  id?: number;
  /**
   * Whether the password setup mail reached the new user. False means the account is
   * usable but nobody can sign into it yet, so it needs an invite to be resent.
   */
  invitation_sent?: boolean;
  /** @format int32 */
  role_id?: number;
}

export interface CreateUserResponseIActionDataResponse {
  correlation_id?: string | null;
  data?: CreateUserResponse;
}

export interface CustomerBasicInformation {
  /** Customer First Name. */
  first_name?: string | null;
  /** Customer Last Name. */
  last_name?: string | null;
}

export interface CustomerEnrolledQuery {
  period?: string | null;
  range_end?: string | null;
  range_start?: string | null;
  timezone?: string | null;
  timezone_iana?: string | null;
}

export interface CustomerEnrolledView {
  /** @format int64 */
  count?: number;
  /** @format date-time */
  period_start?: string;
}

export interface CustomerEnrolledViewICollectionIActionDataResponse {
  correlation_id?: string | null;
  data?: CustomerEnrolledView[] | null;
}

export interface CustomerEnrollmentPolicyView {
  /** @format date-time */
  created_at?: string;
  has_operator_interacted?: boolean | null;
  /** @format int32 */
  id?: number;
  is_active?: boolean | null;
  name?: string | null;
  satisfied?: boolean | null;
  type?: string | null;
  /** @format date-time */
  updated_at?: string;
}

export interface CustomerEnrollmentPolicyViewIActionDataResponse {
  correlation_id?: string | null;
  data?: CustomerEnrollmentPolicyView;
}

export interface CustomerEnrollmentPolicyViewICollectionIActionDataResponse {
  correlation_id?: string | null;
  data?: CustomerEnrollmentPolicyView[] | null;
}

export interface CustomerEnrollmentTierView {
  /** @format date-time */
  created_at?: string;
  description?: string | null;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  limit_max?: number;
  name?: string | null;
  /** @format int32 */
  operator_id?: number;
  required_policies?: CustomerEnrollmentPolicyView[] | null;
  tool_tip?: string | null;
  type?: string | null;
  /** @format date-time */
  updated_at?: string;
}

export interface CustomerEnrollmentTierViewICollectionIActionDataResponse {
  correlation_id?: string | null;
  data?: CustomerEnrollmentTierView[] | null;
}

export interface CustomerEnrollmentView {
  has_operator_interacted?: boolean;
  is_satisfied?: boolean;
  /** @format date-time */
  operator_interacted_at?: string | null;
  policy_id?: EnrollmentPolicyEnum;
  /** @format date-time */
  satisfied_at?: string | null;
}

/** Schema for the included property of customer action responses. */
export interface CustomerIncluded {
  enrollment_policies?: EnrollmentPolicyView[] | null;
  /** Tags associated to this Customer. */
  tags?: TagView[] | null;
}

export interface CustomerStatCardsView {
  /** @format int64 */
  all_time?: number;
  /** @format int64 */
  month?: number;
  /** @format int64 */
  today?: number;
  /** @format int64 */
  year?: number;
}

export interface CustomerStatCardsViewIActionDataResponse {
  correlation_id?: string | null;
  data?: CustomerStatCardsView;
}

export interface CustomerStatsCustomersEnrolledDetailParams {
  period?: string | null;
  range_end?: string | null;
  range_start?: string | null;
  timezone?: string | null;
}

export interface CustomerStatsCustomersStatCardsListParams {
  /** The caller's UTC offset in whole hours. */
  timezone?: string;
}

export interface DayOpenHours {
  span?: OpenHoursSpan[] | null;
  state?: string | null;
}

export enum DeviceStatus {
  Online = 'online',
  Offline = 'offline',
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
}

export interface DispenseAssetView {
  /** Bills of the asset. */
  bills?: DispenseBillView[] | null;
  /** Unique identifier for the asset. */
  id?: string | null;
  /** Symbol of the asset. */
  logo_url?: string | null;
  /** Name of the asset. */
  name?: string | null;
  /** Symbol of the asset. */
  symbol?: string | null;
}

export interface DispenseAssetViewICollectionIActionDataResponse {
  correlation_id?: string | null;
  data?: DispenseAssetView[] | null;
}

/** A single bill line in expected/successful/rejected dispense breakdown. */
export interface DispenseBillItemView {
  bill_note_id?: string | null;
  /** @format int32 */
  cassette_slot?: number;
  display_name?: string | null;
  /** @format int32 */
  quantity?: number;
  /** @format int32 */
  unit?: number;
  variant?: string | null;
}

export interface DispenseBillView {
  /** Unique identifier for the bill. */
  asset_id?: string | null;
  /**
   * Denomination of the bill.
   * @format int32
   */
  denomination?: number;
  /** Unique identifier for the bill. */
  id?: string | null;
  variant?: string | null;
}

/**
 * One cassette's dispense result: bill note identity plus hardware counts and rejection reasons.
 * Merges result_request_data.data[] with expected_bills so you get e.g. "Cassette 1 = Goldback 1, 1 dispensed, 1 rejected (long length)".
 */
export interface DispenseCassetteResultView {
  /** Bill note in this cassette (from expected_dispenses / bill_notes). */
  bill_note_id?: string | null;
  cassette_name?: string | null;
  /** @format int32 */
  cassette_slot?: number;
  /** @format int32 */
  dispensed_count?: number;
  /** @format int32 */
  dispensed_notes?: number;
  display_name?: string | null;
  /** @format int32 */
  passed_cassette_entry?: number;
  /** Hardware-reported rejection reason counts for one cassette. */
  rejection_reasons?: DispenseRejectionReasonsView;
  /** @format int32 */
  requested_for_dispensing?: number;
  /** @format int32 */
  total_rejected_notes?: number;
  /** @format int32 */
  unit?: number;
  variant?: string | null;
}

export enum DispenseEventType {
  DispenseInitiated = 'dispense_initiated',
  DispenseCompleted = 'dispense_completed',
  DispenseFailed = 'dispense_failed',
  RejectDetected = 'reject_detected',
  TestDispense = 'test_dispense',
}

/** Hardware-reported rejection reason counts for one cassette. */
export interface DispenseRejectionReasonsView {
  /** @format int32 */
  abnormal_space?: number;
  /** @format int32 */
  double_note?: number;
  /** @format int32 */
  long_length?: number;
  /** @format int32 */
  short_length?: number;
  /** @format int32 */
  skew?: number;
}

export enum DisplayStageEnum {
  Completed = 'completed',
  Pending = 'pending',
  Frozen = 'frozen',
  Refunded = 'refunded',
}

export enum EnrollmentPolicyEnum {
  Address = 'address',
  BasicInfo = 'basic_info',
  ManualApproval = 'manual_approval',
  GovernmentIdAndSelfie = 'government_id_and_selfie',
  GovernmentIdNumber = 'government_id_number',
  Ssn = 'ssn',
  DateOfBirth = 'date_of_birth',
  Occupation = 'occupation',
  ProofOfIncome = 'proof_of_income',
}

export interface EnrollmentPolicyView {
  id?: EnrollmentPolicyEnum;
  name?: string | null;
}

export interface EnrollmentPolicyViewFilter {
  operands?: EnrollmentPolicyViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface EnrollmentPolicyViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: EnrollmentPolicyView[] | null;
  meta?: EnrollmentPolicyViewPaginatableResponseMetadata;
}

export interface EnrollmentPolicyViewPaginatableRequest {
  filter?: EnrollmentPolicyViewFilter;
  pagination: EnrollmentPolicyViewPagination;
  search_text?: string | null;
}

export interface EnrollmentPolicyViewPaginatableResponseMetadata {
  filter?: EnrollmentPolicyViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface EnrollmentPolicyViewPagination {
  /**
   * @format int32
   * @min 1
   */
  current_page?: number;
  /**
   * @format int32
   * @min 1
   * @max 1000
   */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export enum EppKeyModeEnum {
  SingleDes = 'single_des',
  DualDes = 'dual_des',
  UniqueSingleDes = 'unique_single_des',
  TripleDes = 'triple_des',
  UniqueTripleDes = 'unique_triple_des',
  MacSingleDes = 'mac_single_des',
  MacUniqueDes = 'mac_unique_des',
  MacTripleDes = 'mac_triple_des',
  TripleMacTripleDes = 'triple_mac_triple_des',
}

export enum EppKeyStatusEnum {
  Success = 'success',
  Failed = 'failed',
  Busy = 'busy',
  Unknown = 'unknown',
  LineDown = 'line_down',
  InvalidKeyMode = 'invalid_key_mode',
  InvalidKeyIndex = 'invalid_key_index',
}

export interface EventListView {
  /** @format int32 */
  atm_id?: number;
  /** @format date-time */
  created_at?: string;
  details?: any;
  event_type?: MachineEventType;
  id?: string | null;
  /** @format int32 */
  location_id?: number;
}

export interface EventListViewFilter {
  operands?: EventListViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface EventListViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: EventListView[] | null;
  meta?: EventListViewPaginatableResponseMetadata;
}

export interface EventListViewPaginatableRequest {
  filter?: EventListViewFilter;
  pagination?: EventListViewPagination;
  search_text?: string | null;
}

export interface EventListViewPaginatableResponseMetadata {
  filter?: EventListViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface EventListViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export enum ExportKinds {
  Csv = 'csv',
  Excel = 'excel',
}

export enum FilterOperator {
  None = 'none',
  Equal = 'equal',
  NotEqual = 'not_equal',
  GreaterThan = 'greater_than',
  GreaterThanOrEqual = 'greater_than_or_equal',
  LessThan = 'less_than',
  LessThanOrEqual = 'less_than_or_equal',
  Contains = 'contains',
  NotContains = 'not_contains',
  StartsWith = 'starts_with',
  EndsWith = 'ends_with',
  And = 'and',
  Or = 'or',
}

export enum FrozenTransactionStatusEnum {
  WaitingForCustomerResponse = 'waiting_for_customer_response',
  Approved = 'approved',
  Rejected = 'rejected',
  AutoReleased = 'auto_released',
}

export interface FrozenTransactionView {
  /** @format int32 */
  atm_id?: number | null;
  atm_name?: string | null;
  /** @format date-time */
  auto_release_time?: string | null;
  /** @format double */
  bitstop_rate?: number | null;
  can_customer_release?: boolean;
  closed?: boolean;
  coin?: CoinView;
  coin_id?: string | null;
  coin_type?: string | null;
  /** @format double */
  crypto_amount?: number;
  currency_code?: string | null;
  customer_full_name?: string | null;
  /** @format int32 */
  customer_id?: number;
  customer_phone_number?: string | null;
  /** @format date-time */
  customer_response_time?: string | null;
  frozen_transaction_id?: string | null;
  /** @format date-time */
  frozen_transaction_record_created_at?: string;
  /** @format double */
  inserted?: number;
  /** @format int32 */
  operator_id?: number;
  operator_name?: string | null;
  rules_triggered?: any;
  sale_id?: string | null;
  sale_short_uuid?: string | null;
  /** @format double */
  sent?: number;
  stage?: string | null;
  status?: FrozenTransactionStatusEnum;
  /** @format date-time */
  transaction_updated_at?: string;
  tx_hash?: string | null;
  wallet_address?: string | null;
}

export interface FrozenTransactionViewListIActionDataResponse {
  correlation_id?: string | null;
  data?: FrozenTransactionView[] | null;
}

export interface GmbGroupView {
  id?: string | null;
  /** @format int32 */
  location_count?: number;
  name?: string | null;
}

export interface IActionErrorResponse {
  correlation_id?: string | null;
  errors?: ActionResponseDetail[] | null;
}

export interface ImageResponse {
  /** URL of the image. */
  link_to_image?: string | null;
  /** View after clicking (Enter pin | Proceed | Send To Wallet). */
  view?: string | null;
}

export interface ImageResponseListIActionDataResponse {
  correlation_id?: string | null;
  data?: ImageResponse[] | null;
}

export interface InsightDataPoint {
  /** @format date */
  date?: string;
  /** @format double */
  value?: number;
}

export interface InstallableAtmsListView {
  /**
   * Id of the ATM.
   * @format int32
   */
  id?: number;
  /** Machine Id of the ATM. */
  machine_id?: string | null;
  /** Name of the ATM. */
  name?: string | null;
  /** Pickup Id of the ATM. */
  pick_up_id?: string | null;
  /** Serial number of the ATM. */
  serial?: string | null;
  status?: MachineStatus;
}

export interface InstallableAtmsListViewFilter {
  operands?: InstallableAtmsListViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface InstallableAtmsListViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: InstallableAtmsListView[] | null;
  meta?: InstallableAtmsListViewPaginatableResponseMetadata;
}

export interface InstallableAtmsListViewPaginatableResponseMetadata {
  filter?: InstallableAtmsListViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface Int32ArrayIActionDataResponse {
  correlation_id?: string | null;
  data?: number[] | null;
}

export interface Int32IActionDataResponse {
  correlation_id?: string | null;
  /** @format int32 */
  data?: number;
}

/** Asset View used for Receipt View for a Sale. */
export interface IntegrationAssetView {
  /**
   * asset amount being purchased
   * @format double
   */
  amount?: number;
  /** asset code. Ex: "BTC" */
  code?: string | null;
  /** asset name. Ex: "Bitcoin" */
  name?: string | null;
  /** asset type. Ex: "Crypto" */
  type?: string | null;
}

/** Customer's information to be displayed on the dashboard. */
export interface IntegrationDashboardCustomer {
  /** Customer's first name to be displayed on the dashboard. */
  first_name?: string | null;
}

/** Transcation view for nonce users. */
export interface IntegrationDashboardView {
  /** Customer's information to be displayed on the dashboard. */
  customer?: IntegrationDashboardCustomer;
  /** List of the latest transactions */
  transactions?: IntegrationTransactionView[] | null;
}

export interface IntegrationDashboardViewIActionDataResponse {
  correlation_id?: string | null;
  /** Transcation view for nonce users. */
  data?: IntegrationDashboardView;
}

/** Receipt View for a Sale. */
export interface IntegrationReceiptView {
  /** Asset View used for Receipt View for a Sale. */
  asset?: IntegrationAssetView;
  /**
   * date and time sale was last updated at
   * @format date-time
   */
  date?: string;
  /**
   * fee taken out from fiat amount inserted
   * @format double
   */
  fee?: number;
  /**
   * fiat amount of bills inserted into a machine
   * @format double
   */
  fiat_amount_inserted?: number;
  /**
   * fiat amount after fees
   * @format double
   */
  fiat_amount_sent?: number;
  /**
   * BTC exchange rate
   * @format double
   */
  rate?: number;
  /** BTC wallet address funds are being sent to */
  wallet_address?: string | null;
}

export interface IntegrationReceiptViewIActionDataResponse {
  correlation_id?: string | null;
  /** Receipt View for a Sale. */
  data?: IntegrationReceiptView;
}

/** Transcation view for nonce users. */
export interface IntegrationTransactionView {
  /** @format double */
  asset_amount?: number;
  /** @format date-time */
  created_at?: string;
  /** @format double */
  fiat_amount?: number;
  id?: string | null;
  wallet_address?: string | null;
}

export interface IntegrationView {
  /** Unique identifier for the integration. */
  id?: string | null;
  /** Name of the integration. */
  name?: string | null;
}

export interface IntegrationViewICollectionIActionDataResponse {
  correlation_id?: string | null;
  data?: IntegrationView[] | null;
}

export interface InvoiceDetailView {
  /** @format date-time */
  created_at?: string;
  /** @format date-time */
  ended_at?: string;
  /** @format int32 */
  id?: number;
  invoice_status?: string | null;
  item_title?: string | null;
  item_type?: string | null;
  /** @format int32 */
  item_type_id?: number;
  items?: InvoiceItemView[] | null;
  /** @format int32 */
  operator_id?: number;
  /** @format double */
  paid_amount?: number;
  payments?: InvoicePaymentView[] | null;
  /** @format date-time */
  started_at?: string;
  /** @format double */
  total_amount?: number;
  /** @format date-time */
  updated_at?: string;
}

export interface InvoiceDetailViewIActionDataResponse {
  correlation_id?: string | null;
  data?: InvoiceDetailView;
}

export interface InvoiceItemView {
  /** @format int32 */
  atm_id?: number | null;
  atm_name?: string | null;
  /** @format double */
  btc_amount?: number | null;
  /** @format double */
  btc_rate?: number | null;
  /** @format date-time */
  created_at?: string;
  /** @format double */
  fiat_amount?: number | null;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  invoice_id?: number | null;
  /** @format int32 */
  item_type_id?: number | null;
  /** @format int32 */
  operator_id?: number | null;
  reference_id?: string | null;
  /** @format double */
  total_amount?: number | null;
  /** @format date-time */
  updated_at?: string;
}

export interface InvoiceListQuery {
  /** @format date-time */
  end?: string | null;
  filter?: string | null;
  item_type?: string | null;
  /**
   * @format int32
   * @min 0
   * @exclusiveMin true
   */
  items_per_page?: number;
  /**
   * @format int32
   * @min 0
   * @exclusiveMin true
   */
  page?: number;
  /** @format date-time */
  start?: string | null;
}

export interface InvoicePaymentView {
  address?: string | null;
  /** @format date-time */
  created_at?: string;
  /** @format int32 */
  id?: number;
  invoice_ids?: number[] | null;
  /** @format int32 */
  operator_id?: number;
  /** @format double */
  spot_price?: number | null;
  /** @format double */
  total_amount?: number;
  txid?: string | null;
  /** @format date-time */
  updated_at?: string;
}

export interface InvoiceQuery {
  /** @format date-time */
  end?: string | null;
  filter?: string | null;
  item_type?: string | null;
  /** @format date-time */
  start?: string | null;
}

export interface InvoiceSaleView {
  address?: string | null;
  /** @format int32 */
  atm_id?: number;
  atm_name?: string | null;
  batched?: boolean;
  /** @format date-time */
  created_at?: string;
  currency_code?: string | null;
  customer_first_name?: string | null;
  /** @format int32 */
  customer_id?: number;
  customer_last_name?: string | null;
  /** @format double */
  fee_amount?: number | null;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  invoice_id?: number | null;
  /** @format int32 */
  invoice_item_id?: number | null;
  /** @format int32 */
  operator_id?: number;
  /** @format double */
  operator_usd_fee?: number | null;
  /** @format double */
  operator_usd_price?: number;
  /** @format double */
  sale_usd_price?: number;
  /** @format double */
  total_amount?: number;
  /** @format double */
  total_usd_amount?: number;
  txid?: string | null;
  /** @format int32 */
  unity_id?: number;
  unity_uuid?: string | null;
  /** @format date-time */
  updated_at?: string;
}

export interface InvoiceSaleViewICollectionIActionDataResponse {
  correlation_id?: string | null;
  data?: InvoiceSaleView[] | null;
}

export enum InvoiceStatusEnum {
  Unpaid = 'unpaid',
  PartiallyPaid = 'partially_paid',
  Paid = 'paid',
}

export interface InvoiceView {
  /** @format date-time */
  created_at?: string;
  /** @format date-time */
  ended_at?: string;
  /** @format int32 */
  id?: number;
  invoice_status?: string | null;
  /** @format int32 */
  item_type_id?: number;
  /** @format int32 */
  operator_id?: number;
  /** @format double */
  paid_amount?: number;
  /** @format int32 */
  payment_id?: number | null;
  /** @format date-time */
  started_at?: string;
  /** @format double */
  total_amount?: number;
  /** @format date-time */
  updated_at?: string;
  /** @format double */
  usd_amount?: number | null;
}

export interface InvoiceViewFilter {
  operands?: InvoiceViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface InvoiceViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: InvoiceView[] | null;
  meta?: InvoiceViewPaginatableResponseMetadata;
}

export interface InvoiceViewPaginatableResponseMetadata {
  filter?: InvoiceViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface InvoicesListParams {
  /** @format date-time */
  end?: string | null;
  filter?: string | null;
  item_type?: string | null;
  /**
   * @format int32
   * @min 0
   * @exclusiveMin true
   */
  items_per_page?: number;
  /**
   * @format int32
   * @min 0
   * @exclusiveMin true
   */
  page?: number;
  /** @format date-time */
  start?: string | null;
}

export interface InvoicesMetadataListParams {
  /** @format date-time */
  end?: string | null;
  filter?: string | null;
  item_type?: string | null;
  /** @format date-time */
  start?: string | null;
}

export interface InvoicesMetadataView {
  can_filter?: boolean;
  can_filter_apr?: boolean;
  can_filter_aug?: boolean;
  can_filter_dec?: boolean;
  can_filter_feb?: boolean;
  can_filter_jan?: boolean;
  can_filter_jul?: boolean;
  can_filter_jun?: boolean;
  can_filter_last_month?: boolean;
  can_filter_last_year?: boolean;
  can_filter_mar?: boolean;
  can_filter_may?: boolean;
  can_filter_nov?: boolean;
  can_filter_oct?: boolean;
  can_filter_sep?: boolean;
  can_filter_this_month?: boolean;
  can_filter_this_year?: boolean;
  /** @format double */
  total_paid_on_filtered?: number;
  will_paginate?: boolean;
}

export interface InvoicesMetadataViewIActionDataResponse {
  correlation_id?: string | null;
  data?: InvoicesMetadataView;
}

export interface IssueEventView {
  /** @format int32 */
  atm_id?: number;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  details?: any;
  event_type?: MachineEventType;
  id?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  /** @format int32 */
  location_id?: number;
}

export interface IssueListView {
  affected_devices?: string[] | null;
  /** @format int32 */
  atm_id?: number;
  auto_case_created?: boolean;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  /** @format date-time */
  detected_at?: string;
  /** @format int32 */
  display_id?: number;
  id?: string | null;
  issue_type?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  /** @format int32 */
  linked_case_display_id?: number | null;
  linked_case_id?: string | null;
  /** @format int32 */
  linked_service_ticket_display_id?: number | null;
  linked_service_ticket_id?: string | null;
  location?: IssueLocationView;
  /** @format int32 */
  location_id?: number | null;
  machine_serial_number?: string | null;
  machine_status?: MachineStatus;
  notes?: string | null;
  recovery_steps?: IssueRecoveryView[] | null;
  /** @format date-time */
  resolved_at?: string | null;
  resolved_by_event_ids?: string[] | null;
  resolved_by_events?: IssueEventView[] | null;
  severity?: IssueSeverity;
  status?: IssueStatus;
  triggered_by_event_ids?: string[] | null;
  triggered_by_events?: IssueEventView[] | null;
}

export interface IssueListViewFilter {
  operands?: IssueListViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface IssueListViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: IssueListView[] | null;
  meta?: IssueListViewPaginatableResponseMetadata;
}

export interface IssueListViewPaginatableRequest {
  filter?: IssueListViewFilter;
  pagination?: IssueListViewPagination;
  search_text?: string | null;
}

export interface IssueListViewPaginatableResponseMetadata {
  filter?: IssueListViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface IssueListViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface IssueLocationView {
  address2?: string | null;
  city?: string | null;
  full_address?: string | null;
  /** @format int32 */
  location_id?: number;
  state?: string | null;
  store_name?: string | null;
  street_address?: string | null;
  zip_code?: string | null;
}

export enum IssueRecoveryAttemptStatus {
  InProgress = 'in_progress',
  Completed = 'completed',
  Failed = 'failed',
}

export enum IssueRecoveryStrategy {
  RestartMiddleman = 'restart_middleman',
  SyncCduConfiguration = 'sync_cdu_configuration',
}

export interface IssueRecoveryView {
  attempts?: RecoveryAttemptView[] | null;
  issue_recovery_strategy_step_id?: string | null;
  /** @format int32 */
  max_attempts?: number;
  /** @format int32 */
  retry_interval_seconds?: number;
  /** @format int32 */
  step_order?: number;
  strategy?: IssueRecoveryStrategy;
}

export enum IssueSeverity {
  Low = 'low',
  Medium = 'medium',
  High = 'high',
  Critical = 'critical',
}

export interface IssueStatsView {
  /** @format int32 */
  affected_atms?: number;
  /** @format int32 */
  affected_atms_by_active_issues?: number;
  average_time_to_resolve_formatted?: string | null;
  /** @format double */
  average_time_to_resolve_seconds?: number;
  /** @format date-time */
  from?: string;
  /** @format date-time */
  to?: string;
  /** @format int32 */
  total_active_issues?: number;
  /** @format int32 */
  total_issues?: number;
}

export interface IssueStatsViewFilter {
  operands?: IssueStatsViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface IssueStatsViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: IssueStatsView[] | null;
  meta?: IssueStatsViewPaginatableResponseMetadata;
}

export interface IssueStatsViewPaginatableResponseMetadata {
  filter?: IssueStatsViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export enum IssueStatus {
  Active = 'active',
  Resolved = 'resolved',
}

export interface IssueView {
  affected_devices?: string[] | null;
  /** @format int32 */
  atm_id?: number;
  auto_case_created?: boolean;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  /** @format date-time */
  detected_at?: string;
  /** @format int32 */
  display_id?: number;
  id?: string | null;
  issue_type?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  /** @format int32 */
  linked_case_display_id?: number | null;
  linked_case_id?: string | null;
  /** @format int32 */
  linked_service_ticket_display_id?: number | null;
  linked_service_ticket_id?: string | null;
  /** @format int32 */
  location_id?: number | null;
  notes?: string | null;
  recovery_attempts?: IssueRecoveryView[] | null;
  /** @format date-time */
  resolved_at?: string | null;
  resolved_by_events?: string[] | null;
  severity?: IssueSeverity;
  status?: IssueStatus;
  timeline?: TimelineEntryView[] | null;
  triggered_by_events?: string[] | null;
}

export interface IssueViewActionResponse {
  correlation_id?: string | null;
  data?: IssueView;
  /** @deprecated */
  dictionaries?: any;
  errors?: ActionResponseDetail[] | null;
  included?: any;
  meta?: any;
  warnings?: ActionResponseDetail[] | null;
}

export interface IssueViewExportFilter {
  operands?: IssueViewExportFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface IssueViewExportFilterableRequest {
  filter?: IssueViewExportFilter;
  search_text?: string | null;
}

export interface Item {
  /** @format int32 */
  actual_count?: number;
  bill_note_id?: string | null;
  /** @format int32 */
  expected_count?: number;
  id?: string | null;
  result?: ReconciliationResultType;
}

export interface JsonElementFilter {
  operands?: JsonElementFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface JsonElementIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: any[] | null;
  meta?: JsonElementPaginatableResponseMetadata;
}

export interface JsonElementPaginatableResponseMetadata {
  filter?: JsonElementFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface KycCustomerStatusView {
  admin_status?: boolean;
  /** @format date-time */
  created_at?: string;
  customer_first_name?: string | null;
  /** @format int32 */
  customer_id?: number;
  customer_last_name?: string | null;
  customer_phone_number?: string | null;
  /** @format int32 */
  id?: number;
  note_type?: string | null;
  /** @format int32 */
  operator_id?: number | null;
  status_type?: string | null;
  /** @format date-time */
  updated_at?: string;
}

export interface KycCustomerStatusViewIActionDataResponse {
  correlation_id?: string | null;
  data?: KycCustomerStatusView;
}

export interface KycCustomerView {
  admin_status?: boolean;
  /** @format date-time */
  created_at?: string;
  customer_first_name?: string | null;
  /** @format int32 */
  customer_id?: number;
  customer_last_name?: string | null;
  customer_phone_number?: string | null;
  /** @format int32 */
  id?: number;
  note_type?: string | null;
  /** @format int32 */
  operator_id?: number | null;
  /** @format double */
  spent?: number | null;
  status_type?: string | null;
  /** @format date-time */
  updated_at?: string;
}

export interface KycCustomerViewICollectionIActionDataResponse {
  correlation_id?: string | null;
  data?: KycCustomerView[] | null;
}

export interface KycCustomersListParams {
  /**
   * Excludes customers who have spent this amount or less.
   * @format double
   */
  spent?: number;
  /** Restricts the list to these KYC statuses. Repeatable. */
  status_type?: string[];
}

export interface KycNoteTemplateView {
  allow_content?: boolean;
  content?: string | null;
  /** @format date-time */
  created_at?: string;
  /** @format int32 */
  id?: number;
  master?: boolean;
  note_type?: string | null;
  /** @format int32 */
  operator_id?: number | null;
  /** @format date-time */
  updated_at?: string;
}

export interface KycNoteTemplateViewIActionDataResponse {
  correlation_id?: string | null;
  data?: KycNoteTemplateView;
}

export interface KycNoteTemplateViewICollectionIActionDataResponse {
  correlation_id?: string | null;
  data?: KycNoteTemplateView[] | null;
}

export enum KycNoteTypeEnum {
  None = 'none',
  Suspend = 'suspend',
  Ban = 'ban',
  Unban = 'unban',
  Ofac = 'ofac',
  AdminBan = 'admin_ban',
  AdminUnban = 'admin_unban',
  ScanId = 'scan_id',
  RequestId = 'request_id',
  RequestSurvey = 'request_survey',
  SmsSend = 'sms_send',
  SurveyAnswer = 'survey_answer',
  SmsReceive = 'sms_receive',
  Document = 'document',
  InquiryRequested = 'inquiry_requested',
  InquiryCompleted = 'inquiry_completed',
  InquiryExpired = 'inquiry_expired',
  InquiryRetried = 'inquiry_retried',
  InquiryFailed = 'inquiry_failed',
  Custom = 'custom',
}

export interface KycNoteView {
  /** @format int32 */
  author_id?: number | null;
  author_name?: string | null;
  author_type?: string | null;
  content?: string | null;
  /** @format date-time */
  created_at?: string;
  customer_first_name?: string | null;
  /** @format int32 */
  customer_id?: number;
  customer_last_name?: string | null;
  /** @format int32 */
  id?: number;
  note_type?: string | null;
  /** @format int32 */
  operator_id?: number | null;
  reason?: string | null;
  /** @format date-time */
  updated_at?: string;
}

export interface KycNoteViewIActionDataResponse {
  correlation_id?: string | null;
  data?: KycNoteView;
}

export interface KycNoteViewICollectionIActionDataResponse {
  correlation_id?: string | null;
  data?: KycNoteView[] | null;
}

export interface KycNotesListParams {
  /** @format int32 */
  customer_id?: number;
}

export enum KycStatusEnum {
  None = 'none',
  Cleared = 'cleared',
  Suspended = 'suspended',
  Banned = 'banned',
  Unbanned = 'unbanned',
  ScanId = 'scan_id',
}

export interface KycStatusEnumICollectionIActionDataResponse {
  correlation_id?: string | null;
  data?: KycStatusEnum[] | null;
}

export interface LastSaleDto {
  /** @format double */
  btc?: number;
  /** @format date-time */
  created_at?: string;
  /** @format int32 */
  customer_id?: number;
  idtx?: string | null;
}

export enum LinkStatusEnum {
  PotentialMatch = 'potential_match',
  PotentialMatchRemoved = 'potential_match_removed',
  Linked = 'linked',
  Unlinked = 'unlinked',
}

/** WIP for the customer view model. Ensuring we can filter by policy. */
export interface LinkedCustomerView {
  /** Id of the linking association */
  customers_link_id?: string | null;
  /** Firstname of the customer */
  first_name?: string | null;
  /**
   * PK Id of the customer according to unity.
   * @format int32
   */
  id?: number;
  kyc_status?: KycStatusEnum;
  /** Lastname of the customer */
  last_name?: string | null;
  /**
   * Date of link's last update
   * @format date-time
   */
  last_updated_at?: string;
  link_status?: LinkStatusEnum;
  /**
   * Date of linking
   * @format date-time
   */
  linked_on?: string;
  /** Phone number of the customer */
  phone_number?: string | null;
}

export interface LinkedCustomerViewFilter {
  operands?: LinkedCustomerViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface LinkedCustomerViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: LinkedCustomerView[] | null;
  meta?: LinkedCustomerViewPaginatableResponseMetadata;
}

export interface LinkedCustomerViewPaginatableRequest {
  filter?: LinkedCustomerViewFilter;
  pagination: LinkedCustomerViewPagination;
  search_text?: string | null;
}

export interface LinkedCustomerViewPaginatableResponseMetadata {
  filter?: LinkedCustomerViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface LinkedCustomerViewPagination {
  /**
   * @format int32
   * @min 1
   */
  current_page?: number;
  /**
   * @format int32
   * @min 1
   * @max 1000
   */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface ListingAtmView {
  affiliate_id?: string | null;
  affiliate_name?: string | null;
  /** @format int32 */
  atm_id?: number;
  atm_name?: string | null;
  /** @format date-time */
  date_time_installed?: string;
  /** @format date-time */
  date_time_uninstalled?: string | null;
  integration_id?: string | null;
  integration_reference_id?: string | null;
  integrator_name?: string | null;
  serial?: string | null;
}

export interface ListingDetailView {
  atm_ids?: number[] | null;
  atms?: ListingAtmView[] | null;
  business_contact_name?: string | null;
  business_contact_phone_number?: string | null;
  /** @format date-time */
  changes_processed_until?: string | null;
  city?: string | null;
  company_name?: string | null;
  /** @format date-time */
  created_at?: string;
  full_address?: string | null;
  gmb_group_id?: string | null;
  gmb_group_name?: string | null;
  has_media?: boolean;
  image_urls?: LocationImageData[] | null;
  last_published_data?: LocationPublishedData;
  /** @format date-time */
  last_updated_at?: string;
  /** @format double */
  latitude?: number | null;
  /** @format int32 */
  location_id?: number;
  /** @format double */
  longitude?: number | null;
  marketing_status?: MarketingStatusEnum;
  merchant_id?: string | null;
  merchant_owner_email?: string | null;
  merchant_owner_first_name?: string | null;
  merchant_owner_last_name?: string | null;
  merchant_owner_phone_number?: string | null;
  name?: string | null;
  /** @format int32 */
  operator_id?: number;
  operator_name?: string | null;
  phone?: string | null;
  platform_statuses?: ListingPlatformStatusesView;
  profile_completed?: boolean;
  promotion_status?: PromotionStatusEnum;
  state?: string | null;
}

export interface ListingInsightView {
  metric_key?: string | null;
  series?: InsightDataPoint[] | null;
  source?: string | null;
}

export interface ListingKeywordView {
  /** @format int32 */
  count?: number;
  /** @format date */
  date?: string;
  id?: string | null;
  keyword?: string | null;
}

export interface ListingListView {
  atm_ids?: number[] | null;
  city?: string | null;
  company_name?: string | null;
  /** @format date-time */
  created_at?: string;
  full_address?: string | null;
  gmb_group_id?: string | null;
  gmb_group_name?: string | null;
  has_media?: boolean;
  image_urls?: LocationImageData[] | null;
  /** @format date-time */
  last_updated_at?: string;
  /** @format int32 */
  location_id?: number;
  marketing_status?: MarketingStatusEnum;
  name?: string | null;
  /** @format int32 */
  operator_id?: number;
  operator_name?: string | null;
  profile_completed?: boolean;
  promotion_status?: PromotionStatusEnum;
  state?: string | null;
}

export interface ListingListViewExportFilter {
  operands?: ListingListViewExportFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface ListingListViewExportFilterableRequest {
  filter?: ListingListViewExportFilter;
  search_text?: string | null;
}

export interface ListingListViewFilter {
  operands?: ListingListViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface ListingListViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: ListingListView[] | null;
  meta?: ListingListViewPaginatableResponseMetadata;
}

export interface ListingListViewPaginatableRequest {
  filter?: ListingListViewFilter;
  pagination?: ListingListViewPagination;
  search_text?: string | null;
}

export interface ListingListViewPaginatableResponseMetadata {
  filter?: ListingListViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface ListingListViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export enum ListingPlatformStatusEnum {
  NotLive = 'not_live',
  Live = 'live',
  TemporarilyClosed = 'temporarily_closed',
  PermanentlyClosed = 'permanently_closed',
}

export interface ListingPlatformStatusView {
  link?: string | null;
  status?: ListingPlatformStatusEnum;
}

export interface ListingPlatformStatusesView {
  apple?: ListingPlatformStatusView;
  bing?: ListingPlatformStatusView;
  /** @format date-time */
  checked_at?: string | null;
  google?: ListingPlatformStatusView;
  temporarily_closed_until?: string | null;
}

export interface ListingsSummaryView {
  /** @format int32 */
  in_review?: number;
  /** @format int32 */
  not_published?: number;
  /** @format int32 */
  published?: number;
}

export enum LocationChangeQueueItemActionEnum {
  Create = 'create',
  Update = 'update',
  Unpublish = 'unpublish',
  Republish = 'republish',
}

export enum LocationChangeQueueItemStatusEnum {
  Pending = 'pending',
  Approved = 'approved',
  Rejected = 'rejected',
  Processed = 'processed',
  Error = 'error',
  Obsolete = 'obsolete',
  Completed = 'completed',
  Conflict = 'conflict',
}

export interface LocationImage {
  id?: string | null;
  /** @format int32 */
  rotation?: number | null;
  url?: string | null;
}

export interface LocationImageData {
  id?: string | null;
  /** @format int32 */
  rotation?: number | null;
  url?: string | null;
}

export interface LocationNoteView {
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  id?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  note_text?: string | null;
}

export interface LocationPublishedData {
  address_city?: string | null;
  address_country?: string | null;
  address_state?: string | null;
  address_street?: string | null;
  address_zip?: string | null;
  contact_phone?: string | null;
  gmb_group_name?: string | null;
  google_place_id?: string | null;
  homepage?: string | null;
  images?: LocationImage[] | null;
  is_always_open?: boolean | null;
  /** @format double */
  latitude?: number | null;
  location_description?: string | null;
  /** @format double */
  longitude?: number | null;
  open_hours?: OpenHours;
  temporarily_closed_until?: string | null;
}

export interface LocationSuggestionChangeView {
  field_name?: string | null;
  new_value?: string | null;
  old_value?: string | null;
}

export enum LocationSuggestionStatusEnum {
  Pending = 'pending',
  Approved = 'approved',
  Declined = 'declined',
}

export interface LocationSuggestionView {
  changes?: LocationSuggestionChangeView[] | null;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  id?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  /** @format int32 */
  location_id?: number;
  /** @format int32 */
  operator_id?: number;
  reason?: string | null;
  /** @format date-time */
  resolved_at?: string | null;
  resolved_by?: string | null;
  status?: LocationSuggestionStatusEnum;
}

export enum LocationTypeEnum {
  Native = 'native',
  Teller = 'teller',
}

export interface LocationView {
  address2?: string | null;
  address?: string | null;
  atms?: AtmLocationView[] | null;
  business_contact_name?: string | null;
  business_contact_phone?: string | null;
  cash_service_id?: string | null;
  cash_service_name?: string | null;
  cash_vault_branch_id?: string | null;
  cash_vault_branch_name?: string | null;
  city?: string | null;
  country?: string | null;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  full_address?: string | null;
  /**
   * Resources made taggable after they already exist get a new global id
   * to ensure uniqueness within the 'taggable' table. Resources will continue
   * to support their existing id property.
   * @format uuid
   */
  global_id?: string;
  has_pending_suggestion?: boolean;
  hours?: string[] | null;
  image_urls?: string[] | null;
  images?: LocationImageData[] | null;
  /** @format double */
  latitude?: number | null;
  local_time_zone?: string | null;
  /** @format int32 */
  location_id?: number;
  location_name?: string | null;
  /** @format double */
  longitude?: number | null;
  map_url?: string | null;
  marketing_status?: MarketingStatusEnum;
  merchant?: MerchantView;
  phone?: string | null;
  place_id?: string | null;
  profile_completed?: boolean;
  /**
   * Indicates the rank of the location based on historical sales performance.
   * The rank is calculated compared to other locations belonging to the same operator.
   * A rank of 1 indicates the best performing location, while a higher number indicates a lower performance.
   * @format int32
   */
  sales_performance_rank?: number;
  service_branch?: string | null;
  slug?: string | null;
  state?: string | null;
  street_address?: string | null;
  /** List of tag ids associated to this resource. */
  tag_ids?: string[] | null;
  type?: LocationTypeEnum;
  /** @format date-time */
  updated_at?: string;
  vault_branch?: string | null;
  zipcode?: string | null;
}

export interface LocationsListView {
  address2?: string | null;
  address?: string | null;
  business_contact_name?: string | null;
  business_contact_phone?: string | null;
  cash_service_id?: string | null;
  cash_service_name?: string | null;
  cash_vault_branch_id?: string | null;
  cash_vault_branch_name?: string | null;
  city?: string | null;
  country?: string | null;
  /** @format date-time */
  created_at?: string;
  /**
   * Resources made taggable after they already exist get a new global id
   * to ensure uniqueness within the 'taggable' table. Resources will continue
   * to support their existing id property.
   * @format uuid
   */
  global_id?: string;
  has_pending_suggestion?: boolean;
  installed_atms?: AtmLocationView[] | null;
  /** @format int32 */
  location_id?: number;
  location_name?: string | null;
  marketing_status?: MarketingStatusEnum;
  merchant_classification?: MerchantClassificationEnum;
  merchant_company_name?: string | null;
  merchant_id?: string | null;
  merchant_is_serviceable?: boolean;
  merchant_owner_email?: string | null;
  merchant_owner_first_name?: string | null;
  merchant_owner_last_name?: string | null;
  merchant_owner_phone_number?: string | null;
  merchant_platforms?: MerchantPlatformSummary[] | null;
  merchant_type?: MerchantTypeEnum;
  place_id?: string | null;
  profile_completed?: boolean;
  /**
   * Indicates the rank of the location based on historical sales performance.
   * The rank is calculated compared to other locations belonging to the same operator.
   * A rank of 1 indicates the best performing location, while a higher number indicates a lower performance.
   * @format int32
   */
  sales_performance_rank?: number;
  service_branch?: string | null;
  state?: string | null;
  street_address?: string | null;
  /** List of tag ids associated to this resource. */
  tag_ids?: string[] | null;
  type?: LocationTypeEnum;
  /** @format date-time */
  update_at?: string;
  vault_branch?: string | null;
  zipcode?: string | null;
}

export interface LocationsListViewExportFilter {
  operands?: LocationsListViewExportFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface LocationsListViewExportFilterableRequest {
  filter?: LocationsListViewExportFilter;
  search_text?: string | null;
}

export interface LocationsListViewFilter {
  operands?: LocationsListViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface LocationsListViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: LocationsListView[] | null;
  meta?: LocationsListViewPaginatableResponseMetadata;
}

export interface LocationsListViewPaginatableResponseMetadata {
  filter?: LocationsListViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface LocationsListViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface LocationsPaginatableRequest {
  filter?: LocationsListViewFilter;
  filter_by_atm_ids?: number[] | null;
  filter_by_has_installed_atms?: boolean | null;
  filter_by_has_pending_suggestion?: boolean | null;
  filter_by_platform_ids?: string[] | null;
  pagination?: LocationsListViewPagination;
  search_text?: string | null;
}

export interface LocationsSummaryView {
  /**
   * All the Locations associated to this operator with a machine assigned.
   * @format int32
   */
  locations_with_machines?: number;
  /**
   * All the Locations associated to this operator.
   * @format int32
   */
  total_locations?: number;
}

export interface LocationsSummaryViewIActionDataResponse {
  correlation_id?: string | null;
  data?: LocationsSummaryView;
}

export enum MachineEventType {
  HardwareFailure = 'hardware_failure',
  HardwareRecovered = 'hardware_recovered',
  MiddlemanOffline = 'middleman_offline',
  MiddlemanRecovered = 'middleman_recovered',
  ClientOffline = 'client_offline',
  ClientRecovered = 'client_recovered',
  CashboxRemoved = 'cashbox_removed',
  CashboxInserted = 'cashbox_inserted',
  ClockDriftDetected = 'clock_drift_detected',
  ClockDriftResolved = 'clock_drift_resolved',
  SafeDoorOpened = 'safe_door_opened',
  SafeDoorClosed = 'safe_door_closed',
  CashReduction = 'cash_reduction',
  CashClear = 'cash_clear',
  PsuPowerDisconnected = 'psu_power_disconnected',
  PsuPowerRestored = 'psu_power_restored',
  CduConfigurationMismatch = 'cdu_configuration_mismatch',
  CduConfigurationMismatchResolved = 'cdu_configuration_mismatch_resolved',
  CduCassettePullWithoutOpenRestock = 'cdu_cassette_pull_without_open_restock',
  CduCassettePullWithOpenRestock = 'cdu_cassette_pull_with_open_restock',
  CduCassetteInserted = 'cdu_cassette_inserted',
}

export enum MachineManufacturer {
  Kiosk = 'kiosk',
  Genmega = 'genmega',
  Kole = 'kole',
  Gemini = 'gemini',
}

export enum MachineStatus {
  Ok = 'ok',
  PreOk = 'pre_ok',
  Qa = 'qa',
  CommunicationLost = 'communication_lost',
  Down = 'down',
  MaintenanceMode = 'maintenance_mode',
  UnableToComputeStatus = 'unable_to_compute_status',
}

export interface MapLocationView {
  address2?: string | null;
  assets?: string[] | null;
  city?: string | null;
  coins?: string[] | null;
  country?: string | null;
  full_address?: string | null;
  hours?: string[] | null;
  id?: string | null;
  images?: string[] | null;
  /** @format double */
  lat?: number | null;
  /** @format double */
  lng?: number | null;
  local_time_zone?: string | null;
  location_name?: string | null;
  name?: string | null;
  operated_by?: string | null;
  phone?: string | null;
  place_id?: string | null;
  slug?: string | null;
  state?: string | null;
  street_address?: string | null;
  type?: string | null;
  zip?: string | null;
}

export interface MapLocationViewFilter {
  operands?: MapLocationViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface MapLocationViewIActionDataResponse {
  correlation_id?: string | null;
  data?: MapLocationView;
}

export interface MapLocationViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: MapLocationView[] | null;
  meta?: MapLocationViewPaginatableResponseMetadata;
}

export interface MapLocationViewPaginatableResponseMetadata {
  filter?: MapLocationViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface MapPointView {
  assets?: string[] | null;
  coins?: string[] | null;
  id?: string | null;
  /** @format double */
  lat?: number | null;
  /** @format double */
  lng?: number | null;
  type?: string | null;
}

export interface MapPointViewIActionDataResponse {
  correlation_id?: string | null;
  data?: MapPointView;
}

export interface MapQuery {
  filter?: string | null;
  /** @format double */
  lat?: number | null;
  /** @format double */
  lng?: number | null;
  order_by?: string | null;
  /**
   * @format int32
   * @min 0
   * @exclusiveMin true
   */
  page?: number;
  /**
   * @format int32
   * @min 0
   * @exclusiveMin true
   */
  page_size?: number;
}

export interface MapStatsCityView {
  city?: string | null;
  /** @format int32 */
  count?: number;
}

export interface MapStatsView {
  cities?: MapStatsCityView[] | null;
  state?: string | null;
}

export interface MapStatsViewListIActionDataResponse {
  correlation_id?: string | null;
  data?: MapStatsView[] | null;
}

export interface MarketingDashboardStatsView {
  /** @format int32 */
  total_in_review?: number;
  /** @format int32 */
  total_locations?: number;
  /** @format int32 */
  total_pending_queue?: number;
  /** @format int32 */
  total_published?: number;
  /** @format int32 */
  total_queue_errors?: number;
  /** @format int32 */
  total_unpublished?: number;
}

export enum MarketingStatusEnum {
  Published = 'published',
  Unpublished = 'unpublished',
  InReview = 'in_review',
  SuggestionPending = 'suggestion_pending',
}

export enum MerchantClassificationEnum {
  SingleStore = 'single_store',
  Corporate = 'corporate',
}

export interface MerchantEnumsView {
  classifications?: string[] | null;
}

export interface MerchantEnumsViewIActionDataResponse {
  correlation_id?: string | null;
  data?: MerchantEnumsView;
}

export interface MerchantPlatformSummary {
  name?: string | null;
  platform_id?: string | null;
}

export enum MerchantTypeEnum {
  Native = 'native',
  Teller = 'teller',
}

export interface MerchantView {
  classification?: MerchantClassificationEnum;
  company_name?: string | null;
  /** @format date-time */
  created_at?: string | null;
  id?: string | null;
  is_serviceable?: boolean;
  notes?: string | null;
  owner_email?: string | null;
  owner_first_name?: string | null;
  owner_last_name?: string | null;
  owner_phone_number?: string | null;
  platforms?: MerchantPlatformSummary[] | null;
  type?: MerchantTypeEnum;
}

export interface MerchantViewIActionDataResponse {
  correlation_id?: string | null;
  data?: MerchantView;
}

export interface MerchantsListView {
  classification?: MerchantClassificationEnum;
  company_name?: string | null;
  /** @format date-time */
  created_at?: string | null;
  id?: string | null;
  is_serviceable?: boolean;
  notes?: string | null;
  owner_email?: string | null;
  owner_first_name?: string | null;
  owner_last_name?: string | null;
  owner_phone_number?: string | null;
  platforms?: MerchantPlatformSummary[] | null;
  type?: MerchantTypeEnum;
}

export interface MerchantsListViewFilter {
  operands?: MerchantsListViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface MerchantsListViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: MerchantsListView[] | null;
  meta?: MerchantsListViewPaginatableResponseMetadata;
}

export interface MerchantsListViewPaginatableResponseMetadata {
  filter?: MerchantsListViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface MerchantsListViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface MerchantsPaginatableRequest {
  filter?: MerchantsListViewFilter;
  filter_by_platform_ids?: string[] | null;
  pagination?: MerchantsListViewPagination;
  search_text?: string | null;
}

export interface MerchantsViewExportFilter {
  operands?: MerchantsViewExportFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface MerchantsViewExportFilterableRequest {
  filter?: MerchantsViewExportFilter;
  search_text?: string | null;
}

/** Multi-function cash report view with breakdown by product type */
export interface MultiFunctionCashReportView {
  /** Atm name */
  atm_name?: string | null;
  /** Atm slug */
  atm_slug?: string | null;
  /** Cash clear ID associated with this ATM */
  cash_clear_id?: string | null;
  /** Location (full address) */
  location?: string | null;
  /** Operator name */
  operator: string | null;
  /** Location's pick-up Id */
  pick_up_id?: string | null;
  /** Breakdown of cash by product type (crypto, gold, etc.) */
  product_breakdowns?: ProductCashBreakdown[] | null;
  /** Bills from an ATM */
  total_bills?: Bills;
  /**
   * Total amount of bills across all products
   * @format int32
   */
  total_bills_count?: number;
  /**
   * Total USD across all products
   * @format double
   */
  total_usd?: number;
}

/**
 * Common enumerable atm response that is intended to be used with any type of
 * atm projection.
 */
export interface MultiFunctionCashReportViewAtmActionResponse {
  correlation_id?: string | null;
  /** Multi-function cash report view with breakdown by product type */
  data?: MultiFunctionCashReportView;
  /** Schema for the included property of atm action responses. */
  included?: AtmIncluded;
}

export interface MyAccountCustomerView {
  /** Customer's street address. */
  address?: string | null;
  /** Customer's city. */
  city?: string | null;
  /** Customer's country. */
  country?: string | null;
  /**
   * Customer's Date of Birthday.
   * @format date-time
   */
  date_of_birth?: string | null;
  /**
   * Customer's Date of enrollment
   * @format date-time
   */
  enrolled_on?: string;
  /** Customer's first name. */
  first_name?: string | null;
  /** Customer's government issued id number. */
  id_number?: string | null;
  /** Id of the customer's occupation industry, as served by occupation-options. */
  industry_id?: string | null;
  /** Customer's occupation industry name, in English. */
  industry_name?: string | null;
  /** Customer's last name. */
  last_name?: string | null;
  /** Customer's phone number. */
  phone_number?: string | null;
  /** Customer's enrollment policies (satisfied and not satisfied) */
  policies?: MyAccountEnrollmentPolicyView[] | null;
  /** Id of the customer's occupation position, as served by occupation-options. */
  position_id?: string | null;
  /** Customer's occupation position name, in English. */
  position_name?: string | null;
  /** Customer's state. */
  state?: string | null;
  /** Use this class to represent a summary stats of the transactions list. */
  stats?: TransactionStatsView;
  /** Customer's zipcode. */
  zipcode?: string | null;
}

export interface MyAccountCustomerViewIActionDataResponse {
  correlation_id?: string | null;
  data?: MyAccountCustomerView;
}

export interface MyAccountEnrollmentPolicyView {
  id?: EnrollmentPolicyEnum;
  /** Indicate if the policy is fulfiled by the customer or not. */
  is_satisfied?: boolean;
  name?: string | null;
}

export interface MyAccountFrozenTransactionView {
  /** Crypto Address */
  address?: string | null;
  /**
   * Date and time when the transaction will be released automatically unless action is taken
   * @format date-time
   */
  auto_release_time?: string | null;
  /** Can the customer ask for the transaction to be released */
  can_customer_release?: boolean;
  /** Is the transaction closed */
  closed?: boolean;
  coin?: CoinView;
  coin_id?: string | null;
  /**
   * Type of coin dispensed to the customer for this transaction.
   * @example " bitcoin "
   */
  coin_type?: string | null;
  /**
   * The amount (Satoshis for BTC) to be purchased
   * @format double
   */
  crypto_amount?: number;
  /**
   * Type of currency taken by the machine for this transaction.
   * @example " USD "
   */
  currency_code?: string | null;
  id?: string | null;
  /**
   * Amount of FIAT buying power after fees
   * @format double
   */
  sent?: number;
  short_uuid?: string | null;
  status?: string | null;
}

export interface MyAccountLocationView {
  full_address?: string | null;
  /** @format int32 */
  id?: number;
  /** @format double */
  latitude?: number | null;
  /** @format double */
  longitude?: number | null;
  phone?: string | null;
  slug?: string | null;
}

export interface MyAccountOccupationOptionsView {
  /** Active occupation industries a customer can choose from. */
  industries?: OccupationIndustryView[] | null;
  /** Active occupation positions a customer can choose from. */
  positions?: OccupationPositionView[] | null;
}

export interface MyAccountOccupationOptionsViewIActionDataResponse {
  correlation_id?: string | null;
  data?: MyAccountOccupationOptionsView;
}

/** Meant to be a direct V2 replacement for MyAccountSalesListView */
export interface MyAccountTransactionsView {
  address?: string | null;
  asset?: DispenseAssetView;
  asset_id?: string | null;
  asset_type?: string | null;
  coin?: CoinView;
  coin_id?: string | null;
  /**
   * Type of coin dispensed to the customer for this transaction.
   * @example " bitcoin "
   */
  coin_type?: string | null;
  /**
   * Date of creation, in ISO 8601 format. Unfortunately
   * this datetime is in server time (no timestamp)
   * @format date-time
   */
  created_at?: string;
  /**
   * The humanized text value for AthenaService.Web.ClientModels.v2.MyAccountDashboard.Transactions.MyAccountTransactionsView.CreatedAt
   * This is a computed field so it cannot be filtered on.
   */
  created_at_humanized?: string | null;
  /**
   * The amount (Satoshis for BTC) to be purchased
   * @format double
   */
  crypto_amount?: number;
  currency_code?: string | null;
  display_stage?: DisplayStageEnum;
  /**
   * The fee needed by the network to process the transaction on the blockchain
   * @format double
   */
  fee?: number;
  /**
   * Identifies the transaction within Bitstop.
   * @minLength 1
   */
  id: string;
  /**
   * Amount of FIAT AthenaService.Web.ClientModels.v2.MyAccountDashboard.Transactions.MyAccountTransactionsView.CurrencyCode inserted into the machine
   * @format double
   */
  inserted?: number;
  /**
   * Sale date and time in the local time zone of the atm
   * @format date-time
   */
  local_created_at?: string;
  /** The humanized text value for AthenaService.Web.ClientModels.v2.MyAccountDashboard.Transactions.MyAccountTransactionsView.LocalCreatedAt */
  local_created_at_humanized?: string | null;
  /** IANA time zone name for the local time zone of the atm */
  local_time_zone?: string | null;
  location?: MyAccountLocationView;
  /** @format int32 */
  location_id?: number | null;
  /** @example " buy " */
  order_type?: string | null;
  /**
   * Ratio of AthenaService.Web.ClientModels.v2.MyAccountDashboard.Transactions.MyAccountTransactionsView.CoinType to AthenaService.Web.ClientModels.v2.MyAccountDashboard.Transactions.MyAccountTransactionsView.CurrencyCode
   * at the time of transaction.
   * @format double
   * @example 47945.15
   */
  rate?: number | null;
  /**
   * Amount of FIAT buying power after fees (I think)
   * @format double
   */
  sent?: number;
  short_uuid?: string | null;
  /**
   * State of the transaction,
   * AthenaService.Database.Constants.Sales.Stages
   * @example " completed "
   */
  stage?: string | null;
  /** Identifies the transaction on-chain. */
  transaction_hash?: string | null;
  /** URL to blockchain explorer, such as Blocksteam, for the Transaction Hash of the sale. */
  transaction_hash_url?: string | null;
}

export interface MyAccountTransactionsViewExportFilter {
  operands?: MyAccountTransactionsViewExportFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface MyAccountTransactionsViewExportFilterableRequest {
  filter?: MyAccountTransactionsViewExportFilter;
  search_text?: string | null;
}

export interface MyAccountTransactionsViewFilter {
  operands?: MyAccountTransactionsViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface MyAccountTransactionsViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: MyAccountTransactionsView[] | null;
  meta?: MyAccountTransactionsViewPaginatableResponseMetadata;
}

export interface MyAccountTransactionsViewPaginatableRequest {
  filter?: MyAccountTransactionsViewFilter;
  pagination: MyAccountTransactionsViewPagination;
  search_text?: string | null;
}

export interface MyAccountTransactionsViewPaginatableResponseMetadata {
  filter?: MyAccountTransactionsViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface MyAccountTransactionsViewPagination {
  /**
   * @format int32
   * @min 1
   */
  current_page?: number;
  /**
   * @format int32
   * @min 1
   * @max 1000
   */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface NetsuiteAtmLocationView {
  address2?: string | null;
  city?: string | null;
  country?: string | null;
  full_address?: string | null;
  merchant?: NetsuiteLocationMerchantView;
  name?: string | null;
  state?: string | null;
  street_address?: string | null;
  zipcode?: string | null;
}

export interface NetsuiteAtmView {
  /** Id of the affiliate this atm is managed by, if applicable. */
  affiliate_id?: string | null;
  /** Name of the affiliate this atm is managed by, if applicable. */
  affiliate_name?: string | null;
  /**
   * The ATM resource's primary key identifier
   * @format int32
   */
  atm_id?: number;
  /**
   * When the ATM was created.
   * @format date-time
   */
  created_at?: string;
  integration_id?: string | null;
  integration_name?: string | null;
  location?: NetsuiteAtmLocationView;
  /**
   * Id of the location this atm is installed at, if applicable.
   * @format int32
   */
  location_id?: number | null;
  machine_status?: MachineStatus;
  manufacturer?: MachineManufacturer;
  /** Pickup ID of the ATM. */
  pick_up_id?: string | null;
  product_types?: ProductType[] | null;
  /**
   * A unique identifier physically present on the hardware of the machine.
   * Uniqueness is only guaranteed per manufacturer (genmega, kiosk, etc.)
   * Installers input this into the system during QA of a new machine. It is possible for
   * them to enter an incorrect value (twice) which can be annoying and requires manually fixing.
   */
  serial?: string | null;
  /**
   * Total quantity of all bills for all denominations.
   * @format int32
   */
  total_amount_of_bills?: number | null;
  /**
   * Total (monetary) value of all bills for all denominations.
   * @format double
   */
  total_worth_of_bills?: number | null;
  /**
   * When the ATM was last updated
   * @format date-time
   */
  updated_at?: string;
}

export interface NetsuiteAtmViewFilter {
  operands?: NetsuiteAtmViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface NetsuiteAtmViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: NetsuiteAtmView[] | null;
  meta?: NetsuiteAtmViewPaginatableResponseMetadata;
}

export interface NetsuiteAtmViewPaginatableRequest {
  filter?: NetsuiteAtmViewFilter;
  pagination?: NetsuiteAtmViewPagination;
  search_text?: string | null;
}

export interface NetsuiteAtmViewPaginatableResponseMetadata {
  filter?: NetsuiteAtmViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface NetsuiteAtmViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface NetsuiteBillNoteView {
  asset_id?: string | null;
  asset_type_id?: string | null;
  /** @format date-time */
  created_at?: string;
  display_name?: string | null;
  id?: string | null;
  is_active?: boolean;
  /** @format date-time */
  last_updated_at?: string;
  metadata?: any;
  /** @format int32 */
  unit?: number;
  variant?: string | null;
}

export interface NetsuiteBillNoteViewFilter {
  operands?: NetsuiteBillNoteViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface NetsuiteBillNoteViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: NetsuiteBillNoteView[] | null;
  meta?: NetsuiteBillNoteViewPaginatableResponseMetadata;
}

export interface NetsuiteBillNoteViewPaginatableRequest {
  filter?: NetsuiteBillNoteViewFilter;
  pagination?: NetsuiteBillNoteViewPagination;
  search_text?: string | null;
}

export interface NetsuiteBillNoteViewPaginatableResponseMetadata {
  filter?: NetsuiteBillNoteViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface NetsuiteBillNoteViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface NetsuiteCashPullView {
  /**
   * Id of the atm
   * @format int32
   */
  atm_id?: number;
  /** @format date-time */
  created_at?: string;
  /**
   * Id of the cash pull
   * @format int32
   */
  id?: number;
  /**
   * Creation date and time in the atm's timezone
   * @format date-time
   */
  local_created_at?: string;
  /**
   * Id for the location of the cash pull
   * @format int32
   */
  location_id?: number | null;
  /** Pick up Id */
  pickup_id?: string | null;
  /** Serial number of the atm */
  serial_number?: string | null;
  /**
   * Amount of cash by bills present at the time of cash pull
   * @format int32
   */
  total_amount_of_bills?: number;
  /**
   * The sum total value of all bills combined
   * @format int32
   */
  total_worth_of_bills?: number;
}

export interface NetsuiteCashPullViewFilter {
  operands?: NetsuiteCashPullViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface NetsuiteCashPullViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: NetsuiteCashPullView[] | null;
  meta?: NetsuiteCashPullViewPaginatableResponseMetadata;
}

export interface NetsuiteCashPullViewPaginatableRequest {
  filter?: NetsuiteCashPullViewFilter;
  pagination?: NetsuiteCashPullViewPagination;
  search_text?: string | null;
}

export interface NetsuiteCashPullViewPaginatableResponseMetadata {
  filter?: NetsuiteCashPullViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface NetsuiteCashPullViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface NetsuiteCashPullsUpdatedListParams {
  /** @format date-time */
  since?: string;
}

export interface NetsuiteCustomerView {
  /**
   * Created date
   * @format date-time
   */
  created_at?: string;
  /** First name. */
  first_name?: string | null;
  /**
   * PK Id of the customer according to unity.
   * @format int32
   */
  id?: number;
  /** Last name. */
  last_name?: string | null;
  /** Phone number. */
  phone_number?: string | null;
  /**
   * Last updated date
   * @format date-time
   */
  updated_at?: string;
}

export interface NetsuiteCustomerViewFilter {
  operands?: NetsuiteCustomerViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface NetsuiteCustomerViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: NetsuiteCustomerView[] | null;
  meta?: NetsuiteCustomerViewPaginatableResponseMetadata;
}

export interface NetsuiteCustomerViewPaginatableRequest {
  filter?: NetsuiteCustomerViewFilter;
  pagination?: NetsuiteCustomerViewPagination;
  search_text?: string | null;
}

export interface NetsuiteCustomerViewPaginatableResponseMetadata {
  filter?: NetsuiteCustomerViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface NetsuiteCustomerViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface NetsuiteInvoiceItemTypeView {
  item_type_name?: string | null;
  item_type_title?: string | null;
}

export interface NetsuiteInvoiceView {
  /** @format date-time */
  created_at?: string;
  /** @format date-time */
  ended_at?: string;
  /** @format int32 */
  id?: number;
  item_type?: NetsuiteInvoiceItemTypeView;
  /** @format date-time */
  last_updated_at?: string;
  /** @format int32 */
  operator_id?: number;
  /** @format double */
  paid_amount?: number;
  /** @format date-time */
  started_at?: string;
  status?: InvoiceStatusEnum;
  /** @format double */
  total_amount?: number;
  /** @format double */
  usd_amount?: number;
}

export interface NetsuiteInvoiceViewFilter {
  operands?: NetsuiteInvoiceViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface NetsuiteInvoiceViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: NetsuiteInvoiceView[] | null;
  meta?: NetsuiteInvoiceViewPaginatableResponseMetadata;
}

export interface NetsuiteInvoiceViewPaginatableRequest {
  filter?: NetsuiteInvoiceViewFilter;
  pagination?: NetsuiteInvoiceViewPagination;
  search_text?: string | null;
}

export interface NetsuiteInvoiceViewPaginatableResponseMetadata {
  filter?: NetsuiteInvoiceViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface NetsuiteInvoiceViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface NetsuiteLocationAtmView {
  /** @format int32 */
  atm_id?: number;
  /** @format date-time */
  date_time_installed?: string;
  /** @format date-time */
  date_time_uninstalled?: string | null;
}

export interface NetsuiteLocationMerchantView {
  classification?: MerchantClassificationEnum;
  company_name?: string | null;
  id?: string | null;
  is_serviceable?: boolean;
  owner_email?: string | null;
  owner_first_name?: string | null;
  owner_last_name?: string | null;
  owner_phone_number?: string | null;
}

export interface NetsuiteLocationView {
  address2?: string | null;
  affiliate_id?: string | null;
  affiliate_name?: string | null;
  atms?: NetsuiteLocationAtmView[] | null;
  business_contact_name?: string | null;
  business_contact_phone?: string | null;
  city?: string | null;
  country?: string | null;
  /** @format date-time */
  created_at?: string;
  full_address?: string | null;
  hours?: string[] | null;
  integration_id?: string | null;
  integration_name?: string | null;
  /** @format double */
  latitude?: number | null;
  local_time_zone?: string | null;
  /** @format int32 */
  location_id?: number;
  /** @format double */
  longitude?: number | null;
  merchant?: NetsuiteLocationMerchantView;
  name?: string | null;
  phone?: string | null;
  state?: string | null;
  street_address?: string | null;
  /** @format date-time */
  updated_at?: string;
  zipcode?: string | null;
}

export interface NetsuiteLocationViewFilter {
  operands?: NetsuiteLocationViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface NetsuiteLocationViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: NetsuiteLocationView[] | null;
  meta?: NetsuiteLocationViewPaginatableResponseMetadata;
}

export interface NetsuiteLocationViewPaginatableRequest {
  filter?: NetsuiteLocationViewFilter;
  pagination?: NetsuiteLocationViewPagination;
  search_text?: string | null;
}

export interface NetsuiteLocationViewPaginatableResponseMetadata {
  filter?: NetsuiteLocationViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface NetsuiteLocationViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface NetsuitePaymentView {
  address?: string | null;
  /** @format date-time */
  created_at?: string;
  /** @format int32 */
  id?: number;
  invoice_ids?: number[] | null;
  /** @format date-time */
  last_updated_at?: string;
  /** @format int32 */
  operator_id?: number;
  /** @format double */
  spot_price?: number;
  /** @format double */
  total_amount?: number;
  txid?: string | null;
}

export interface NetsuitePaymentViewFilter {
  operands?: NetsuitePaymentViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface NetsuitePaymentViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: NetsuitePaymentView[] | null;
  meta?: NetsuitePaymentViewPaginatableResponseMetadata;
}

export interface NetsuitePaymentViewPaginatableRequest {
  filter?: NetsuitePaymentViewFilter;
  pagination?: NetsuitePaymentViewPagination;
  search_text?: string | null;
}

export interface NetsuitePaymentViewPaginatableResponseMetadata {
  filter?: NetsuitePaymentViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface NetsuitePaymentViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface NetsuiteSaleAtmView {
  /** @format int32 */
  atm_id?: number;
  name?: string | null;
  serial?: string | null;
}

export interface NetsuiteSaleCustomerView {
  /** First name. */
  first_name?: string | null;
  /** Last name. */
  last_name?: string | null;
  /** Phone number. */
  phone_number?: string | null;
}

export interface NetsuiteSaleView {
  /** The customer's wallet address */
  address?: string | null;
  /** Primary key identifier for affiliate resource and is not null if sale has affiliate association */
  affiliate_id?: string | null;
  /** Affiliate name associated with the sale, if applicable */
  affiliate_name?: string | null;
  atm?: NetsuiteSaleAtmView;
  /**
   * Batch resource identifier primary key and is not null if sale was batched in Bitcoin network
   * @format int32
   */
  batch_id?: number | null;
  /** Boolean to determine if sale was batched during broadcasting to Bitcoin network */
  batched?: boolean;
  /**
   * The rate of Bitcoin at the time of sale creation
   * @format double
   */
  bitstop_rate?: number | null;
  cash_pull_id?: string | null;
  /** The type of cryptocurrency involved in the sale */
  coin_type?: string | null;
  /**
   * Gets or sets the UTC DateTime when the record was created.
   * @format date-time
   */
  created_at?: string;
  /**
   * Gets the TimeSpan representing the time zone offset from UTC for the creation time.
   * This offset helps in filtering and displaying times in the context of the local time zone.
   */
  created_at_time_zone_offset?: string | null;
  /**
   * Gets the local DateTime of the record creation based on the ATM's timezone.
   * This time is converted from UTC to the local time zone specified in LocalTimeZone.
   * @format date-time
   */
  created_at_transaction_local?: string;
  /**
   * The amount of digital currency to send to customer wallet address
   * @format double
   */
  crypto_amount?: number | null;
  /** The currency used in the sale */
  currency_code?: string | null;
  customer?: NetsuiteSaleCustomerView;
  /**
   * The Customer resource's primary key identifier
   * @format int32
   */
  customer_id?: number;
  /**
   * The fee amount for processing the sale
   * @format double
   */
  fee?: number | null;
  /**
   * The Sale resource primay key identifier
   * @format int32
   */
  id?: number | null;
  /**
   * The amount of cash inserted into the Atm when sale was created
   * @format float
   */
  inserted?: number | null;
  integration_id?: string | null;
  integration_name?: string | null;
  /**
   * Sale date and time in the local time zone of the atm
   * @format date-time
   */
  local_created_at?: string;
  /** IANA time zone name for the local time zone of the atm */
  local_time_zone?: string | null;
  /** @format float */
  netsuite_quantity?: number | null;
  /** @format float */
  netsuite_rate?: number | null;
  /**
   * The operator fee amount in cryptocurrency
   * @format float
   */
  operator_fee?: number | null;
  /** Flag to determine if operator fee was collected for the sale */
  operator_fee_collected?: boolean;
  /**
   * The crypocurrency rate at which the operator fee was calculated
   * @format float
   */
  operator_fee_rate?: number | null;
  /**
   * The operator fee amount in USD
   * @format float
   */
  operator_fee_usd?: number | null;
  /** Buy or sell side sale type */
  order_type?: string | null;
  /**
   * The amount of satoshis to send to customer wallet address
   * @format double
   */
  satoshis?: number | null;
  /**
   * The amount of bitcoin sent
   * @format float
   */
  sent?: number | null;
  /**
   * Represents the difference between the spot price and the bitstop rate at the time of the transaction.
   * @format float
   */
  spread?: number | null;
  /** The state of the sale (is it completed, started or partial?) */
  stage?: string | null;
  /** The blockchain transaction hash identifier */
  transaction_hash?: string | null;
  /**
   * Gets or sets the UTC DateTime when the record was updated.
   * @format date-time
   */
  updated_at?: string;
  /**
   * Gets the TimeSpan representing the time zone offset from UTC for the update time.
   * This offset is crucial for operations and representations that are sensitive to time zones.
   */
  updated_at_time_zone_offset?: string | null;
  /**
   * Gets the local DateTime of the record update based on the ATM's timezone.
   * This time is converted from UTC to the local time zone specified in LocalTimeZone.
   * @format date-time
   */
  updated_at_transaction_local?: string;
}

export interface NetsuiteSaleViewFilter {
  operands?: NetsuiteSaleViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface NetsuiteSaleViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: NetsuiteSaleView[] | null;
  meta?: NetsuiteSaleViewPaginatableResponseMetadata;
}

export interface NetsuiteSaleViewPaginatableRequest {
  filter?: NetsuiteSaleViewFilter;
  pagination?: NetsuiteSaleViewPagination;
  search_text?: string | null;
}

export interface NetsuiteSaleViewPaginatableResponseMetadata {
  filter?: NetsuiteSaleViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface NetsuiteSaleViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface NetsuiteSalesUpdatedListParams {
  /** @format date-time */
  since?: string;
}

/** ATM view for nonce users. */
export interface NonceAtmListView {
  /** Id of the affiliate this atm is managed by, if applicable. */
  affiliate_id?: string | null;
  /** Robotface client version. */
  app_version?: string | null;
  /** @format int32 */
  barcode_scanner_status?: number | null;
  /** @format int32 */
  bill_acceptor_status?: number | null;
  /** A generic Dictionary of */
  bill_denominations?: Record<string, number>;
  /** @format int32 */
  bill_dispenser_status?: number | null;
  /** @format int32 */
  bulk_note_recycler_status?: number | null;
  /** @format int32 */
  card_reader_status?: number | null;
  city?: string | null;
  country?: string | null;
  /**
   * When the ATM was created.
   * @format date-time
   */
  created_at?: string;
  currency?: string | null;
  /** This is a list of enabled coins for atm. */
  enabled_coin_ids?: string[] | null;
  /** This is a list of enabled precious metals for atm. */
  enabled_precious_metal_ids?: string[] | null;
  epp_kcv?: string | null;
  /** @format int32 */
  epp_key_index?: number | null;
  epp_key_mode?: EppKeyModeEnum;
  epp_key_status?: EppKeyStatusEnum;
  /**
   * Resources made taggable after they already exist get a new global id
   * to ensure uniqueness within the 'taggable' table. Resources will continue
   * to support their existing id property.
   * @format uuid
   */
  global_id?: string;
  /**
   * Identity of the atm in the source domain service (Boro)
   * @format int32
   */
  id?: number;
  /** @format int32 */
  imaging_device_status?: number | null;
  /** Id of the Integration. */
  integration_id?: string | null;
  is_bill_dispenser_available?: boolean;
  is_bill_dispenser_low?: boolean;
  /**
   * The datetime object for the last machine restart,
   * or null if no restart can be found.
   * Use this value if you want to filter based on it, but use
   * the humanized version AthenaService.Web.ClientModels.v2.NonceDashboard.Atms.NonceAtmListView.LastRestartHumanized
   * for display in the UI.
   * @format date-time
   */
  last_restart?: string | null;
  /**
   * The humanized text value for the last restart AthenaService.Web.ClientModels.v2.NonceDashboard.Atms.NonceAtmListView.LastRestart
   * This is a computed field so it cannot be filtered on. Filter on the datetime version of this value instead.
   */
  last_restart_humanized?: string | null;
  /** @format date-time */
  last_robot_heartbeat_created_at?: string | null;
  /**
   * The humanized text value for the last heartbeat created AthenaService.Web.ClientModels.v2.NonceDashboard.Atms.NonceAtmListView.LastRobotHeartbeatCreatedAt
   * This is a computed field so it cannot be filtered on. Filter on the datetime version of this value instead.
   */
  last_robot_heartbeat_created_at_humanized?: string | null;
  last_sale?: LastSaleDto;
  /** @format date-time */
  last_sale_created_at?: string | null;
  /**
   * The humanized text value for the last sale AthenaService.Web.ClientModels.v2.NonceDashboard.Atms.NonceAtmListView.LastSaleCreatedAt
   * This is a computed field so it cannot be filtered on. Filter on the datetime version of this value instead.
   */
  last_sale_created_at_humanized?: string | null;
  /**
   * Timestamp for the last machine heartbeat.
   * @format date-time
   */
  last_seen?: string | null;
  /**
   * The humanized text value for the last heartbeat created AthenaService.Web.ClientModels.v2.NonceDashboard.Atms.NonceAtmListView.LastSeen
   * This is a computed field so it cannot be filtered on. Filter on the datetime version of this value instead.
   */
  last_seen_humanized?: string | null;
  /** Live denomination breakdown backing AthenaService.Web.ClientModels.v2.NonceDashboard.Atms.NonceAtmListView.LiveCash. */
  live_bill_denominations?: Record<string, number>;
  /**
   * Live cash currently in the box, derived from the box-clear boundary.
   * Distinct from the heartbeat-reported AthenaService.Web.ClientModels.v2.NonceDashboard.Atms.NonceAtmListView.TotalWorthOfBills.
   * @format double
   */
  live_cash?: number | null;
  /**
   * Live total quantity of all bills for all denominations, backing AthenaService.Web.ClientModels.v2.NonceDashboard.Atms.NonceAtmListView.LiveCash.
   * @format int32
   */
  live_total_amount_of_bills?: number | null;
  location?: NonceLocationShortView;
  /** @format int32 */
  location_id?: number | null;
  location_name?: string | null;
  location_slug?: string | null;
  /** Physical lock identifier */
  lock_serial_number?: string | null;
  /** Description of lock combination/key */
  lock_set_to?: string | null;
  /**
   * Identifier created by the machine when it first turns on, OR when it is factory reset. (Uniquely identifies an ATMs "state" in Bitstop system.
   *  AtmId can be used to uniquely identify the ATM ACROSS states, even if it has been reset.
   * Since a factory reset ATM cannot know what its old atm id was on boot, this field is
   * necessary.)
   */
  machine_id?: string | null;
  /** Modem hardware identifier */
  modem_serial?: string | null;
  /** Friendly human name operators can pick for an ATM. */
  name?: string | null;
  note_dispenser_cassettes?: CassetteView[] | null;
  /** Padlock presence/type */
  padlock?: string | null;
  /** @format int32 */
  phidget_board_status?: number | null;
  pick_up_id?: string | null;
  /**
   * Percentage of time when the atm was online in the 30 days prior to previous 30 days
   * @format double
   */
  previous_thirty_days_uptime_percentage?: number;
  /** @format int32 */
  printer_status?: number | null;
  /**
   * Indicates the rank of the ATM based on historical sales performance.
   * The rank is calculated compared to other ATMs belonging to the same operator.
   * A rank of 1 indicates the best performing ATM, while a higher number indicates a lower performance.
   * @format int32
   */
  sales_performance_rank?: number;
  /**
   * A unique identifier physically present on the hardware of the machine.
   * Uniqueness is only guaranteed per manufacturer (genmega, kiosk, etc.)
   * Installers input this into the system during QA of a new machine. It is possible for
   * them to enter an incorrect value (twice) which can be annoying and requires manually fixing.
   */
  serial?: string | null;
  /**
   * A unique location string concatenated from address fields. (See this code for source (I think).
   * https://github.com/bitstopco/locations_service/blob/5083f20f360e268c568e86dfb4513bb21f113b95/locations_service.Web/Models/Location.cs#L43)
   */
  slug?: string | null;
  state?: string | null;
  status?: MachineStatus;
  street_address?: string | null;
  /** List of tag ids associated to this resource. */
  tag_ids?: string[] | null;
  /**
   * Percentage of time when the atm was online in the last 30 days
   * @format double
   */
  thirty_days_uptime_percentage?: number;
  /**
   * Total quantity of all bills for all denominations.
   * @format int32
   */
  total_amount_of_bills?: number | null;
  /**
   * Total (monetary) value of all bills for all denominations.
   * @format double
   */
  total_worth_of_bills?: number | null;
  zipcode?: string | null;
}

/**
 * Common enumerable atm response that is intended to be used with any type of
 * atm projection.
 */
export interface NonceAtmListViewEnumerableAtmActionResponse {
  correlation_id?: string | null;
  data?: NonceAtmListView[] | null;
  /** Schema for the included property of atm action responses. */
  included?: AtmIncluded;
  meta?: NonceAtmListViewPaginatableResponseMetadata;
}

export interface NonceAtmListViewFilter {
  operands?: NonceAtmListViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface NonceAtmListViewPaginatableRequest {
  filter?: NonceAtmListViewFilter;
  pagination: NonceAtmListViewPagination;
  search_text?: string | null;
}

export interface NonceAtmListViewPaginatableResponseMetadata {
  filter?: NonceAtmListViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface NonceAtmListViewPagination {
  /**
   * @format int32
   * @min 1
   */
  current_page?: number;
  /**
   * @format int32
   * @min 1
   * @max 1000
   */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface NonceAtmLocationHistoryView {
  /** @format date-time */
  date_time_installed?: string;
  /** @format date-time */
  date_time_uninstalled?: string | null;
  full_address?: string | null;
  /** @format int32 */
  id?: number;
  name?: string | null;
  operator_location_name?: string | null;
  slug?: string | null;
}

/** ATM view for nonce users. */
export interface NonceAtmSingleView {
  /** Id of the affiliate this atm is managed by, if applicable. */
  affiliate_id?: string | null;
  /** Robotface client version. */
  app_version?: string | null;
  /** Flag to indicate if backline post provision is enabled. */
  bankline_post_provision?: boolean;
  /** @format int32 */
  barcode_scanner_status?: number | null;
  /** @format int32 */
  bill_acceptor_status?: number | null;
  /** A generic Dictionary of */
  bill_denominations?: Record<string, number>;
  /** @format int32 */
  bill_dispenser_status?: number | null;
  /** @format int32 */
  bulk_note_recycler_status?: number | null;
  /** @format int32 */
  card_reader_status?: number | null;
  /**
   * When the ATM was created.
   * @format date-time
   */
  created_at?: string;
  currency?: string | null;
  /** This is a list of enabled coins for atm. */
  enabled_coin_ids?: string[] | null;
  /** This is a list of enabled precious metals for atm. */
  enabled_precious_metal_ids?: string[] | null;
  epp_kcv?: string | null;
  /** @format int32 */
  epp_key_index?: number | null;
  epp_key_mode?: EppKeyModeEnum;
  epp_key_status?: EppKeyStatusEnum;
  /**
   * Resources made taggable after they already exist get a new global id
   * to ensure uniqueness within the 'taggable' table. Resources will continue
   * to support their existing id property.
   * @format uuid
   */
  global_id?: string;
  /**
   * Identity of the atm in the source domain service (Boro)
   * @format int32
   */
  id?: number;
  /** @format int32 */
  imaging_device_status?: number | null;
  /** Id of the Integration. */
  integration_id?: string | null;
  is_dispenser_initialized?: boolean;
  /**
   * The datetime object for the last machine restart,
   * or null if no restart can be found.
   * Use this value if you want to filter based on it, but use
   * the humanized version AthenaService.Web.ClientModels.v2.NonceDashboard.Atms.NonceAtmSingleView.LastRestartHumanized
   * for display in the UI.
   * @format date-time
   */
  last_restart?: string | null;
  /**
   * The humanized text value for the last restart AthenaService.Web.ClientModels.v2.NonceDashboard.Atms.NonceAtmSingleView.LastRestart
   * This is a computed field so it cannot be filtered on. Filter on the datetime version of this value instead.
   */
  last_restart_humanized?: string | null;
  /** @format date-time */
  last_robot_heartbeat_created_at?: string | null;
  /**
   * The humanized text value for the last heartbeat created AthenaService.Web.ClientModels.v2.NonceDashboard.Atms.NonceAtmSingleView.LastRobotHeartbeatCreatedAt
   * This is a computed field so it cannot be filtered on. Filter on the datetime version of this value instead.
   */
  last_robot_heartbeat_created_at_humanized?: string | null;
  last_sale?: LastSaleDto;
  /** @format date-time */
  last_sale_created_at?: string | null;
  /**
   * The humanized text value for the last sale AthenaService.Web.ClientModels.v2.NonceDashboard.Atms.NonceAtmSingleView.LastSaleCreatedAt
   * This is a computed field so it cannot be filtered on. Filter on the datetime version of this value instead.
   */
  last_sale_created_at_humanized?: string | null;
  /**
   * Timestamp for the last machine heartbeat.
   * @format date-time
   */
  last_seen?: string | null;
  /**
   * The humanized text value for the last heartbeat created AthenaService.Web.ClientModels.v2.NonceDashboard.Atms.NonceAtmSingleView.LastSeen
   * This is a computed field so it cannot be filtered on. Filter on the datetime version of this value instead.
   */
  last_seen_humanized?: string | null;
  /** Live denomination breakdown backing AthenaService.Web.ClientModels.v2.NonceDashboard.Atms.NonceAtmSingleView.LiveCash. */
  live_bill_denominations?: Record<string, number>;
  /**
   * Live cash currently in the box, derived from the box-clear boundary.
   * Distinct from the heartbeat-reported AthenaService.Web.ClientModels.v2.NonceDashboard.Atms.NonceAtmSingleView.TotalWorthOfBills.
   * @format double
   */
  live_cash?: number | null;
  /**
   * Live total quantity of all bills for all denominations, backing AthenaService.Web.ClientModels.v2.NonceDashboard.Atms.NonceAtmSingleView.LiveCash.
   * @format int32
   */
  live_total_amount_of_bills?: number | null;
  location?: AtmLocationDataView;
  location_history?: NonceAtmLocationHistoryView[] | null;
  /** Physical lock identifier */
  lock_serial_number?: string | null;
  /** Description of lock combination/key */
  lock_set_to?: string | null;
  /**
   * Identifier created by the machine when it first turns on, OR when it is factory reset. (Uniquely identifies an ATMs "state" in Bitstop system.
   *  AtmId can be used to uniquely identify the ATM ACROSS states, even if it has been reset.
   * Since a factory reset ATM cannot know what its old atm id was on boot, this field is
   * necessary.)
   */
  machine_id?: string | null;
  manufacturer?: MachineManufacturer;
  /** Modem hardware identifier */
  modem_serial?: string | null;
  /** Friendly human name operators can pick for an ATM. */
  name?: string | null;
  note_dispenser_cassettes?: CassetteView[] | null;
  /** Padlock presence/type */
  padlock?: string | null;
  /** @format int32 */
  phidget_board_status?: number | null;
  pick_up_id?: string | null;
  /**
   * Percentage of time when the atm was online in the 30 days prior to previous 30 days
   * @format double
   */
  previous_thirty_days_uptime_percentage?: number;
  /** @format int32 */
  printer_status?: number | null;
  /**
   * A unique identifier physically present on the hardware of the machine.
   * Uniqueness is only guaranteed per manufacturer (genmega, kiosk, etc.)
   * Installers input this into the system during QA of a new machine. It is possible for
   * them to enter an incorrect value (twice) which can be annoying and requires manually fixing.
   */
  serial?: string | null;
  /**
   * A unique location string concatenated from address fields. (See this code for source (I think).
   * https://github.com/bitstopco/locations_service/blob/5083f20f360e268c568e86dfb4513bb21f113b95/locations_service.Web/Models/Location.cs#L43)
   */
  slug?: string | null;
  status?: MachineStatus;
  /** List of tag ids associated to this resource. */
  tag_ids?: string[] | null;
  /**
   * Percentage of time when the atm was online in the last 30 days
   * @format double
   */
  thirty_days_uptime_percentage?: number;
  /**
   * Total quantity of all bills for all denominations.
   * @format int32
   */
  total_amount_of_bills?: number | null;
  /**
   * Total (monetary) value of all bills for all denominations.
   * @format double
   */
  total_worth_of_bills?: number | null;
}

/**
 * Common enumerable atm response that is intended to be used with any type of
 * atm projection.
 */
export interface NonceAtmSingleViewAtmActionResponse {
  correlation_id?: string | null;
  /** ATM view for nonce users. */
  data?: NonceAtmSingleView;
  /** Schema for the included property of atm action responses. */
  included?: AtmIncluded;
}

export interface NonceAtmViewExportFilter {
  operands?: NonceAtmViewExportFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface NonceAtmViewExportFilterableRequest {
  filter?: NonceAtmViewExportFilter;
  search_text?: string | null;
}

/**
 * This request services to create or update the banners in Nonce UI
 * to taking people from V1 to V2 and vice versa
 */
export interface NonceBannerRequest {
  banner_type?: Severity;
  /**
   * Message that will be shown in the banner.
   * @minLength 1
   * @maxLength 1000
   */
  message: string;
  /**
   * Relative url path to the other nonce version of the page.
   * So if this page is for v1, the relative button url should be to v2.
   * This allows for the action button to take the user to the other nonce page
   * @minLength 1
   */
  relative_page_url: string;
}

export interface NonceBannerSingleView {
  banner_type?: Severity;
  id?: string | null;
  /**
   * Message content of the banner. (Note here that there are some validation contraints on the Banner resource message field.
   * There is a limit of 1000 characters that can be stored.)
   */
  message?: string | null;
  /**
   * The relative URL (missing base for use by consuming client) for which
   * to redirect customer on client from Banner display.
   */
  relative_page_url?: string | null;
}

export interface NonceBannerSingleViewIActionDataResponse {
  correlation_id?: string | null;
  data?: NonceBannerSingleView;
}

export interface NonceBannerSingleViewListIActionDataResponse {
  correlation_id?: string | null;
  data?: NonceBannerSingleView[] | null;
}

/** Batch view for nonce users. */
export interface NonceBatchView {
  /** Used to know if batch is closed and it doesn't receive more transactions. */
  closed?: boolean;
  /**
   * Creation date of the batch.
   * @format date-time
   */
  created_at?: string;
  /** Used to know if the batch was paid. */
  funded?: boolean;
  /**
   * Batch Iidentifier.
   * @format int32
   */
  id?: number;
  /** URL to blockchain explorer, such as Blocksteam, for the Transaction Hash of the sale. */
  transaction_hash_url?: string | null;
  /**
   * Limit for transactions into the batch.
   * @format int32
   */
  tx_count?: number;
  /** Table transaction identifier. */
  tx_hash?: string | null;
  /**
   * Update date of the batch.
   * @format date-time
   */
  updated_at?: string;
}

export interface NonceBatchViewFilter {
  operands?: NonceBatchViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface NonceBatchViewIActionDataResponse {
  correlation_id?: string | null;
  /** Batch view for nonce users. */
  data?: NonceBatchView;
}

export interface NonceBatchViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: NonceBatchView[] | null;
  meta?: NonceBatchViewPaginatableResponseMetadata;
}

export interface NonceBatchViewPaginatableRequest {
  filter?: NonceBatchViewFilter;
  pagination: NonceBatchViewPagination;
  search_text?: string | null;
}

export interface NonceBatchViewPaginatableResponseMetadata {
  filter?: NonceBatchViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface NonceBatchViewPagination {
  /**
   * @format int32
   * @min 1
   */
  current_page?: number;
  /**
   * @format int32
   * @min 1
   * @max 1000
   */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

/** WIP for the customer view model. Ensuring we can filter by policy. */
export interface NonceCustomerView {
  /** Address. */
  address?: string | null;
  address_enrollment_policy?: CustomerEnrollmentView;
  basic_info_enrollment_policy?: CustomerEnrollmentView;
  /** City. */
  city?: string | null;
  /** Country. */
  country?: string | null;
  /** List of the id's of the linked customers. */
  customer_links?: number[] | null;
  /**
   * Date of birth.
   * @format date-time
   */
  date_of_birth?: string | null;
  date_of_birth_enrollment_policy?: CustomerEnrollmentView;
  /**
   * Created date
   * @format date-time
   */
  enrolled_on?: string;
  /**
   * Represents the EnrollmentAtm as a POCO without json serializer rules.
   * This ensures the db model is not tied to the view model for serialization rules.
   */
  enrollment_atm?: NonceEnrollmentAtmView;
  /** First name. */
  first_name?: string | null;
  /** Full name. */
  full_name?: string | null;
  /**
   * Resources made taggable after they already exist get a new global id
   * to ensure uniqueness within the 'taggable' table. Resources will continue
   * to support their existing id property.
   * @format uuid
   */
  global_id?: string;
  government_id_and_selfie_enrollment_policy?: CustomerEnrollmentView;
  government_id_number_enrollment_policy?: CustomerEnrollmentView;
  /**
   * Indicates whether the ManualApprovalEnrollmentPolicy property values are relevant.
   * That is, true if the policy exists for the current operator, otherwise false.
   * This is because of a limitation that we currently have that does not allow null to be projected with a ternary conditional operator.
   */
  has_manual_approval_enrollment_policy?: boolean;
  /**
   * PK Id of the customer according to unity.
   * @format int32
   */
  id?: number;
  id_number?: string | null;
  /**
   * True if customer enrolled with the operator making the request,
   * false otherwise.
   */
  is_enrolling_operator?: boolean;
  kyc_note_type?: KycNoteTypeEnum;
  kyc_status?: KycStatusEnum;
  /** Last name. */
  last_name?: string | null;
  manual_approval_enrollment_policy?: CustomerEnrollmentView;
  occupation_enrollment_policy?: CustomerEnrollmentView;
  /** Phone number. */
  phone_number?: string | null;
  proof_of_income_enrollment_policy?: CustomerEnrollmentView;
  ssn_enrollment_policy?: CustomerEnrollmentView;
  /** State. */
  state?: string | null;
  /** List of tag ids associated to this resource. */
  tag_ids?: string[] | null;
  /**
   * CustomerOperator Total Fiat.
   * @format double
   */
  total_fiat?: number;
  /** Use this class to represent a summary stats of the transactions list. */
  transaction_stats?: TransactionStatsView;
  /** Zipcode. */
  zipcode?: string | null;
}

/** Implementation of IPaginatableActionResponse with a Included property added for extra data. */
export interface NonceCustomerViewCustomerIncludedPaginatableActionResponse {
  correlation_id?: string | null;
  data?: NonceCustomerView[] | null;
  /** Schema for the included property of customer action responses. */
  included?: CustomerIncluded;
  meta?: NonceCustomerViewPaginatableResponseMetadata;
}

export interface NonceCustomerViewFilter {
  operands?: NonceCustomerViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface NonceCustomerViewFilterableRequest {
  filter?: NonceCustomerViewFilter;
  search_text?: string | null;
}

export interface NonceCustomerViewPaginatableRequest {
  filter?: NonceCustomerViewFilter;
  pagination: NonceCustomerViewPagination;
  search_text?: string | null;
}

export interface NonceCustomerViewPaginatableResponseMetadata {
  filter?: NonceCustomerViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface NonceCustomerViewPagination {
  /**
   * @format int32
   * @min 1
   */
  current_page?: number;
  /**
   * @format int32
   * @min 1
   * @max 1000
   */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

/**
 * Represents the EnrollmentAtm as a POCO without json serializer rules.
 * This ensures the db model is not tied to the view model for serialization rules.
 */
export interface NonceEnrollmentAtmView {
  /**
   * PK identity of the machine according to our backend service, boro.
   * @format int32
   * @example 42
   */
  atm_id?: number | null;
  /**
   * Identify of the ATM generated by our software on the machine. (Original KIOSK machine ids have semantic meaning based on positions of some
   * characters, whereas new Genmega machines have plain UUIDs.)
   */
  machine_id?: string | null;
  /**
   * Friendly name the operator may choose for an ATM
   * @example "
   *             City Gas
   *             "
   */
  name?: string | null;
  /**
   * Identity of the machine according to the manufacturer.
   * Kiosks tends to be numeric,
   * Genmegas tend to be alphanumeric.
   */
  serial?: string | null;
}

export interface NonceLocationShortView {
  address2?: string | null;
  city?: string | null;
  country?: string | null;
  full_address?: string | null;
  /** @format int32 */
  id?: number;
  /** @format double */
  latitude?: number | null;
  local_time_zone?: string | null;
  /** @format double */
  longitude?: number | null;
  name?: string | null;
  slug?: string | null;
  state?: string | null;
  street_address?: string | null;
  zipcode?: string | null;
}

/** A role assignable in the nonce dashboard, shaped like the payload ergot's GET /roles returns. */
export interface NonceRoleView {
  /**
   * When the role was created
   * @format date-time
   */
  created_at?: string;
  /** Explanation of what the role grants, shown next to the role picker */
  description?: string | null;
  /**
   * Identifier of the role
   * @format int32
   */
  id?: number;
  /** Display name of the role, and the name its auth0 counterpart carries */
  name?: string | null;
  /**
   * Rank of the role, where a lower value outranks a higher one
   * @format int32
   */
  priority?: number | null;
  /**
   * When the role was last changed
   * @format date-time
   */
  updated_at?: string;
}

export interface NonceRoleViewListIActionDataResponse {
  correlation_id?: string | null;
  data?: NonceRoleView[] | null;
}

export interface NonceSalesListViewFilter {
  operands?: NonceSalesListViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface NonceSingleCustomerView {
  /** Customer's street address. */
  address?: string | null;
  address_enrollment_policy?: CustomerEnrollmentView;
  /**
   * Computed property to calculate the age.
   * @format int32
   */
  age?: number | null;
  basic_info_enrollment_policy?: CustomerEnrollmentView;
  /** City. */
  city?: string | null;
  /** Country. */
  country?: string | null;
  /**
   * Customer's Date of Birthday.
   * @format date-time
   */
  date_of_birth?: string | null;
  date_of_birth_enrollment_policy?: CustomerEnrollmentView;
  /**
   * Customer's Date of enrollment
   * @format date-time
   */
  enrolled_on?: string;
  /**
   * Represents the EnrollmentAtm as a POCO without json serializer rules.
   * This ensures the db model is not tied to the view model for serialization rules.
   */
  enrollment_machine?: NonceEnrollmentAtmView;
  /** Customer's first name. */
  first_name?: string | null;
  /** Full name. */
  full_name?: string | null;
  /**
   * Resources made taggable after they already exist get a new global id
   * to ensure uniqueness within the 'taggable' table. Resources will continue
   * to support their existing id property.
   * @format uuid
   */
  global_id?: string;
  government_id_and_selfie_enrollment_policy?: CustomerEnrollmentView;
  government_id_number_enrollment_policy?: CustomerEnrollmentView;
  /**
   * Indicates whether the ManualApprovalEnrollmentPolicy property values are relevant.
   * That is, true if the policy exists for the current operator, otherwise false.
   * This is because of a limitation that we currently have that does not allow null to be projected with a ternary conditional operator.
   */
  has_manual_approval_enrollment_policy?: boolean;
  /**
   * PK Id of the customer according to unity.
   * @format int32
   */
  id?: number;
  /** Customer's government issued id number. */
  id_number?: string | null;
  /** GUID of customer's Occupation Industry */
  industry_id?: string | null;
  kyc_note_type?: KycNoteTypeEnum;
  kyc_status?: KycStatusEnum;
  /** Customer's last name. */
  last_name?: string | null;
  manual_approval_enrollment_policy?: CustomerEnrollmentView;
  occupation_enrollment_policy?: CustomerEnrollmentView;
  /** Customer's phone number. */
  phone_number?: string | null;
  /** GUID of customer's Occupation Position */
  position_id?: string | null;
  proof_of_income_enrollment_policy?: CustomerEnrollmentView;
  ssn_enrollment_policy?: CustomerEnrollmentView;
  /** State. */
  state?: string | null;
  /** List of tag ids associated to this resource. */
  tag_ids?: string[] | null;
  /** Zipcode. */
  zipcode?: string | null;
}

export interface NonceSingleCustomerViewIActionDataResponse {
  correlation_id?: string | null;
  data?: NonceSingleCustomerView;
}

export interface NonceTransactionBillsView {
  /** @format int32 */
  fifty?: number;
  /** @format int32 */
  five?: number;
  /** @format int32 */
  one?: number;
  /** @format int32 */
  one_hundred?: number;
  /** @format int32 */
  ten?: number;
  /** @format int32 */
  twenty?: number;
  /** @format int32 */
  two?: number;
}

/**
 * Minimal projection of the coupon used on a sale, for the Nonce transaction views/drawer.
 * Source: `sale.coupon` jsonb, populated by the CouponUsedEvent consumer (see DEV-770).
 * Null when the sale didn't use a coupon.
 */
export interface NonceTransactionCouponView {
  code?: string | null;
  discount_type?: string | null;
  discount_value?: string | null;
  /** @format date-time */
  redeemed_at?: string | null;
}

/**
 * Minimal projection of the sale's OFAC state for the Nonce drawer.
 * Only `status` (pending | cleared | matched) is exposed today; the
 * source `ofac_state` jsonb has more fields we intentionally omit —
 * add them here (and in the projections) if the UI ever needs them.
 */
export interface NonceTransactionOfacStateView {
  status?: string | null;
}

export interface NonceTransactionSaleAuditsView {
  /** Additional data about the transaction state */
  data?: any;
  /** State of the transaction */
  stage?: string | null;
  /**
   * Date and time when the transaction state update was made
   * @format date-time
   */
  updated_at?: string;
}

/** Transcation view for nonce users. */
export interface NonceTransactionView {
  address?: string | null;
  affiliate_id?: string | null;
  asset?: DispenseAssetView;
  asset_id?: string | null;
  asset_type?: string | null;
  atm?: SaleAtm;
  /** @format int32 */
  atm_id?: number | null;
  /** @format int32 */
  batch_id?: number | null;
  batched?: boolean;
  bills?: NonceTransactionBillsView;
  coin?: CoinView;
  coin_id?: string | null;
  coin_type?: string | null;
  /**
   * Minimal projection of the coupon used on a sale, for the Nonce transaction views/drawer.
   * Source: `sale.coupon` jsonb, populated by the CouponUsedEvent consumer (see DEV-770).
   * Null when the sale didn't use a coupon.
   */
  coupon_used?: NonceTransactionCouponView;
  /** @format date-time */
  created_at?: string;
  created_at_humanized?: string | null;
  /** @format double */
  crypto_amount?: number;
  currency_code?: string | null;
  customer?: SaleCustomer;
  /** @format int32 */
  customer_id?: number;
  /** Dispense(s) for this sale: expected vs successful vs rejected bills (for precious metal / asset dispenses). */
  dispenses?: SaleDispenseView[] | null;
  /** @format double */
  fee?: number;
  /**
   * Resources made taggable after they already exist get a new global id
   * to ensure uniqueness within the 'taggable' table. Resources will continue
   * to support their existing id property.
   * @format uuid
   */
  global_id?: string;
  id?: string | null;
  /** @format double */
  inserted?: number;
  /**
   * Sale date and time in the local time zone of the atm
   * @format date-time
   */
  local_created_at?: string;
  /** The humanized text value for AthenaService.Web.ClientModels.v2.NonceDashboard.Transactions.NonceTransactionView.LocalCreatedAt */
  local_created_at_humanized?: string | null;
  /** IANA time zone name for the local time zone of the atm */
  local_time_zone?: string | null;
  location?: NonceLocationShortView;
  /**
   * Location id of the atm where the sale took place.
   * @format int32
   */
  location_id?: number | null;
  /** @format int32 */
  model_id?: number | null;
  /**
   * Minimal projection of the sale's OFAC state for the Nonce drawer.
   * Only `status` (pending | cleared | matched) is exposed today; the
   * source `ofac_state` jsonb has more fields we intentionally omit —
   * add them here (and in the projections) if the UI ever needs them.
   */
  ofac_state?: NonceTransactionOfacStateView;
  /** @format float */
  operator_fee?: number | null;
  operator_fee_collected?: boolean;
  /** @format float */
  operator_fee_rate?: number | null;
  /** @format float */
  operator_fee_usd?: number | null;
  /** @format int32 */
  operator_id?: number;
  order_type?: string | null;
  /** @format double */
  rate?: number | null;
  /** Log of the sale status changes. */
  sale_audits?: NonceTransactionSaleAuditsView[] | null;
  /** @format double */
  satoshis?: number | null;
  /** @format double */
  sent?: number;
  /**
   * An eight-ish character hash of the uuid that is friendlier for limited
   * character use-cases, like urls in sms. (https://github.com/skorokithakis/shortuuid)
   */
  short_uuid?: string | null;
  stage?: string | null;
  /**
   * Flattened copy of AthenaService.Web.ClientModels.v2.NonceDashboard.Transactions.NonceTransactionView.Location's state, purely so the generic table filter
   * (DynamicFilterBuilder, which only reflects over an entity's own top-level properties) can
   * filter sales by state -- it can't reach the nested Location.State. Use Location.State for display.
   */
  state?: string | null;
  /** List of tag ids associated to this resource. */
  tag_ids?: string[] | null;
  transaction_hash?: string | null;
  /** URL to blockchain explorer, such as Blocksteam, for the Transaction Hash of the sale. */
  transaction_hash_url?: string | null;
  /** @format date-time */
  updated_at?: string;
  uuid?: string | null;
}

export interface NonceTransactionViewExportFilter {
  operands?: NonceTransactionViewExportFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface NonceTransactionViewExportFilterableRequest {
  filter?: NonceTransactionViewExportFilter;
  search_text?: string | null;
}

export interface NonceTransactionViewFilter {
  operands?: NonceTransactionViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface NonceTransactionViewFilterableRequest {
  filter?: NonceTransactionViewFilter;
  search_text?: string | null;
}

export interface NonceTransactionViewIActionDataResponse {
  correlation_id?: string | null;
  /** Transcation view for nonce users. */
  data?: NonceTransactionView;
}

export interface NonceTransactionViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: NonceTransactionView[] | null;
  meta?: NonceTransactionViewPaginatableResponseMetadata;
}

export interface NonceTransactionViewPaginatableRequest {
  filter?: NonceTransactionViewFilter;
  pagination: NonceTransactionViewPagination;
  search_text?: string | null;
}

export interface NonceTransactionViewPaginatableResponseMetadata {
  filter?: NonceTransactionViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface NonceTransactionViewPagination {
  /**
   * @format int32
   * @min 1
   */
  current_page?: number;
  /**
   * @format int32
   * @min 1
   * @max 1000
   */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

/** A user of the nonce dashboard, shaped like the payload ergot's GET /users returns. */
export interface NonceUserView {
  /** Dialing code belonging to AthenaService.Web.ClientModels.v2.NonceDashboard.Users.NonceUserView.Phone */
  country_code?: string | null;
  /**
   * When the user was created
   * @format date-time
   */
  created_at?: string;
  /** Email address the user signs in with */
  email?: string | null;
  /** Given name of the user */
  first_name?: string | null;
  /**
   * Identifier of the user
   * @format int32
   */
  id?: number;
  /**
   * When the user last signed in, null until they have
   * @format date-time
   */
  last_login?: string | null;
  /** Family name of the user */
  last_name?: string | null;
  /** Whether an administrator has locked the account */
  locked_by_admin?: boolean;
  /** Whether the security policy has locked the account */
  locked_by_security_policy?: boolean;
  /** Contact number of the user */
  phone?: string | null;
  /**
   * Identifier of the role the user holds in the nonce dashboard
   * @format int32
   */
  role_id?: number;
  /**
   * When the user was last changed
   * @format date-time
   */
  updated_at?: string;
}

export interface NonceUserViewFilter {
  operands?: NonceUserViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface NonceUserViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: NonceUserView[] | null;
  meta?: NonceUserViewPaginatableResponseMetadata;
}

export interface NonceUserViewPaginatableRequest {
  filter?: NonceUserViewFilter;
  pagination: NonceUserViewPagination;
  search_text?: string | null;
}

export interface NonceUserViewPaginatableResponseMetadata {
  filter?: NonceUserViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface NonceUserViewPagination {
  /**
   * @format int32
   * @min 1
   */
  current_page?: number;
  /**
   * @format int32
   * @min 1
   * @max 1000
   */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface NoteDispenserView {
  /** @format int32 */
  atm_id?: number;
  /** @format int32 */
  cassette_count?: number;
  cassettes?: CassetteView[] | null;
  cdu_license_key?: string | null;
  cdu_type?: string | null;
  country_code?: string | null;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  device_status?: DeviceStatus;
  id?: string | null;
  /** @format date-time */
  initialized_at?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  manufacturer?: string | null;
  status_detail?: string | null;
  version?: string | null;
}

export interface NoteDispenserViewFilter {
  operands?: NoteDispenserViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface NoteDispenserViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: NoteDispenserView[] | null;
  meta?: NoteDispenserViewPaginatableResponseMetadata;
}

export interface NoteDispenserViewPaginatableRequest {
  filter?: NoteDispenserViewFilter;
  pagination?: NoteDispenserViewPagination;
  search_text?: string | null;
}

export interface NoteDispenserViewPaginatableResponseMetadata {
  filter?: NoteDispenserViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface NoteDispenserViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export enum NoteType {
  Fiat = 'fiat',
  Gold = 'gold',
}

export interface ObjectActionResponse {
  correlation_id?: string | null;
  data?: any;
  /** @deprecated */
  dictionaries?: any;
  errors?: ActionResponseDetail[] | null;
  included?: any;
  meta?: any;
  warnings?: ActionResponseDetail[] | null;
}

export interface ObjectIActionDataResponse {
  correlation_id?: string | null;
  data?: any;
}

export interface ObjectSource {
  example?: string | null;
  parameter?: string | null;
  pointer?: string | null;
}

export interface OccupationIndustryView {
  /** Unique identifier for the OccupationIndustry */
  id?: string | null;
  /** Name of the OccupationIndustry */
  name?: any;
}

export interface OccupationIndustryViewICollectionIActionDataResponse {
  correlation_id?: string | null;
  data?: OccupationIndustryView[] | null;
}

export interface OccupationPositionView {
  /** Unique identifier for the OccupationPosition */
  id?: string | null;
  /** Name of the OccupationPosition */
  name?: any;
}

export interface OccupationPositionViewICollectionIActionDataResponse {
  correlation_id?: string | null;
  data?: OccupationPositionView[] | null;
}

export interface OpenHours {
  fri?: DayOpenHours;
  mon?: DayOpenHours;
  sat?: DayOpenHours;
  sun?: DayOpenHours;
  thu?: DayOpenHours;
  tue?: DayOpenHours;
  wed?: DayOpenHours;
}

export interface OpenHoursSpan {
  close?: string | null;
  open?: string | null;
}

export interface OperationsIssuesStatsListParams {
  /** @format date-time */
  from?: string;
  /** @format date-time */
  to?: string;
}

export interface OperationsStatusesView {
  issue_types?: string[] | null;
  priorities?: string[] | null;
  record_statuses?: string[] | null;
  severities?: string[] | null;
  statuses?: string[] | null;
  task_types?: string[] | null;
  types?: string[] | null;
}

export interface OperationsStatusesViewIActionDataResponse {
  correlation_id?: string | null;
  data?: OperationsStatusesView;
}

export interface OperatorDataAffiliateView {
  id?: string | null;
  name?: string | null;
}

export interface OperatorDataAffiliateViewFilter {
  operands?: OperatorDataAffiliateViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface OperatorDataAffiliateViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: OperatorDataAffiliateView[] | null;
  meta?: OperatorDataAffiliateViewPaginatableResponseMetadata;
}

export interface OperatorDataAffiliateViewPaginatableRequest {
  filter?: OperatorDataAffiliateViewFilter;
  pagination?: OperatorDataAffiliateViewPagination;
  search_text?: string | null;
}

export interface OperatorDataAffiliateViewPaginatableResponseMetadata {
  filter?: OperatorDataAffiliateViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface OperatorDataAffiliateViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface OperatorDataAtmLocationView {
  /** @format int32 */
  atm_id?: number;
  /** @format date-time */
  date_time_installed?: string;
  /** @format date-time */
  date_time_uninstalled?: string | null;
}

export interface OperatorDataAtmView {
  /** Id of the affiliate this atm is managed by, if applicable. */
  affiliate_id?: string | null;
  /** Robotface client version. */
  app_version?: string | null;
  /** @format int32 */
  barcode_scanner_status?: number | null;
  /** @format int32 */
  bill_acceptor_status?: number | null;
  /** A generic Dictionary of */
  bill_denominations?: Record<string, number>;
  /** @format int32 */
  bill_dispenser_status?: number | null;
  /** @format int32 */
  bulk_note_recycler_status?: number | null;
  /** @format int32 */
  card_reader_status?: number | null;
  /**
   * When the ATM was created.
   * @format date-time
   */
  created_at?: string;
  enabled_coin_ids?: string[] | null;
  enabled_coins?: CoinView[] | null;
  /**
   * Identity of the atm in the source domain service (Boro)
   * @format int32
   */
  id?: number;
  /** @format int32 */
  imaging_device_status?: number | null;
  /**
   * The datetime object for the last machine restart,
   * or null if no restart can be found.
   * Use this value if you want to filter based on it, but use
   * the humanized version AthenaService.Web.ClientModels.v2.OperatorData.OperatorDataAtmView.LastRestartHumanized
   * for display in the UI.
   * @format date-time
   */
  last_restart?: string | null;
  /**
   * The humanized text value for the last restart AthenaService.Web.ClientModels.v2.OperatorData.OperatorDataAtmView.LastRestart
   * This is a computed field so it cannot be filtered on. Filter on the datetime version of this value instead.
   */
  last_restart_humanized?: string | null;
  /** @format date-time */
  last_robot_heartbeat_created_at?: string | null;
  /**
   * The humanized text value for the last heartbeat created AthenaService.Web.ClientModels.v2.OperatorData.OperatorDataAtmView.LastRobotHeartbeatCreatedAt
   * This is a computed field so it cannot be filtered on. Filter on the datetime version of this value instead.
   */
  last_robot_heartbeat_created_at_humanized?: string | null;
  last_sale?: LastSaleDto;
  /** @format date-time */
  last_sale_created_at?: string | null;
  /**
   * The humanized text value for the last sale AthenaService.Web.ClientModels.v2.OperatorData.OperatorDataAtmView.LastSaleCreatedAt
   * This is a computed field so it cannot be filtered on. Filter on the datetime version of this value instead.
   */
  last_sale_created_at_humanized?: string | null;
  /**
   * Timestamp for the last machine heartbeat.
   * @format date-time
   */
  last_seen?: string | null;
  /**
   * The humanized text value for the last heartbeat created AthenaService.Web.ClientModels.v2.OperatorData.OperatorDataAtmView.LastSeen
   * This is a computed field so it cannot be filtered on. Filter on the datetime version of this value instead.
   */
  last_seen_humanized?: string | null;
  /** Live denomination breakdown backing AthenaService.Web.ClientModels.v2.OperatorData.OperatorDataAtmView.LiveCash. */
  live_bill_denominations?: Record<string, number>;
  /**
   * Live cash currently in the box, derived from the box-clear boundary (sum of sale bills
   * since the latest non-invalidated cash clear). Distinct from the heartbeat-reported
   * AthenaService.Web.ClientModels.v2.OperatorData.OperatorDataAtmView.TotalWorthOfBills.
   * @format double
   */
  live_cash?: number | null;
  /**
   * Live total quantity of all bills for all denominations, backing AthenaService.Web.ClientModels.v2.OperatorData.OperatorDataAtmView.LiveCash.
   * @format int32
   */
  live_total_amount_of_bills?: number | null;
  location?: AtmLocationDataView;
  /**
   * Identifier created by the machine when it first turns on, OR when it is factory reset. (Uniquely identifies an ATMs "state" in Bitstop system.
   *  AtmId can be used to uniquely identify the ATM ACROSS states, even if it has been reset.
   * Since a factory reset ATM cannot know what its old atm id was on boot, this field is
   * necessary.)
   */
  machine_id?: string | null;
  /** Friendly human name operators can pick for an ATM. */
  name?: string | null;
  /** @format int32 */
  operator_id?: number | null;
  /** @format int32 */
  phidget_board_status?: number | null;
  pick_up_id?: string | null;
  /**
   * Percentage of time when the atm was online in the 30 days prior to previous 30 days
   * @format double
   */
  previous_thirty_days_uptime_percentage?: number;
  /** @format int32 */
  printer_status?: number | null;
  /**
   * A unique identifier physically present on the hardware of the machine.
   * Uniqueness is only guaranteed per manufacturer (genmega, kiosk, etc.)
   * Installers input this into the system during QA of a new machine. It is possible for
   * them to enter an incorrect value (twice) which can be annoying and requires manually fixing.
   */
  serial?: string | null;
  /**
   * A unique location string concatenated from address fields. (See this code for source (I think).
   * https://github.com/bitstopco/locations_service/blob/5083f20f360e268c568e86dfb4513bb21f113b95/locations_service.Web/Models/Location.cs#L43)
   */
  slug?: string | null;
  status?: MachineStatus;
  /** Tags associated with the atm. */
  tags?: string[] | null;
  /**
   * Percentage of time when the atm was online in the last 30 days
   * @format double
   */
  thirty_days_uptime_percentage?: number;
  /**
   * Total quantity of all bills for all denominations.
   * @format int32
   */
  total_amount_of_bills?: number | null;
  /**
   * Total (monetary) value of all bills for all denominations.
   * @format double
   */
  total_worth_of_bills?: number | null;
  /** @format date-time */
  updated_at?: string;
}

export interface OperatorDataAtmViewFilter {
  operands?: OperatorDataAtmViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface OperatorDataAtmViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: OperatorDataAtmView[] | null;
  meta?: OperatorDataAtmViewPaginatableResponseMetadata;
}

export interface OperatorDataAtmViewPaginatableRequest {
  filter?: OperatorDataAtmViewFilter;
  pagination?: OperatorDataAtmViewPagination;
  search_text?: string | null;
}

export interface OperatorDataAtmViewPaginatableResponseMetadata {
  filter?: OperatorDataAtmViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface OperatorDataAtmViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface OperatorDataCashPullView {
  /**
   * Id of the atm
   * @format int32
   */
  atm_id?: number;
  /**
   * Creation date and time in UTC
   * @format date-time
   */
  created_at?: string;
  /**
   * Fifty notes pulled
   * @format int32
   */
  fifty?: number;
  /**
   * Five notes pulled
   * @format int32
   */
  five?: number;
  /**
   * Hundred notes pulled
   * @format int32
   */
  hundred?: number;
  /**
   * Id of the cash pull
   * @format int32
   */
  id?: number;
  /**
   * Creation date and time in the atm's timezone
   * @format date-time
   */
  local_created_at?: string;
  /**
   * Id for the location of the cash pull
   * @format int32
   */
  location_id?: number | null;
  /**
   * One notes pulled
   * @format int32
   */
  one?: number;
  /** Pick up Id */
  pickup_id?: string | null;
  /** Serial number of the atm */
  serial_number?: string | null;
  /**
   * Ten notes pulled
   * @format int32
   */
  ten?: number;
  /**
   * Amount of cash by bills present at the time of cash pull
   * @format int32
   */
  total_amount_of_bills?: number;
  /**
   * The sum total value of all bills combined
   * @format int32
   */
  total_worth_of_bills?: number;
  /**
   * Twenty notes pulled
   * @format int32
   */
  twenty?: number;
  /**
   * Two notes pulled
   * @format int32
   */
  two?: number;
}

export interface OperatorDataCashPullViewFilter {
  operands?: OperatorDataCashPullViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface OperatorDataCashPullViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: OperatorDataCashPullView[] | null;
  meta?: OperatorDataCashPullViewPaginatableResponseMetadata;
}

export interface OperatorDataCashPullViewPaginatableRequest {
  filter?: OperatorDataCashPullViewFilter;
  pagination?: OperatorDataCashPullViewPagination;
  search_text?: string | null;
}

export interface OperatorDataCashPullViewPaginatableResponseMetadata {
  filter?: OperatorDataCashPullViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface OperatorDataCashPullViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

/** WIP for the customer view model. Ensuring we can filter by policy. */
export interface OperatorDataCustomerView {
  /** Address. */
  address?: string | null;
  address_enrollment_policy?: CustomerEnrollmentView;
  basic_info_enrollment_policy?: CustomerEnrollmentView;
  /** City. */
  city?: string | null;
  /** Country. */
  country?: string | null;
  /**
   * Created date
   * @format date-time
   */
  created_at?: string;
  /** List of the id's of the linked customers. */
  customer_links?: number[] | null;
  /**
   * Date of birth.
   * @format date-time
   */
  date_of_birth?: string | null;
  date_of_birth_enrollment_policy?: CustomerEnrollmentView;
  /**
   * Represents the EnrollmentAtm as a POCO without json serializer rules.
   * This ensures the db model is not tied to the view model for serialization rules.
   */
  enrollment_atm?: NonceEnrollmentAtmView;
  /** First name. */
  first_name?: string | null;
  government_id_and_selfie_enrollment_policy?: CustomerEnrollmentView;
  government_id_number_enrollment_policy?: CustomerEnrollmentView;
  /**
   * Indicates whether the ManualApprovalEnrollmentPolicy property values are relevant.
   * That is, true if the policy exists for the current operator, otherwise false.
   * This is because of a limitation that we currently have that does not allow null to be projected with a ternary conditional operator.
   */
  has_manual_approval_enrollment_policy?: boolean;
  /**
   * PK Id of the customer according to unity.
   * @format int32
   */
  id?: number;
  /** Full name. */
  id_number?: string | null;
  /**
   * The customer's occupation industry name, in English. Null if the customer has no industry set.
   * Returned per record but not available as a sort or filter field.
   */
  industry_name?: string | null;
  /**
   * True if customer enrolled with the operator making the request,
   * false otherwise.
   */
  is_enrolling_operator?: boolean;
  /** @format date-time */
  kyc_last_updated_at?: string | null;
  kyc_note_type?: KycNoteTypeEnum;
  kyc_status?: KycStatusEnum;
  /** Last name. */
  last_name?: string | null;
  manual_approval_enrollment_policy?: CustomerEnrollmentView;
  occupation_enrollment_policy?: CustomerEnrollmentView;
  /** Phone number. */
  phone_number?: string | null;
  /**
   * The customer's occupation position name, in English (the "occupation" field in the Bitstop UI).
   * Null if the customer has no position set. Returned per record but not available as a sort or filter field.
   */
  position_name?: string | null;
  proof_of_income_enrollment_policy?: CustomerEnrollmentView;
  ssn_enrollment_policy?: CustomerEnrollmentView;
  /** State. */
  state?: string | null;
  /** Tags associated with the customer. */
  tags?: string[] | null;
  /** @format date-time */
  updated_at?: string;
  /** Zipcode. */
  zipcode?: string | null;
}

/** Implementation of IPaginatableActionResponse with a Included property added for extra data. */
export interface OperatorDataCustomerViewCustomerIncludedPaginatableActionResponse {
  correlation_id?: string | null;
  data?: OperatorDataCustomerView[] | null;
  /** Schema for the included property of customer action responses. */
  included?: CustomerIncluded;
  meta?: OperatorDataCustomerViewPaginatableResponseMetadata;
}

export interface OperatorDataCustomerViewFilter {
  operands?: OperatorDataCustomerViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface OperatorDataCustomerViewPaginatableRequest {
  filter?: OperatorDataCustomerViewFilter;
  pagination?: OperatorDataCustomerViewPagination;
  search_text?: string | null;
}

export interface OperatorDataCustomerViewPaginatableResponseMetadata {
  filter?: OperatorDataCustomerViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface OperatorDataCustomerViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface OperatorDataIntegrationView {
  id?: string | null;
  name?: string | null;
}

export interface OperatorDataIntegrationViewFilter {
  operands?: OperatorDataIntegrationViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface OperatorDataIntegrationViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: OperatorDataIntegrationView[] | null;
  meta?: OperatorDataIntegrationViewPaginatableResponseMetadata;
}

export interface OperatorDataIntegrationViewPaginatableRequest {
  filter?: OperatorDataIntegrationViewFilter;
  pagination?: OperatorDataIntegrationViewPagination;
  search_text?: string | null;
}

export interface OperatorDataIntegrationViewPaginatableResponseMetadata {
  filter?: OperatorDataIntegrationViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface OperatorDataIntegrationViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface OperatorDataLocationView {
  address2?: string | null;
  atms?: OperatorDataAtmLocationView[] | null;
  city?: string | null;
  country?: string | null;
  /** @format date-time */
  created_at?: string;
  full_address?: string | null;
  hours?: string[] | null;
  /** @format double */
  latitude?: number | null;
  local_time_zone?: string | null;
  /** @format int32 */
  location_id?: number;
  location_image_urls?: string[] | null;
  /** @format double */
  longitude?: number | null;
  map_url?: string | null;
  marketing_status?: MarketingStatusEnum;
  name?: string | null;
  phone?: string | null;
  place_id?: string | null;
  /** DTO compatible RecordStatus. "Active" if active, otherwise "Archived". */
  record_status?: string | null;
  slug?: string | null;
  state?: string | null;
  street_address?: string | null;
  /** Tags associated with the location. */
  tags?: string[] | null;
  /** @format date-time */
  updated_at?: string;
  zipcode?: string | null;
}

export interface OperatorDataLocationViewFilter {
  operands?: OperatorDataLocationViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface OperatorDataLocationViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: OperatorDataLocationView[] | null;
  meta?: OperatorDataLocationViewPaginatableResponseMetadata;
}

export interface OperatorDataLocationViewPaginatableRequest {
  filter?: OperatorDataLocationViewFilter;
  pagination?: OperatorDataLocationViewPagination;
  search_text?: string | null;
}

export interface OperatorDataLocationViewPaginatableResponseMetadata {
  filter?: OperatorDataLocationViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface OperatorDataLocationViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface OperatorDataSaleBillsView {
  /** @format int32 */
  fifty?: number;
  /** @format int32 */
  five?: number;
  /** @format int32 */
  one?: number;
  /** @format int32 */
  one_hundred?: number;
  /** @format int32 */
  ten?: number;
  /** @format int32 */
  twenty?: number;
  /** @format int32 */
  two?: number;
}

export interface OperatorDataSaleView {
  /** The customer's wallet address */
  address?: string | null;
  /** Primary key identifier for affiliate resource and is not null if sale has affiliate association */
  affiliate_id?: string | null;
  atm?: SaleAtm;
  /**
   * The Atm resource's primary key identifier
   * @format int32
   */
  atm_id?: number | null;
  /** The Atm's physical serial number */
  atm_serial?: string | null;
  /**
   * Batch resource identifier primary key and is not null if sale was batched in Bitcoin network
   * @format int32
   */
  batch_id?: number | null;
  /** Boolean to determine if sale was batched during broadcasting to Bitcoin network */
  batched?: boolean;
  bills?: OperatorDataSaleBillsView;
  /**
   * The rate of Bitcoin at the time of sale creation
   * @format double
   */
  bitstop_rate?: number | null;
  /** The type of cryptocurrency involved in the sale */
  coin_type?: string | null;
  /**
   * Gets or sets the UTC DateTime when the record was created.
   * @format date-time
   */
  created_at?: string;
  /**
   * Gets the TimeSpan representing the time zone offset from UTC for the creation time.
   * This offset helps in filtering and displaying times in the context of the local time zone.
   */
  created_at_time_zone_offset?: string | null;
  /**
   * Gets the local DateTime of the record creation based on the ATM's timezone.
   * This time is converted from UTC to the local time zone specified in LocalTimeZone.
   * @format date-time
   */
  created_at_transaction_local?: string;
  /**
   * The amount of digital currency to send to customer wallet address
   * @format double
   */
  crypto_amount?: number | null;
  /** The currency used in the sale */
  currency_code?: string | null;
  customer?: SaleCustomer;
  /**
   * The Customer resource's primary key identifier
   * @format int32
   */
  customer_id?: number;
  /**
   * The fee amount for processing the sale
   * @format double
   */
  fee?: number | null;
  /**
   * The Sale resource primay key identifier
   * @format int32
   */
  id?: number | null;
  /**
   * The amount of cash inserted into the Atm when sale was created
   * @format float
   */
  inserted?: number | null;
  /**
   * Sale date and time in the local time zone of the atm
   * @format date-time
   */
  local_created_at?: string;
  /** IANA time zone name for the local time zone of the atm */
  local_time_zone?: string | null;
  /**
   * The Id of the location where the Sale happened.
   * @format int32
   */
  location_id?: number | null;
  /** The Name of the location where the Sale happened. */
  location_name?: string | null;
  /**
   * The operator fee amount in cryptocurrency
   * @format float
   */
  operator_fee?: number | null;
  /** Flag to determine if operator fee was collected for the sale */
  operator_fee_collected?: boolean;
  /**
   * The crypocurrency rate at which the operator fee was calculated
   * @format float
   */
  operator_fee_rate?: number | null;
  /**
   * The operator fee amount in USD
   * @format float
   */
  operator_fee_usd?: number | null;
  /**
   * The operator resource primary key identifier associated to the sale
   * @format int32
   */
  operator_id?: number;
  /** Buy or sell side sale type */
  order_type?: string | null;
  /**
   * The amount of satoshis to send to customer wallet address
   * @format double
   */
  satoshis?: number | null;
  /**
   * The amount of bitcoin sent
   * @format float
   */
  sent?: number | null;
  /**
   * An eight-ish character hash of the uuid that is friendlier for limited
   * character use-cases, like urls in sms. (https://github.com/skorokithakis/shortuuid)
   */
  short_uuid?: string | null;
  /** The state of the sale (is it completed, started or partial?) */
  stage?: string | null;
  /** Tags associated with the sale. */
  tags?: string[] | null;
  /** The blockchain transaction hash identifier */
  transaction_hash?: string | null;
  /**
   * Gets or sets the UTC DateTime when the record was updated.
   * @format date-time
   */
  updated_at?: string;
  /**
   * Gets the TimeSpan representing the time zone offset from UTC for the update time.
   * This offset is crucial for operations and representations that are sensitive to time zones.
   */
  updated_at_time_zone_offset?: string | null;
  /**
   * Gets the local DateTime of the record update based on the ATM's timezone.
   * This time is converted from UTC to the local time zone specified in LocalTimeZone.
   * @format date-time
   */
  updated_at_transaction_local?: string;
}

export interface OperatorDataSaleViewFilter {
  operands?: OperatorDataSaleViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface OperatorDataSaleViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: OperatorDataSaleView[] | null;
  meta?: OperatorDataSaleViewPaginatableResponseMetadata;
}

export interface OperatorDataSaleViewPaginatableRequest {
  filter?: OperatorDataSaleViewFilter;
  pagination?: OperatorDataSaleViewPagination;
  search_text?: string | null;
}

export interface OperatorDataSaleViewPaginatableResponseMetadata {
  filter?: OperatorDataSaleViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface OperatorDataSaleViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface OperatorInformation {
  address?: AddressInformation;
  /**
   * Legal Name of the Operator.
   * Ex: "Cash Depot LLC"
   */
  name?: string | null;
}

/** Operator Legal Information */
export interface OperatorLegalInformationView {
  /**
   * Second portion of Legal Street Address, if applicable. Usually a Suite Number.
   * Ex: "unit 1", or "" if empty.
   */
  legal_address_street_address2?: string | null;
  /**
   * Legal City of the Operator.
   * Ex: "Miami"
   */
  legal_address_city?: string | null;
  /**
   * Legal Country of the Operator.
   * Ex: "USA"
   */
  legal_address_country?: string | null;
  /**
   * Legal City of the Operator.
   * Ex: "FL"
   */
  legal_address_state?: string | null;
  /**
   * Legal Street Address of the Operator.
   * Ex: "181 8th St"
   */
  legal_address_street_address?: string | null;
  /**
   * Legal Zipcode of the Operator.
   * Ex: "33023"
   */
  legal_address_zipcode?: string | null;
  /**
   * Calculated field that concatenates the address fields.
   * Ex: "181 8th St unit 1, Miami, FL 33023 USA"
   */
  legal_full_address?: string | null;
  /**
   * Legal Name of the Operator.
   * Ex: "Cash Depot LLC"
   */
  legal_name?: string | null;
  /** NMLS Id of the Operator (if exists). */
  nmls_id?: string | null;
}

export interface OperatorResourceView {
  /** @format int32 */
  id?: number;
  name?: string | null;
}

export interface OperatorResourceViewICollectionIActionDataResponse {
  correlation_id?: string | null;
  data?: OperatorResourceView[] | null;
}

/** Represent the current operator settings. */
export interface OperatorSettingsView {
  /** If true the transactions will be processed in batch. Otherwise, they will be processed right away one by one. */
  batching_enabled?: boolean;
  /**
   * Is the maximum amount of transactions that can be in a batch.
   * @format int32
   */
  batching_max_tx_count?: number;
  /**
   * Is the maximum USD amount allowed by a transaction for being included in a batch.
   * @format int32
   */
  batching_minimum_usd?: number;
  /**
   * Created date.
   * @format date-time
   */
  created_at?: string;
  manual_review_prereqs?: string[] | null;
  nmls_id?: string | null;
  /** @format int32 */
  shields_up_customer_threshold?: number;
  /** @format int32 */
  shields_up_duration_minutes?: number;
  /** @format int32 */
  shields_up_monitoring_window_minutes?: number;
  /**
   * Updated date.
   * @format date-time
   */
  updated_at?: string;
}

export interface OperatorSettingsViewIActionDataResponse {
  correlation_id?: string | null;
  /** Represent the current operator settings. */
  data?: OperatorSettingsView;
}

export interface OpsServiceListView {
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  description?: string | null;
  id?: string | null;
  is_active?: boolean;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  name?: string | null;
}

export interface OpsServiceListViewFilter {
  operands?: OpsServiceListViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface OpsServiceListViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: OpsServiceListView[] | null;
  meta?: OpsServiceListViewPaginatableResponseMetadata;
}

export interface OpsServiceListViewPaginatableRequest {
  filter?: OpsServiceListViewFilter;
  pagination?: OpsServiceListViewPagination;
  search_text?: string | null;
}

export interface OpsServiceListViewPaginatableResponseMetadata {
  filter?: OpsServiceListViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface OpsServiceListViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface PaginationMetadata {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
  /** @format int32 */
  total_items?: number;
  /** @format int32 */
  total_pages?: number;
}

export interface PreciousMetalView {
  id?: string | null;
  logo_url?: string | null;
  name?: string | null;
  ticker?: string | null;
}

/** Cash breakdown for a specific product type */
export interface ProductCashBreakdown {
  /** Asset type ID from the database */
  asset_type_id?: string | null;
  /** Bills from an ATM */
  bills?: Bills;
  /** Product type name (e.g., "crypto", "gold") */
  product_type: string | null;
  /**
   * Total amount of bills for this product type
   * @format int32
   */
  total_bills?: number;
  /**
   * Total USD for this product type
   * @format double
   */
  total_usd?: number;
}

export interface ProductState {
  id?: string | null;
  is_enabled?: boolean;
  name?: string | null;
}

export enum ProductType {
  BuyCryptoCash = 'buy_crypto_cash',
  SellCryptoCash = 'sell_crypto_cash',
  BuyCryptoDebit = 'buy_crypto_debit',
  SellCryptoDebit = 'sell_crypto_debit',
}

export enum PromotionStatusEnum {
  IsMarketable = 'is_marketable',
  IsNotMarketable = 'is_not_marketable',
}

export interface ProviderView {
  api_key?: string | null;
  coins?: CoinView[] | null;
  id?: string | null;
  is_configured?: boolean;
  name?: string | null;
}

export interface ProviderViewListActionResponse {
  correlation_id?: string | null;
  data?: ProviderView[] | null;
  /** @deprecated */
  dictionaries?: any;
  errors?: ActionResponseDetail[] | null;
  included?: any;
  meta?: any;
  warnings?: ActionResponseDetail[] | null;
}

export interface QueueItemDetailView {
  action?: LocationChangeQueueItemActionEnum;
  /** @format date-time */
  change_occurred_at?: string;
  /** @format date-time */
  created_at?: string;
  current_state?: LocationPublishedData;
  /** If the status is "Error", this field may contain details about the error */
  error_details?: string | null;
  id?: string | null;
  is_retryable_error?: boolean | null;
  /** @format int32 */
  location_id?: number;
  location_name?: string | null;
  operator_name?: string | null;
  /** @format date-time */
  processed_at?: string | null;
  proposed_changes?: LocationPublishedData;
  proposed_changes_differences?: string | null;
  rejection_reason?: string | null;
  /** @format int32 */
  retry_attempts?: number | null;
  /** @format date-time */
  reviewed_at?: string | null;
  /** @format int32 */
  reviewed_by?: number | null;
  status?: LocationChangeQueueItemStatusEnum;
}

export interface QueueItemListView {
  action?: LocationChangeQueueItemActionEnum;
  /** @format date-time */
  change_occurred_at?: string;
  /** @format date-time */
  created_at?: string;
  /** If the status is "Error", this field may contain details about the error */
  error_details?: string | null;
  id?: string | null;
  /** @format int32 */
  location_id?: number;
  location_name?: string | null;
  operator_name?: string | null;
  rejection_reason?: string | null;
  /** @format date-time */
  reviewed_at?: string | null;
  /** @format int32 */
  reviewed_by?: number | null;
  status?: LocationChangeQueueItemStatusEnum;
}

export interface QueueItemListViewExportFilter {
  operands?: QueueItemListViewExportFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface QueueItemListViewExportFilterableRequest {
  filter?: QueueItemListViewExportFilter;
  search_text?: string | null;
}

export interface QueueItemListViewFilter {
  operands?: QueueItemListViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface QueueItemListViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: QueueItemListView[] | null;
  meta?: QueueItemListViewPaginatableResponseMetadata;
}

export interface QueueItemListViewPaginatableRequest {
  filter?: QueueItemListViewFilter;
  pagination?: QueueItemListViewPagination;
  search_text?: string | null;
}

export interface QueueItemListViewPaginatableResponseMetadata {
  filter?: QueueItemListViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface QueueItemListViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface QueueSummaryView {
  /** @format int32 */
  queued_to_create?: number;
  /** @format int32 */
  queued_to_republish?: number;
  /** @format int32 */
  queued_to_unpublish?: number;
  /** @format int32 */
  queued_with_errors?: number;
}

export interface RateInformation {
  /** @format double */
  bitstop_rate?: number;
  quoted_exchange?: string | null;
  /** @format double */
  spot_rate?: number;
  /** @format double */
  spread?: number;
}

export enum ReconciliationResultType {
  Zero = 'zero',
  Long = 'long',
  Short = 'short',
}

export interface RecoveryAttemptView {
  /** @format date-time */
  attempted_at?: string;
  details?: any;
  status?: IssueRecoveryAttemptStatus;
}

/** What is owed to a customer after a dispense failure. */
export interface RedemptionObligationView {
  /**
   * Asset units owed when the obligation was created.
   * @format int32
   */
  asset_amount?: number;
  asset_id?: string | null;
  /** Fiat per asset unit, from the sale. Decimal as a string. */
  asset_rate?: string | null;
  asset_type?: string | null;
  /** @format date-time */
  closed_at?: string | null;
  closed_by?: string | null;
  /** @format date-time */
  created_at?: string;
  /** Decimal as a string. */
  fiat_amount?: string | null;
  /** ISO 4217 currency code. */
  fiat_type?: string | null;
  id?: string | null;
  /** dispense_failure | unreversed_debit. */
  origin?: string | null;
  /**
   * Asset units still owed.
   * @format int32
   */
  outstanding_asset_amount?: number;
  /** cash | debit. */
  payment_method?: string | null;
  /** pending | completed | cancelled. */
  status?: string | null;
  /** @format date-time */
  updated_at?: string;
}

/** One attempt to settle an obligation. */
export interface RedemptionSettlementView {
  /**
   * Asset units this attempt was issued for.
   * @format int32
   */
  asset_amount?: number;
  asset_id?: string | null;
  asset_type?: string | null;
  /**
   * 1-based, per obligation and method.
   * @format int32
   */
  attempt_number?: number;
  /** @format date-time */
  created_at?: string;
  /** Operator identity, or a system actor. */
  created_by?: string | null;
  /** The claim dispense, for reserved_dispense once claimed. */
  dispense_id?: string | null;
  /** Decimal as a string. */
  fiat_amount?: string | null;
  /** ISO 4217 currency code. */
  fiat_type?: string | null;
  id?: string | null;
  /** Redemption method, e.g. reserved_dispense or debit_reversal. */
  method?: string | null;
  /** Method-specific data recorded at issue and fulfilment. */
  method_data?: any;
  notes?: string | null;
  /** refused | transient | unknown | withdrawn. */
  outcome_class?: string | null;
  /** Processor code, our error code, or the operator's cancel reason. */
  outcome_code?: string | null;
  redemption_obligation_id?: string | null;
  /** The method's external id (the redemption code for reserved_dispense). */
  reference?: string | null;
  /** @format date-time */
  resolved_at?: string | null;
  resolved_by?: string | null;
  resolved_reason?: string | null;
  /**
   * Asset units this attempt settled; null until known.
   * @format int32
   */
  settled_asset_amount?: number | null;
  /** issued | claimed | fulfilled | short | cancelled | unknown. */
  status?: string | null;
  /** @format date-time */
  updated_at?: string;
}

export interface ResidualBagContentView {
  bill_note_id?: string | null;
  /** @format int32 */
  confirmed_note_count?: number | null;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  /** @format int32 */
  estimated_note_count?: number;
  id?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  residual_bag_id?: string | null;
}

export enum ResidualBagType {
  RejectBinOnly = 'reject_bin_only',
  CassetteOnly = 'cassette_only',
  RejectBinAndCassette = 'reject_bin_and_cassette',
}

export interface ResidualBagView {
  /** @format int32 */
  atm_id?: number | null;
  /** @format date-time */
  bank_confirmed_at?: string | null;
  /** @format date-time */
  collected_at?: string | null;
  collected_by?: string | null;
  contents?: ResidualBagContentView[] | null;
  /** @format date-time */
  created_at?: string | null;
  created_by?: string | null;
  id?: string | null;
  is_confirmed?: boolean | null;
  /** @format date-time */
  last_updated_at?: string | null;
  last_updated_by?: string | null;
  note_type?: NoteType;
  reject_bin_confirmed_content?: any;
  /** @format int32 */
  reject_bin_confirmed_notes_count?: number | null;
  reject_bin_estimated_content?: any;
  /** @format int32 */
  reject_bin_estimated_notes_count?: number | null;
  residual_bag_id?: string | null;
  /** @format int32 */
  total_note_count?: number | null;
  type?: ResidualBagType;
}

export interface ResidualBagViewFilter {
  operands?: ResidualBagViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface ResidualBagViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: ResidualBagView[] | null;
  meta?: ResidualBagViewPaginatableResponseMetadata;
}

export interface ResidualBagViewPaginatableRequest {
  filter?: ResidualBagViewFilter;
  pagination?: ResidualBagViewPagination;
  search_text?: string | null;
}

export interface ResidualBagViewPaginatableResponseMetadata {
  filter?: ResidualBagViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface ResidualBagViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface RestockReconciliationAdjustmentView {
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  id?: string | null;
  reason?: string | null;
  state_after_adjustment?: any;
  state_before_adjustment?: any;
}

export interface RestockReconciliationItemView {
  /** @format int32 */
  actual_count?: number;
  bill_note_id?: string | null;
  details?: any;
  /** @format int32 */
  expected_count?: number;
  id?: string | null;
  related_physical_residual_bag_ids?: string[] | null;
  result?: ReconciliationResultType;
}

export interface RestockReconciliationListView {
  /** @format int32 */
  actual_total?: number;
  /** ATM view for nonce users. */
  atm?: NonceAtmSingleView;
  /** @format int32 */
  atm_id?: number;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  /** @format int32 */
  expected_total?: number;
  id?: string | null;
  items?: Item[] | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  location?: LocationView;
  /** @format int32 */
  location_id?: number | null;
  /** @format int32 */
  net_discrepancy?: number;
  notes?: string | null;
  /** @format date-time */
  reconciled_at?: string;
  reconciled_by?: string | null;
  restock_request_id?: string | null;
}

export interface RestockReconciliationListViewFilter {
  operands?: RestockReconciliationListViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface RestockReconciliationListViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: RestockReconciliationListView[] | null;
  meta?: RestockReconciliationListViewPaginatableResponseMetadata;
}

export interface RestockReconciliationListViewPaginatableRequest {
  filter?: RestockReconciliationListViewFilter;
  pagination?: RestockReconciliationListViewPagination;
  search_text?: string | null;
}

export interface RestockReconciliationListViewPaginatableResponseMetadata {
  filter?: RestockReconciliationListViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface RestockReconciliationListViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface RestockReconciliationView {
  adjustments?: RestockReconciliationAdjustmentView[] | null;
  /** ATM view for nonce users. */
  atm?: NonceAtmSingleView;
  /** @format int32 */
  atm_id?: number;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  id?: string | null;
  items?: RestockReconciliationItemView[] | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  location?: LocationView;
  /** @format int32 */
  location_id?: number | null;
  notes?: string | null;
  /** @format date-time */
  reconciled_at?: string;
  reconciled_by?: string | null;
  restock_request_id?: string | null;
}

export enum RestockRequestChangeType {
  Created = 'created',
  Fulfilled = 'fulfilled',
  Reconciled = 'reconciled',
  Completed = 'completed',
  Updated = 'updated',
  Cancelled = 'cancelled',
  Loaded = 'loaded',
  CollectedResiduals = 'collected_residuals',
}

export interface RestockRequestStateChangeVew {
  id?: string | null;
  /** @format int32 */
  sequence_number?: number;
  snapshot?: any;
  type?: RestockRequestChangeType;
}

export enum RestockRequestStatus {
  Created = 'created',
  Fulfilled = 'fulfilled',
  Loaded = 'loaded',
  PendingReconcile = 'pending_reconcile',
  Completed = 'completed',
  Cancelled = 'cancelled',
}

export enum RestockRequestType {
  Add = 'add',
  Swap = 'swap',
}

export interface RestockRequestView {
  access_code?: string | null;
  /** ATM view for nonce users. */
  atm?: NonceAtmSingleView;
  /** @format int32 */
  atm_id?: number;
  bag_id?: string | null;
  cassettes?: CassetteView[] | null;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  history?: RestockRequestStateChangeVew[] | null;
  id?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  location?: LocationView;
  /** @format int32 */
  location_id?: number | null;
  notes?: string | null;
  residual_bags?: ResidualBagView[] | null;
  restock_type?: RestockRequestType;
  status?: RestockRequestStatus;
}

export interface RestockRequestViewFilter {
  operands?: RestockRequestViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface RestockRequestViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: RestockRequestView[] | null;
  meta?: RestockRequestViewPaginatableResponseMetadata;
}

export interface RestockRequestViewPaginatableRequest {
  filter?: RestockRequestViewFilter;
  pagination?: RestockRequestViewPagination;
  search_text?: string | null;
}

export interface RestockRequestViewPaginatableResponseMetadata {
  filter?: RestockRequestViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface RestockRequestViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface RestockingSummaryView {
  bills_count?: Record<string, number>;
  /** @format int32 */
  low_machines_count?: number;
  orders_count?: Record<string, number>;
}

/** Operator information. */
export interface RobotFaceOperatorSingleView {
  legal_address_street_address2?: string | null;
  legal_address_city?: string | null;
  legal_address_country?: string | null;
  legal_address_state?: string | null;
  legal_address_street_address?: string | null;
  legal_address_zipcode?: string | null;
  /** Calculated field that concatenates the address fields. */
  legal_full_address?: string | null;
  legal_name?: string | null;
  nmls_id?: string | null;
  /** @format int32 */
  operator_id?: number;
}

/**
 * Common enumerable atm response that is intended to be used with any type of
 * atm projection.
 */
export interface RobotFaceOperatorSingleViewAtmActionResponse {
  correlation_id?: string | null;
  /** Operator information. */
  data?: RobotFaceOperatorSingleView;
  /** Schema for the included property of atm action responses. */
  included?: AtmIncluded;
}

export interface RobotFaceOperatorSingleViewIActionDataResponse {
  correlation_id?: string | null;
  /** Operator information. */
  data?: RobotFaceOperatorSingleView;
}

/** Operator information. */
export interface RobotFaceOperatorWithAddressSingleView {
  operator?: OperatorInformation;
}

export interface RobotFaceSaleReceiptSingleView {
  address?: string | null;
  /** @format double */
  btc?: number;
  coin_type?: string | null;
  /** @format date-time */
  created_at?: string;
  currency_code?: string | null;
  customer?: CustomerBasicInformation;
  /** @format double */
  enviando?: number;
  /** @format double */
  fee?: number;
  /** @format double */
  fiat?: number;
  local_time_zone?: string | null;
  /** Operator information. */
  operator?: RobotFaceOperatorWithAddressSingleView;
  order_type?: string | null;
  rate?: RateInformation;
  uuid?: string | null;
}

export interface RobotFaceSaleReceiptSingleViewIActionDataResponse {
  correlation_id?: string | null;
  data?: RobotFaceSaleReceiptSingleView;
}

export interface RoleView {
  /** @format uuid */
  application_id?: string | null;
  description?: string | null;
  /** @format int32 */
  id?: number;
  name?: string | null;
  /** @format int32 */
  operator_id?: number | null;
  /** @format int32 */
  priority?: number | null;
}

export interface RouteListView {
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  /** @format int32 */
  display_id?: number;
  /**
   * Resources made taggable after they already exist get a new global id
   * to ensure uniqueness within the 'taggable' table. Resources will continue
   * to support their existing id property.
   * @format uuid
   */
  global_id?: string;
  id?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  name?: string | null;
  notes?: string | null;
  route_status?: RouteStatus;
  /** @format date-time */
  scheduled_at?: string | null;
  service_ticket_location_states?: string[] | null;
  service_tickets?: RouteServiceTicketLinkView[] | null;
  /** List of tag ids associated to this resource. */
  tag_ids?: string[] | null;
  /** @format int32 */
  technician_id?: number | null;
}

export interface RouteListViewFilter {
  operands?: RouteListViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface RouteListViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: RouteListView[] | null;
  meta?: RouteListViewPaginatableResponseMetadata;
}

export interface RouteListViewPaginatableRequest {
  filter?: RouteListViewFilter;
  pagination?: RouteListViewPagination;
  search_text?: string | null;
}

export interface RouteListViewPaginatableResponseMetadata {
  filter?: RouteListViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface RouteListViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface RouteServiceTicketLinkView {
  auto_created?: boolean;
  /** @format int32 */
  case_display_id?: number | null;
  case_id?: string | null;
  /** @format date-time */
  completed_at?: string | null;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  details?: string | null;
  /** @format int32 */
  display_id?: number;
  /** @format date-time */
  finish_date?: string | null;
  id?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  /** @format date-time */
  link_created_at?: string;
  /** @format int32 */
  location_id?: number | null;
  /** @format date-time */
  start_date?: string | null;
  status?: ServiceTicketStatus;
  /**
   * Flattened list of distinct task type names from all tasks associated with this
   * service ticket (e.g., "Modem Swap", "Bill Acceptor Error"). Lets Ops users see
   * the work expected at each stop without opening the ticket. Empty when the ticket
   * has no tasks with a task type.
   */
  task_type_names?: string[] | null;
  /** @format int32 */
  technician_id?: number | null;
}

export interface RouteStatsView {
  /** @format int32 */
  assigned_routes?: number;
  /** @format double */
  closed_routes_percentage_change?: number;
  /** @format double */
  open_routes_percentage_change?: number;
  /** @format int32 */
  total_closed_routes?: number;
  /** @format int32 */
  total_open_routes?: number;
  /** @format int32 */
  unassigned_routes?: number;
}

export interface RouteStatsViewActionResponse {
  correlation_id?: string | null;
  data?: RouteStatsView;
  /** @deprecated */
  dictionaries?: any;
  errors?: ActionResponseDetail[] | null;
  included?: any;
  meta?: any;
  warnings?: ActionResponseDetail[] | null;
}

export enum RouteStatus {
  Planning = 'planning',
  Scheduled = 'scheduled',
  InProgress = 'in_progress',
  Completed = 'completed',
  Cancelled = 'cancelled',
}

export interface RouteView {
  /** @format int32 */
  completed_tickets?: number;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  /** @format int32 */
  display_id?: number;
  /** @format int32 */
  failed_tickets?: number;
  /**
   * Resources made taggable after they already exist get a new global id
   * to ensure uniqueness within the 'taggable' table. Resources will continue
   * to support their existing id property.
   * @format uuid
   */
  global_id?: string;
  id?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  name?: string | null;
  notes?: string | null;
  /** @format int32 */
  pending_tickets?: number;
  route_status?: RouteStatus;
  /** @format date-time */
  scheduled_at?: string | null;
  service_tickets?: RouteServiceTicketLinkView[] | null;
  /** List of tag ids associated to this resource. */
  tag_ids?: string[] | null;
  /** @format int32 */
  technician_id?: number | null;
  /** @format int32 */
  total_tickets?: number;
}

export interface RouteViewActionResponse {
  correlation_id?: string | null;
  data?: RouteView;
  /** @deprecated */
  dictionaries?: any;
  errors?: ActionResponseDetail[] | null;
  included?: any;
  meta?: any;
  warnings?: ActionResponseDetail[] | null;
}

export interface SaleAtm {
  /** @format int32 */
  atm_id?: number;
  machine_id?: string | null;
  name?: string | null;
  serial?: string | null;
}

export interface SaleCustomer {
  address?: string | null;
  city?: string | null;
  country?: string | null;
  /** @format date-time */
  date_of_birth?: string | null;
  enrollment_tier?: string | null;
  first_name?: string | null;
  id_number?: string | null;
  last_name?: string | null;
  phone_number?: string | null;
  state?: string | null;
  zipcode?: string | null;
  [key: string]: any;
}

/**
 * Summary of a single dispense operation for a sale (e.g. precious metal / asset dispense).
 * Exposes expected vs successful vs rejected bills so clients can show why a dispense was partial or rejected.
 */
export interface SaleDispenseView {
  /**
   * Per-cassette results merging hardware stats (from result_request_data) with bill note identity.
   * Use this to show which bill note was in each cassette and how many dispensed/rejected and why.
   */
  cassette_results?: DispenseCassetteResultView[] | null;
  /** Whether the dispense was fully completed. */
  completed?: boolean;
  /** Bills that were expected to be dispensed (by bill note). */
  expected_bills?: DispenseBillItemView[] | null;
  /** Dispense record id. */
  id?: string | null;
  /** Whether the dispense was only partially completed. */
  partial?: boolean;
  /** Bills that were expected but not successfully dispensed (rejected/failed). */
  rejected_bills?: DispenseBillItemView[] | null;
  /** Bills that were successfully dispensed. */
  successful_bills?: DispenseBillItemView[] | null;
}

export interface SalesStatsAtmSalesStatsListParams {
  /** @format int32 */
  atm_id?: number;
  /** @format int32 */
  customer_id?: number;
  /** @format date-time */
  range_end?: string;
  /** @format date-time */
  range_start?: string;
}

export interface SalesStatsSalesStatsDetailParams {
  /** @format int32 */
  atm_id?: number;
  /** @format int32 */
  customer_id?: number;
  period: string;
  /** @format date-time */
  range_end?: string;
  /** @format date-time */
  range_start?: string;
  timezone?: string;
}

export interface SalesStatsSalesStatsListParams {
  /** @format int32 */
  atm_id?: number;
  /** @format int32 */
  customer_id?: number;
  /** @format date-time */
  range_end?: string;
  /** @format date-time */
  range_start?: string;
}

/** Sales statistics view model corresponding to Crystal Lang Payloads::Sales::Stats */
export interface SalesStatsView {
  /** @format int32 */
  atm_id?: number | null;
  atm_name?: string | null;
  /** @format date-time */
  period?: string | null;
  /** @format double */
  total_btc?: number | null;
  /** @format int64 */
  total_count?: number | null;
  /** @format double */
  total_env?: number | null;
  /** @format double */
  total_fees?: number | null;
  /** @format double */
  total_sales?: number | null;
}

export interface SalesStatsViewIActionDataResponse {
  correlation_id?: string | null;
  /** Sales statistics view model corresponding to Crystal Lang Payloads::Sales::Stats */
  data?: SalesStatsView;
}

export interface SalesStatsViewListIActionDataResponse {
  correlation_id?: string | null;
  data?: SalesStatsView[] | null;
}

export interface ServiceTicketListView {
  address2?: string | null;
  /** @format int32 */
  atm_id?: number | null;
  auto_created?: boolean;
  /** @format int32 */
  case_display_id?: number | null;
  case_id?: string | null;
  city?: string | null;
  /** @format date-time */
  completed_at?: string | null;
  country?: string | null;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  details?: string | null;
  /** @format int32 */
  display_id?: number;
  /** @format date-time */
  finish_date?: string | null;
  id?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  /** @format int32 */
  location_id?: number | null;
  location_tag_ids?: string[] | null;
  location_tags?: TagView[] | null;
  ops_service_id?: string | null;
  ops_service_name?: string | null;
  priority?: ServiceTicketPriority;
  /**
   * Distinct DisplayIds of the routes this service ticket is associated with. Lets Ops
   * users filter/search service tickets by a specific route. Empty when the ticket isn't
   * on any active route.
   */
  route_ids?: number[] | null;
  /** Routes this service ticket is associated with. */
  routes?: ServiceTicketRouteLinkView[] | null;
  /** @format date-time */
  start_date?: string | null;
  state?: string | null;
  status?: ServiceTicketStatus;
  street_address?: string | null;
  /**
   * Flattened list of task type names from all tasks associated with this service ticket.
   * Useful for filtering by task type name (e.g., "CDU Hardware", "Revive Machine").
   */
  task_type_names?: string[] | null;
  tasks?: ServiceTicketTaskView[] | null;
  /** @format int32 */
  technician_id?: number | null;
  zipcode?: string | null;
}

export interface ServiceTicketListViewFilter {
  operands?: ServiceTicketListViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface ServiceTicketListViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: ServiceTicketListView[] | null;
  meta?: ServiceTicketListViewPaginatableResponseMetadata;
}

export interface ServiceTicketListViewPaginatableRequest {
  filter?: ServiceTicketListViewFilter;
  pagination?: ServiceTicketListViewPagination;
  search_text?: string | null;
}

export interface ServiceTicketListViewPaginatableResponseMetadata {
  filter?: ServiceTicketListViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface ServiceTicketListViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface ServiceTicketNoteAttachmentView {
  /** @format date-time */
  created_at?: string;
  file_name?: string | null;
  id?: string | null;
}

export enum ServiceTicketNoteType {
  Ops = 'ops',
  Field = 'field',
  Internal = 'internal',
}

export interface ServiceTicketNoteView {
  attachments?: ServiceTicketNoteAttachmentView[] | null;
  author?: string | null;
  body?: string | null;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  id?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  type?: ServiceTicketNoteType;
}

export enum ServiceTicketPriority {
  Low = 'low',
  Medium = 'medium',
  High = 'high',
  Critical = 'critical',
}

/**
 * Represents a route associated with a service ticket (the inverse of
 * AthenaService.Web.ClientModels.v2.NonceDashboard.Operations.RouteServiceTicketLinkView). Surfaced on service ticket
 * responses so clients can see which routes include a ticket without
 * calling the routes API. (Audit fields are namespaced to make their scope unambiguous:
 * `Route*` fields describe the route itself, while `Link*` fields
 * describe the route-to-service-ticket link.)
 */
export interface ServiceTicketRouteLinkView {
  /** @format int32 */
  display_id?: number;
  /** The id of the route-to-service-ticket link. */
  id?: string | null;
  /** @format date-time */
  link_created_at?: string;
  link_created_by?: string | null;
  /** @format date-time */
  link_last_updated_at?: string;
  link_last_updated_by?: string | null;
  name?: string | null;
  notes?: string | null;
  /** @format date-time */
  route_created_at?: string;
  route_created_by?: string | null;
  /** The id of the associated route. */
  route_id?: string | null;
  /** @format date-time */
  route_last_updated_at?: string;
  route_last_updated_by?: string | null;
  route_status?: RouteStatus;
  /** @format date-time */
  scheduled_at?: string | null;
  /** @format int32 */
  technician_id?: number | null;
}

export interface ServiceTicketStatsView {
  /** @format int32 */
  assigned_tickets?: number;
  /** @format double */
  closed_tickets_percentage_change?: number;
  /** @format double */
  open_tickets_percentage_change?: number;
  /** @format int32 */
  total_closed_tickets?: number;
  /** @format int32 */
  total_open_tickets?: number;
  /** @format int32 */
  unassigned_tickets?: number;
}

export interface ServiceTicketStatsViewActionResponse {
  correlation_id?: string | null;
  data?: ServiceTicketStatsView;
  /** @deprecated */
  dictionaries?: any;
  errors?: ActionResponseDetail[] | null;
  included?: any;
  meta?: any;
  warnings?: ActionResponseDetail[] | null;
}

export enum ServiceTicketStatus {
  Planned = 'planned',
  InProgress = 'in_progress',
  Completed = 'completed',
  Failed = 'failed',
  Cancelled = 'cancelled',
}

export interface ServiceTicketTaskView {
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  description?: string | null;
  id?: string | null;
  is_success_reason?: boolean | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  resolution?: TaskResolution;
  resolution_notes?: string | null;
  resolution_reason_id?: string | null;
  resolution_reason_name?: string | null;
  /** @format date-time */
  resolved_at?: string | null;
  resolved_by?: string | null;
  /** @format int32 */
  sort_order?: number;
  task_type_description?: string | null;
  task_type_id?: string | null;
  task_type_name?: string | null;
}

export interface ServiceTicketView {
  auto_created?: boolean;
  /** @format int32 */
  case_display_id?: number | null;
  case_id?: string | null;
  /** @format date-time */
  completed_at?: string | null;
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  details?: string | null;
  /** @format int32 */
  display_id?: number;
  /** @format date-time */
  finish_date?: string | null;
  id?: string | null;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  /** @format int32 */
  location_id?: number | null;
  notes?: ServiceTicketNoteView[] | null;
  ops_service_id?: string | null;
  ops_service_name?: string | null;
  priority?: ServiceTicketPriority;
  /** Routes this service ticket is associated with. */
  routes?: ServiceTicketRouteLinkView[] | null;
  /** @format date-time */
  start_date?: string | null;
  status?: ServiceTicketStatus;
  tasks?: ServiceTicketTaskView[] | null;
  /** @format int32 */
  technician_id?: number | null;
}

export interface ServiceTicketViewActionResponse {
  correlation_id?: string | null;
  data?: ServiceTicketView;
  /** @deprecated */
  dictionaries?: any;
  errors?: ActionResponseDetail[] | null;
  included?: any;
  meta?: any;
  warnings?: ActionResponseDetail[] | null;
}

export interface ServiceTicketViewExportFilter {
  operands?: ServiceTicketViewExportFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface ServiceTicketViewExportFilterableRequest {
  filter?: ServiceTicketViewExportFilter;
  search_text?: string | null;
}

export enum Severity {
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
  Primary = 'primary',
  Secondary = 'secondary',
  Action = 'action',
  Disabled = 'disabled',
}

export interface StringIActionDataResponse {
  correlation_id?: string | null;
  data?: string | null;
}

export interface StringICollectionIActionDataResponse {
  correlation_id?: string | null;
  data?: string[] | null;
}

export enum TagCategoryEnum {
  Machine = 'machine',
  Customer = 'customer',
  Transaction = 'transaction',
  Location = 'location',
  Route = 'route',
}

/**
 * A model for centralizing constraints for tags. This is not at this stage
 * intended to be customized or configured. But it is helpful to have a construct we
 * can link from code to UX to be transparent about these things.
 */
export interface TagConstraints {
  /**
   * Maximum number of characters for a tag name.
   * @format int32
   */
  name_character_limit?: number;
  /**
   * Maximum number of resources that can be associated with a single tag.
   * @format int32
   */
  resources_limit?: number;
  /**
   * Maximum number of tags that can be associated to a single resource.
   * @format int32
   */
  tags_limit?: number;
}

export interface TagConstraintsIActionDataResponse {
  correlation_id?: string | null;
  /**
   * A model for centralizing constraints for tags. This is not at this stage
   * intended to be customized or configured. But it is helpful to have a construct we
   * can link from code to UX to be transparent about these things.
   */
  data?: TagConstraints;
}

/** Request model for adding or removing relationships between tags and resources. */
export interface TagRelationshipRequest {
  /**
   * A list of  resource ids that should be associated or unassociated to the tag ids.
   * @minItems 1
   * @uniqueItems true
   */
  resource_ids: string[];
  /**
   * A list of  tag ids that should be associated or unassociated to the resource ids.
   * @minItems 1
   * @uniqueItems true
   */
  tag_ids: string[];
}

/** Client model for changing the details of a tag. */
export interface TagUpsertRequest {
  category?: TagCategoryEnum;
  /**
   * A string representing the color of this tag for UI display. ( Validity is delegated to the client for ease.
   * This is because  most browsers for a css color can use either
   * "red" or "#FF0000". So we don't want the back end to make the judgments.)
   * @minLength 1
   */
  color: string;
  /**
   * Used as the display label for a tag.
   * This property is case insensitive.
   * @minLength 1
   * @maxLength 32
   */
  name: string;
}

/**
 * Common view model for tags.
 * Implements IEquatable for de-duping collections using Distinct()
 */
export interface TagView {
  category?: TagCategoryEnum;
  /**
   * A string representing the color of this tag for UI display.
   * @example "
   *             red, #FF0000
   *             "
   */
  color?: string | null;
  id?: string | null;
  /**
   * Used as the display label for a tag.
   * This property is case insensitive.
   */
  name?: string | null;
}

export interface TagViewFilter {
  operands?: TagViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface TagViewICollectionIActionDataResponse {
  correlation_id?: string | null;
  data?: TagView[] | null;
}

export interface TagViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: TagView[] | null;
  meta?: TagViewPaginatableResponseMetadata;
}

export interface TagViewPaginatableRequest {
  filter?: TagViewFilter;
  pagination: TagViewPagination;
  search_text?: string | null;
}

export interface TagViewPaginatableResponseMetadata {
  filter?: TagViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface TagViewPagination {
  /**
   * @format int32
   * @min 1
   */
  current_page?: number;
  /**
   * @format int32
   * @min 1
   * @max 1000
   */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export enum TaskResolution {
  Pending = 'pending',
  Success = 'success',
  Failure = 'failure',
}

export interface TaskResolutionReasonListView {
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  description?: string | null;
  id?: string | null;
  is_active?: boolean;
  is_success_reason?: boolean;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  name?: string | null;
}

export interface TaskResolutionReasonListViewFilter {
  operands?: TaskResolutionReasonListViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface TaskResolutionReasonListViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: TaskResolutionReasonListView[] | null;
  meta?: TaskResolutionReasonListViewPaginatableResponseMetadata;
}

export interface TaskResolutionReasonListViewPaginatableRequest {
  filter?: TaskResolutionReasonListViewFilter;
  pagination?: TaskResolutionReasonListViewPagination;
  search_text?: string | null;
}

export interface TaskResolutionReasonListViewPaginatableResponseMetadata {
  filter?: TaskResolutionReasonListViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface TaskResolutionReasonListViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface TaskTypeListView {
  /** @format date-time */
  created_at?: string;
  created_by?: string | null;
  description?: string | null;
  id?: string | null;
  is_active?: boolean;
  /** @format date-time */
  last_updated_at?: string;
  last_updated_by?: string | null;
  name?: string | null;
}

export interface TaskTypeListViewFilter {
  operands?: TaskTypeListViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface TaskTypeListViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: TaskTypeListView[] | null;
  meta?: TaskTypeListViewPaginatableResponseMetadata;
}

export interface TaskTypeListViewPaginatableRequest {
  filter?: TaskTypeListViewFilter;
  pagination?: TaskTypeListViewPagination;
  search_text?: string | null;
}

export interface TaskTypeListViewPaginatableResponseMetadata {
  filter?: TaskTypeListViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface TaskTypeListViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface TerminalView {
  /** Indicates if the ATM has provisional posting enabled. */
  active?: boolean;
  /**
   * Id of the ATM
   * @format int32
   */
  id?: number;
  /** Name of the ATM */
  name?: string | null;
  /** Serial number of the ATM */
  serial_number?: string | null;
}

export interface TerminalViewFilter {
  operands?: TerminalViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface TerminalViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: TerminalView[] | null;
  meta?: TerminalViewPaginatableResponseMetadata;
}

export interface TerminalViewPaginatableRequest {
  filter?: TerminalViewFilter;
  pagination?: TerminalViewPagination;
  search_text?: string | null;
}

export interface TerminalViewPaginatableResponseMetadata {
  filter?: TerminalViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface TerminalViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface TimelineEntryView {
  component?: string | null;
  /** @format date-time */
  created_at?: string;
  machine_event_id?: string | null;
  new_state?: string | null;
  old_state?: string | null;
}

/**
 * This is the V2 Version of:
 * AthenaService.Web.ClientModels.v1.MyAccountDashboard.Sales.SalesReceiptView
 */
export interface TransactionReceiptView {
  address?: string | null;
  asset?: DispenseAssetView;
  /** Asset ID */
  asset_id?: string | null;
  /** Asset Type */
  asset_type?: string | null;
  /** @format int32 */
  atm_id?: number | null;
  atm_name?: string | null;
  /** @format double */
  bitstop_rate?: number | null;
  coin?: CoinView;
  /** Coin ID */
  coin_id?: string | null;
  /** example BTC */
  coin_type?: string | null;
  /** @format date-time */
  created_at?: string;
  /** @format double */
  crypto_amount?: number | null;
  currency_code?: string | null;
  customer_first_name?: string | null;
  /** @format int32 */
  customer_id?: number;
  customer_last_name?: string | null;
  display_stage?: DisplayStageEnum;
  id?: string | null;
  /**
   * fiat bills added to a machine
   * @format double
   */
  inserted?: number;
  /**
   * Sale date and time in the local time zone of the atm
   * @format date-time
   */
  local_created_at?: string;
  /** The humanized text value for AthenaService.Web.ClientModels.v2.NonceDashboard.Transactions.TransactionReceiptView.LocalCreatedAt */
  local_created_at_humanized?: string | null;
  /** IANA time zone name for the local time zone of the atm */
  local_time_zone?: string | null;
  /** @format int32 */
  operator_id?: number;
  /** Operator Legal Information */
  operator_legal_information?: OperatorLegalInformationView;
  operator_name?: string | null;
  /**
   * An eight-ish character hash of the uuid that is friendlier for limited
   * character use-cases, like urls in sms. (https://github.com/skorokithakis/shortuuid)
   */
  short_uuid?: string | null;
  status?: string | null;
  /** URL to blockchain explorer, such as Blocksteam, for the Transaction Hash of the sale. */
  transaction_hash_url?: string | null;
  tx_hash?: string | null;
}

export interface TransactionReceiptViewIActionDataResponse {
  correlation_id?: string | null;
  /**
   * This is the V2 Version of:
   * AthenaService.Web.ClientModels.v1.MyAccountDashboard.Sales.SalesReceiptView
   */
  data?: TransactionReceiptView;
}

/**
 * A transaction's redemption: the obligation (what is owed to the customer after a dispense
 * failure) and every settlement attempt against it.
 */
export interface TransactionRedemptionView {
  /** What is owed to a customer after a dispense failure. */
  obligation?: RedemptionObligationView;
  /**
   * Set when this transaction is a claim sale (it redeemed a settlement) and the obligation
   * belongs to another sale: that sale's id.
   * @format int32
   */
  origin_sale_id?: number | null;
  /** The uuid of the sale in AthenaService.Web.ClientModels.v2.NonceDashboard.Transactions.TransactionRedemptionView.OriginSaleId, for linking to it. */
  origin_sale_uuid?: string | null;
  /** All settlements for the obligation, newest first. Empty when there is no obligation. */
  settlements?: RedemptionSettlementView[] | null;
}

export interface TransactionRedemptionViewIActionDataResponse {
  correlation_id?: string | null;
  /**
   * A transaction's redemption: the obligation (what is owed to the customer after a dispense
   * failure) and every settlement attempt against it.
   */
  data?: TransactionRedemptionView;
}

/** Use this class to represent a summary stats of the transactions list. */
export interface TransactionStatsView {
  /** Asset: Stats by Asset. */
  assets?: AssetStatsView[] | null;
  /** Coins: Stats by Coin. */
  coins?: CoinStatsView[] | null;
  /**
   * Total Fees: Aggregate FIAT amount in Fees for all the matching transactions.
   * @format double
   */
  total_fees?: number;
  /**
   * Total Sales: Aggregate FIAT amount for all the matching transactions.
   * @format double
   */
  total_sales?: number;
  /**
   * Total Transactions: Count of all matching transactions.
   * @format int32
   */
  total_transactions?: number;
}

export interface TransactionStatsViewIActionDataResponse {
  correlation_id?: string | null;
  /** Use this class to represent a summary stats of the transactions list. */
  data?: TransactionStatsView;
}

export enum TransactionTypeEnum {
  Send = 'send',
  Deposit = 'deposit',
}

export interface TransactionView {
  /**
   * Amount of cash involved in the transaction
   * @format double
   */
  cash_amount?: number;
  /**
   * Id of the transaction
   * @format int32
   */
  id?: number | null;
  /** Serial number of the terminal */
  serial_number?: string | null;
  /**
   * Creation date and time in UTC
   * @format date-time
   */
  server_time?: string;
  /**
   * Id of the terminal
   * @format int32
   */
  terminal_id?: number | null;
  /**
   * Creation date and time in the terminal's timezone
   * @format date-time
   */
  terminal_time?: string;
}

export interface TransactionViewFilter {
  operands?: TransactionViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface TransactionViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: TransactionView[] | null;
  meta?: TransactionViewPaginatableResponseMetadata;
}

export interface TransactionViewPaginatableRequest {
  filter?: TransactionViewFilter;
  pagination?: TransactionViewPagination;
  search_text?: string | null;
}

export interface TransactionViewPaginatableResponseMetadata {
  filter?: TransactionViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface TransactionViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface UpdateEnrollmentPolicyRequest {
  is_satisfied?: boolean;
  /** @minLength 1 */
  policy_type: string;
}

export interface UpdateUserRoleRequest {
  /**
   * @format int32
   * @min 0
   * @exclusiveMin true
   */
  role_id?: number;
}

export interface UpdateUserRoleResponse {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  role_id?: number;
}

export interface UpdateUserRoleResponseIActionDataResponse {
  correlation_id?: string | null;
  data?: UpdateUserRoleResponse;
}

export interface UserContactView {
  email?: string | null;
  /** @format int32 */
  id?: number;
  phone?: string | null;
}

export interface UserContactViewListIActionDataResponse {
  correlation_id?: string | null;
  data?: UserContactView[] | null;
}

export interface UserView {
  account_locked?: boolean;
  affiliate_id?: string | null;
  country_code?: string | null;
  /** @format date-time */
  created_at?: string;
  email?: string | null;
  first_name?: string | null;
  /** @format int32 */
  id?: number;
  /** @format date-time */
  last_login_utc?: string | null;
  last_name?: string | null;
  /** @format int32 */
  operator_id?: number | null;
  phone?: string | null;
  role_ids?: number[] | null;
  roles?: RoleView[] | null;
  security_policy_locked?: boolean;
  /** @format date-time */
  updated_at?: string;
}

export interface UserViewFilter {
  operands?: UserViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface UserViewIActionDataResponse {
  correlation_id?: string | null;
  data?: UserView;
}

export interface UserViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: UserView[] | null;
  meta?: UserViewPaginatableResponseMetadata;
}

export interface UserViewPaginatableRequest {
  filter?: UserViewFilter;
  pagination?: UserViewPagination;
  search_text?: string | null;
}

export interface UserViewPaginatableResponseMetadata {
  filter?: UserViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface UserViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface UsersCreateParams {
  /** @format int32 */
  roleId?: number;
}

export interface UsersNonceCreateParams {
  /**
   * Optional role the returned users must hold
   * @format int32
   */
  roleId?: number;
}

export interface WalletAddressesListParams {
  /** How many addresses to generate. Missing, non-numeric or above 25 generates 25; 0 or less generates none. */
  limit?: string;
}

export interface WalletInfoView {
  /** @format double */
  balance?: number;
  /** @format double */
  immature_balance?: number | null;
  /** @format int64 */
  keypoololdest?: number | null;
  /** @format int32 */
  keypoolsize?: number | null;
  /** @format int32 */
  keypoolsize_hd_internal?: number | null;
  /** @format double */
  paytxfee?: number | null;
  /** @format int32 */
  txcount?: number | null;
  /** @format double */
  unconfirmed_balance?: number | null;
  walletname?: string | null;
  /** @format int32 */
  walletversion?: number | null;
}

export interface WalletInfoViewIActionDataResponse {
  correlation_id?: string | null;
  data?: WalletInfoView;
}

export enum WalletStatusEnum {
  Healthy = 'healthy',
  LowBalance = 'low_balance',
  Unhealthy = 'unhealthy',
}

export interface WalletTransactionView {
  /** @format double */
  amount?: number;
  coin?: CoinView;
  coin_id?: string | null;
  /** @format date-time */
  created_at?: string;
  /** @format double */
  fee?: number;
  fee_coin?: CoinView;
  fee_coin_id?: string | null;
  id?: string | null;
  provider_transaction_id?: string | null;
  sale_ids?: number[] | null;
  status?: string | null;
  tx_hash?: string | null;
  type?: TransactionTypeEnum;
  wallet?: WalletView;
  wallet_id?: string | null;
}

export interface WalletTransactionViewExportFilter {
  operands?: WalletTransactionViewExportFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface WalletTransactionViewExportFilterableRequest {
  filter?: WalletTransactionViewExportFilter;
  search_text?: string | null;
}

export interface WalletTransactionViewFilter {
  operands?: WalletTransactionViewFilter[] | null;
  operator?: FilterOperator;
  property?: string | null;
  value?: any;
}

export interface WalletTransactionViewIPaginatableActionResponse {
  correlation_id?: string | null;
  data?: WalletTransactionView[] | null;
  meta?: WalletTransactionViewPaginatableResponseMetadata;
}

export interface WalletTransactionViewPaginatableRequest {
  filter?: WalletTransactionViewFilter;
  pagination?: WalletTransactionViewPagination;
  search_text?: string | null;
}

export interface WalletTransactionViewPaginatableResponseMetadata {
  filter?: WalletTransactionViewFilter;
  filter_operators?: FilterOperator[] | null;
  pagination?: PaginationMetadata;
  search_text?: string | null;
}

export interface WalletTransactionViewPagination {
  /** @format int32 */
  current_page?: number;
  /** @format int32 */
  items_per_page?: number;
  sort_ascending?: boolean | null;
  sort_by?: string | null;
}

export interface WalletTransactionsListParams {
  items_per_page?: string;
  page?: string;
}

export interface WalletView {
  id?: string | null;
  /** @format double */
  last_balance?: number | null;
  /** @format date-time */
  last_balance_updated_at?: string | null;
  name?: string | null;
  provider_wallet_id?: string | null;
  status?: WalletStatusEnum;
  wallet_passphrase?: string | null;
}
